import {
  PROPERTY_LOAN_PROCESSING_FEE_LABEL,
  propertyLoanProcessingFeeTerms,
  propertyLoanProcessingFee,
} from "../../utils/propertyLoanProcessingFee";
import { repaymentStatusLabel } from "../../utils/repaymentStatus";
import { propertyLoanMonths } from "../../utils/propertyLoanProducts";
import { getPersonData } from "../../utils/myinfoData";
import { Box, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import React, { useState, useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { matchesLoanCardName } from "../../utils/loanCardSearch";
import CountdownWithHover from "../../components/CountDownWithHover";
import { Progress } from "antd";
import Cookies from "js-cookie";
import { Button, Modal, message, Input, InputNumber, Select, Tooltip } from "antd";
import {
  UnorderedListOutlined,
  AppstoreOutlined,
  PlusOutlined,
  MinusOutlined,
  QuestionCircleOutlined,
  LockOutlined,
  MailOutlined,
} from "@ant-design/icons";
import grid_normal from "../../assets/img/Grid_normal.png";
import grid_selected from "../../assets/img/grid_selected.png";
import list_normal from "../../assets/img/List_normal.png";
import list_selected from "../../assets/img/List_selected.png";
import Filter from "../../assets/img/Filter.png";
import StarIcon from "@mui/icons-material/Star";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { format } from "date-fns";
import defaultIcon from "../../assets/img/Profile.png";
import { toFloat } from "validator";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFDownloadLink,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import logo from "../../assets/img/SL-01.png";
import boldFont from "../../assets/font/Poppins-SemiBold.ttf";
import Tour from "reactour";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ProfileViewer from "../../pages/borrower-dashboard/ProfileViewer";
import SupportCancelOfferButton from "../../components/SupportCancelOfferButton";
import SupportMarkOfferOngoingButton from "../../components/SupportMarkOfferOngoingButton";
import usePropertyApplicationCommentRefresh from "../../hooks/usePropertyApplicationCommentRefresh";
import { parseCbsReportFromPdf } from "../../utils/parseCbsReportFromPdf";
import { isTruthyFlag, shouldHideProfileContactInfo, getLoanProfileTabs, SCCB_EXCLUDE_COLUMNS } from "../../utils/loanProfile";
import { CircularProgress } from "@mui/material";
import "./support-crm-warning.css";
import "./lender-rejection.css";

Font.register({
  family: "Poppins",
  fonts: [
    { src: boldFont, fontWeight: 700 }, // Bold (700)
  ],
});

const isNoContactLoan = (loan) =>
  isTruthyFlag(loan?.concierge) ||
  isTruthyFlag(loan?.blanko_contact) ||
  isTruthyFlag(loan?.applied_for_concierge);

const isSlCreatedLoan = (loan) =>
  isTruthyFlag(loan?.sl_created) ||
  isTruthyFlag(loan?.borrower?.sl_created) ||
  isTruthyFlag(loan?.borrower_summary?.sl_created) ||
  isTruthyFlag(loan?.borrower_data?.sl_created) ||
  isTruthyFlag(loan?.user?.sl_created);

const parseLoanRemark = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const isSmtvCrmLoan = (loan) => {
  const meta = parseLoanRemark(loan?.meta);
  return (
    isTruthyFlag(loan?.created_by_smtv_crm) ||
    meta?.application_source === "smtv_crm" ||
    meta?.created_by === "smtv_crm"
  );
};

const isWithdrawnLoan = (loan, loanType) => {
  if (loanType === "corporate") return isTruthyFlag(loan?.make_hidden);
  if (loanType === "personal") {
    return [false, 0, "0", "false"].includes(loan?.allow_lender_visibility);
  }
  return loan?.marketplace_status === "withdrawn";
};

const SupportLoanStatusPills = ({ loan, loanType }) => {
  const withdrawn = isWithdrawnLoan(loan, loanType);
  const crmCase = isSmtvCrmLoan(loan);
  if (!withdrawn && !crmCase) return null;

  return (
    <div className="sl-support-status-pills">
      {withdrawn ? <span className="sl-support-withdrawn-pill">Withdrawn</span> : null}
      {crmCase ? <span className="sl-support-crm-pill">CRM Case</span> : null}
    </div>
  );
};

const PERSONAL_LOAN_PROCESSING_FEE_RATE = 0.1;
const PERSONAL_LOAN_PROCESSING_FEE_LABEL = "10%";
const MONEY_LENDER_INTEREST_RATE_PM = 3.92;
const MONEY_LENDER_RATE_TOOLTIP =
  "Rate is fixed to match the borrower's request. Every lender bids at the same rate, so competition stays fair. We don't pit lenders against each other on price — you win on speed, service, and tenor instead.";
const MONEY_LENDER_PROCESSING_FEE_TOOLTIP =
  "Processing fee is fixed and applied equally to all lenders. No fee undercutting here — competition stays transparent and fair. Stand out on service and terms, not price.";

const LoanRequestGrid = ({
  item,
  mode = "lender",
  showLenderActions = true,
  onOpenBorrowerProfile,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isSupportMode = mode === "support";
  const location = useLocation();
  const pageSearch = isSupportMode
    ? ""
    : new URLSearchParams(location.search).get("search") || "";
  const getSupportLoanCardClass = (loan, loanType) => {
    if (!isSupportMode) return "";
    return [
      isSmtvCrmLoan(loan) ? "sl-support-crm-warning" : "",
      isWithdrawnLoan(loan, loanType) ? "sl-support-withdrawn-warning" : "",
    ].filter(Boolean).join(" ");
  };
  const shouldShowLenderActions = !isSupportMode && showLenderActions;
  const authToken = isSupportMode
    ? Cookies.get("support_token")
    : Cookies.get("token");
  const corporateLoanEndpoint = isSupportMode
    ? "https://www.smart-lend.com/api/support/loans/corporate"
    : "https://www.smart-lend.com/api/loan/viewLoanRequest";
  const personalLoanEndpoint = isSupportMode
    ? "https://www.smart-lend.com/api/support/loans/personal"
    : "https://www.smart-lend.com/api/personalLoans/marketplace";
  const propertyLoanEndpoint = isSupportMode
    ? "https://www.smart-lend.com/api/support/loans/property"
    : "https://www.smart-lend.com/api/propTermLoan/getAllPropLoans";
  const [sortBy, setSortBy] = useState("latest-request");
  const [activeLoanTypeFilter, setActiveLoanTypeFilter] = useState("all");
  const [loanPeriod, setLoanPeriod] = useState(0);
  const [type, setLoanType] = useState("simple");
  const [offer_interest_rate, setInterestRate] = useState(0);
  const [offer_processing_fee, setProcessingFee] = useState(0);
  const [total_admin_fee, setTotalAdminFee] = useState(0);
  const [admin_fee, setAdminFee] = useState(0);
  const [offer_period, setSelectedLoanPeriod] = useState(0);
  const [offer_principal, setLoanPrincipal] = useState(0);
  const [offer_monthly_installment, setExpectedMonthlyInstallment] =
    useState(0);
  const [offer_revenue, setGuaranteedRevenue] = useState(0);
  const history = useHistory();
  const [minLoanAmount, setMinLoanAmount] = useState("");
  const [maxLoanAmount, setMaxLoanAmount] = useState("");
  const [creditScoreMin, setCreditScoreMin] = useState("");
  const [creditScoreMax, setCreditScoreMax] = useState("");
  const [LoanPeriodMin, setLoanPeriodMin] = useState("");
  const [LoanPeriodMax, setLoanPeriodMax] = useState("");
  const [MinYearOfIncorp, setMinYearOfIncorp] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedCreditRating, setSelectedCreditRating] = useState("");
  const [LoanInterestMin, setLoanInterestMin] = useState("");
  const [LoanInterestMax, setLoanInterestMax] = useState("");
  const [loanPeriodFilter, setLoanPeriodFilter] = useState("");
  const [loanCategoryFilters, setLoanCategoryFilters] = useState([]);
  const [filterClicked, setFilterClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [offer_amount, setLoanAmount] = useState(0);
  const [selectedLoanId, setSelectedLoanId] = useState(null);
  const [loanDetails, setLoanDetails] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [filteredDataStatus, setFilteredDataStatus] = useState(null);
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);
  const [selectedCheckbox1, setSelectedCheckbox1] = useState(null);
  const [selectedCheckbox2, setSelectedCheckbox2] = useState(null);
  const [empty, setempty] = useState("0");
  const [currentID, setcurrentID] = useState(null);
  const [data, setData] = useState([]);
  const [personalLoans, setPersonalLoans] = useState([]);
  const [propertyLoans, setPropertyLoans] = useState([]);
  const [countLoanOffer, setCountLoanOffer] = useState([]);
  const [targetDate, setTargetDate] = useState(null);
  const [notInterestedIds, setNotInterestedIds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loanId, setLoanId] = useState(null);
  const [express, setExpress] = useState(null);
  const [user_id, setUserId] = useState(null);
  const [principal_name, setPrincipalName] = useState(null);
  const [add_document_description, setAddDocumentDescription] = useState(null);
  const [documentDescriptions, setDocumentDescriptions] = useState([""]);
  const [screenWidth, setScreenWidth] = useState(() => window.innerWidth);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [makeOfferData, setMakeOfferData] = useState(null);
  const [loanRepaymentTenor, setLoanRepaymentTenor] = useState("");
  const [supportLenders, setSupportLenders] = useState([]);
  const [supportLendersLoading, setSupportLendersLoading] = useState(false);
  const [selectedSupportLenderId, setSelectedSupportLenderId] = useState("");
  const [personalOfferModal, setPersonalOfferModal] = useState({
    open: false,
    loan: null,
  });
  const [personalOfferForm, setPersonalOfferForm] = useState({
    amount: "",
    rate_pa: MONEY_LENDER_INTEREST_RATE_PM,
    tenor_months: "",
  });
  const [personalOfferBusy, setPersonalOfferBusy] = useState(false);
  const [personalOfferMessage, setPersonalOfferMessage] = useState("");
  const [personalOfferDocuments, setPersonalOfferDocuments] = useState([""]);
  const [personalRejectionModal, setPersonalRejectionModal] = useState({
    open: false,
    loan: null,
  });
  const [personalRejectionOptions, setPersonalRejectionOptions] = useState([]);
  const [personalRejectionForm, setPersonalRejectionForm] = useState({
    reason: undefined,
    notes: "",
  });
  const [personalRejectionBusy, setPersonalRejectionBusy] = useState(false);
  const [personalDownloadId, setPersonalDownloadId] = useState(null);
  const [propertyOfferModal, setPropertyOfferModal] = useState({
    open: false,
    loan: null,
  });
  const [propertyOfferForm, setPropertyOfferForm] = useState({
    amount: "",
    rate_pa: "",
    tenor_years: "",
  });
  const [propertyOfferBusy, setPropertyOfferBusy] = useState(false);
  const [propertyOfferMessage, setPropertyOfferMessage] = useState("");
  const [propertyOfferDocuments, setPropertyOfferDocuments] = useState([""]);
  const [propertyRejectionModal, setPropertyRejectionModal] = useState({
    open: false,
    loan: null,
  });
  const [propertyRejectionOptions, setPropertyRejectionOptions] = useState([]);
  const [propertyRejectionForm, setPropertyRejectionForm] = useState({
    reason: undefined,
    notes: "",
  });
  const [propertyRejectionBusy, setPropertyRejectionBusy] = useState(false);
  const [propertyDownloadId, setPropertyDownloadId] = useState(null);
  const [manageDocumentModal, setManageDocumentModal] = useState({
    open: false,
    loanType: null,
    loan: null,
  });
  const [manageDocumentList, setManageDocumentList] = useState([]);
  const [manageDocumentTypeOptions, setManageDocumentTypeOptions] = useState([]);
  const [manageDocumentType, setManageDocumentType] = useState("");
  const [manageDocumentGroupKey, setManageDocumentGroupKey] = useState("");
  const [manageDocumentGroupLabel, setManageDocumentGroupLabel] = useState("");
  const [manageDocumentFile, setManageDocumentFile] = useState(null);
  const [manageDocumentLoading, setManageDocumentLoading] = useState(false);
  const [manageDocumentUploading, setManageDocumentUploading] = useState(false);
  const [manageDocumentDeletingId, setManageDocumentDeletingId] = useState(null);
  const [lenderActivityModal, setLenderActivityModal] = useState({
    open: false,
    loanType: null,
    loan: null,
  });
  const [lenderActivityData, setLenderActivityData] = useState(null);
  const [lenderActivityLoading, setLenderActivityLoading] = useState(false);
  const [selectedCommunicationOffer, setSelectedCommunicationOffer] =
    useState(null);
  const [supportAcceptModal, setSupportAcceptModal] = useState({
    open: false,
    offer: null,
  });
  const [supportAcceptForm, setSupportAcceptForm] = useState({});
  const [supportAcceptBusy, setSupportAcceptBusy] = useState(false);
  const [supportEditModal, setSupportEditModal] = useState({
    open: false,
    offer: null,
  });
  const [supportEditForm, setSupportEditForm] = useState({});
  const [supportEditBusy, setSupportEditBusy] = useState(false);
  const [supportDisbursementModal, setSupportDisbursementModal] = useState({
    open: false,
    offer: null,
  });
  const [supportDisbursementForm, setSupportDisbursementForm] = useState({});
  const [supportDisbursementBusy, setSupportDisbursementBusy] = useState(false);
  const [bankAnalysisContext, setBankAnalysisContext] = useState({
    loanId: null,
    loanType: null,
    enabled: false,
  });
  const [mlcbAnalysisContext, setMlcbAnalysisContext] = useState({
    loanId: null,
    enabled: false,
  });
  const [loanGuarantorFilter, setLoanGuarantorFilter] = useState("single");
  const [loanPrivatePropertyFilter, setLoanPrivatePropertyFilter] =
    useState("yes");
  const [loanDsrFilter, setLoanDsrFilter] = useState(25);
  const [loanAembFilter, setLoanAembFilter] = useState(50000);
  const [loanBtiFilter, setLoanBtiFilter] = useState(2);

  const getUserDetails = async () => {
    if (isSupportMode) {
      setUserDetails({
        user_id: Cookies.get("support_employee_id") || "support",
        lender_allowed_products: ["corporate", "personal", "property"],
      });
      return;
    }

    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/getUserDetails",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        const json = await response.json();
        setUserDetails(json.User);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const increaseKeenCount = async (loan_id) => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loanStats/increaseKeenCount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ loan_id: loan_id }),
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  const [interestRequests, setInterestRequests] = useState({});
  const [expressedInterests, setExpressedInterests] = useState({});

  const logExpressInterest = async (loan_id, loan_type) => {
    const key = `${loan_type}:${loan_id}`;
    if (interestRequests[key] || expressedInterests[key]) return;
    setInterestRequests((previous) => ({ ...previous, [key]: true }));
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loanStats/logExpressInterest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ loan_id, loan_type }),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Unable to express interest. Please try again.");
      }
      setExpressedInterests((previous) => ({ ...previous, [key]: true }));
      message.success("Your interest in this loan has been noted.");
      if (loan_type === "personal") {
        fetchPersonalLoans();
      } else {
        fetchDataWithRunFilter();
      }
    } catch (error) {
      message.error(error.message || "Unable to express interest. Please try again.");
    } finally {
      setInterestRequests((previous) => ({ ...previous, [key]: false }));
    }
  };

  const renderConciergeInterest = (loanType, loan, expired) => {
    if (!shouldShowLenderActions || !isNoContactLoan(loan) || isTruthyFlag(loan?.rejected_by_me)) return null;
    const loanId = loanType === "personal" ? loan.id : loan.loan_id;
    const key = `${loanType}:${loanId}`;
    const hasExpressedInterest =
      isTruthyFlag(loan.has_expressed_interest) || expressedInterests[key];

    if (hasExpressedInterest) {
      return (
        <div role="status" style={{ marginTop: 10, padding: "10px 12px", borderRadius: 12, background: "#ecfdf5", color: "#047857", fontSize: 12, fontWeight: 700 }}>
          Interest expressed. SmartLend will be in touch.
        </div>
      );
    }
    if (expired) return null;

    return (
      <button
        type="button"
        className="all_button"
        disabled={Boolean(interestRequests[key])}
        style={{ background: "linear-gradient(90deg, #206be3 0%, #d413c7 100%)", width: "100%", borderRadius: 50, padding: "7px 0px", marginTop: 10, fontSize: 12, color: "white", border: "none" }}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          logExpressInterest(loanId, loanType);
        }}
      >
        {interestRequests[key] ? "Submitting…" : "Express Interest"}
      </button>
    );
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    if (!isSupportMode && !Cookies.get("tourDoneLender")) {
      setIsTourOpen(true);
      Cookies.set("tourDoneLender", true);
    }
  }, [isSupportMode]);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 1200
  );
  useEffect(() => {
    if (screenWidth <= 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  const getInitials = (name) => {
    const textToSplit = name.split(" ");
    const initials =
      textToSplit?.[0]?.[0].toUpperCase() +
      (textToSplit?.[1]?.[0].toUpperCase() || "");
    return initials;
  };

  const possiblecreditrating = [
    { value: "AA" },
    { value: "BB" },
    { value: "CC" },
    { value: "DD" },
    { value: "EE" },
    { value: "FF" },
    { value: "GG" },
    { value: "HH" },
    { value: "CX" },
    { value: "Others" },
  ];
  const SsicCodes = [
    {
      name: "AGRICULTURE AND FISHING",
      value: [
        "01",
        "011",
        "0111",
        "01111",
        "01112",
        "01113",
        "01119",
        "0112",
        "01120",
        "0113",
        "01130",
        "0114",
        "01141",
        "01142",
        "01149",
        "0119",
        "01190",
        "014",
        "0141",
        "01411",
        "01412",
        "01413",
        "0142",
        "01421",
        "01422",
        "01423",
        "01424",
        "0149",
        "01491",
        "01492",
        "01493",
        "01494",
        "01499",
        "015",
        "0150",
        "01500",
        "016",
        "0160",
        "01600",
        "02",
        "020",
        "0200",
        "02000",
        "03",
        "031",
        "0310",
        "03101",
        "03102",
        "03103",
        "03109",
        "032",
        "0320",
        "03201",
        "03202",
        "03209",
      ],
    },
    {
      name: "MINING AND QUARRYING",
      value: [
        "08",
        "081",
        "0810",
        "08101",
        "08102",
        "089",
        "0890",
        "08900",
        "09",
        "090",
        "0900",
        "09001",
        "09002",
      ],
    },
    {
      name: "MANUFACTURING",
      value: [
        "10",
        "101",
        "1010",
        "10101",
        "10102",
        "10103",
        "10104",
        "10109",
        "102",
        "1020",
        "10200",
        "103",
        "1030",
        "10301",
        "10302",
        "10303",
        "104",
        "1040",
        "10401",
        "10402",
        "10409",
        "105",
        "1050",
        "10501",
        "10502",
        "10503",
        "10509",
        "106",
        "1061",
        "10611",
        "10612",
        "10613",
        "10619",
        "1062",
        "10620",
        "107",
        "1071",
        "10711",
        "10712",
        "10719",
        "1072",
        "10720",
        "1073",
        "10731",
        "10732",
        "10733",
        "1074",
        "10740",
        "1075",
        "10750",
        "1076",
        "10761",
        "10762",
        "10763",
        "10764",
        "10765",
        "1079",
        "10791",
        "10792",
        "10793",
        "10794",
        "10799",
        "108",
        "1080",
        "10800",
        "11",
        "110",
        "1101",
        "11010",
        "1102",
        "11020",
        "1103",
        "11030",
        "1104",
        "11041",
        "11042",
        "11043",
        "12",
        "120",
        "1200",
        "12001",
        "12009",
        "13",
        "131",
        "1310",
        "13100",
        "139",
        "1391",
        "13910",
        "1392",
        "13921",
        "13922",
        "13929",
        "1393",
        "13930",
        "1394",
        "13940",
        "1399",
        "13990",
        "14",
        "141",
        "1410",
        "14101",
        "14102",
        "14103",
        "14109",
        "142",
        "1420",
        "14200",
        "143",
        "1430",
        "14301",
        "14302",
        "14309",
        "15",
        "151",
        "1511",
        "15110",
        "1512",
        "15121",
        "15122",
        "15129",
        "152",
        "1520",
        "15200",
        "16",
        "161",
        "1610",
        "16101",
        "16102",
        "16109",
        "162",
        "1621",
        "16211",
        "16219",
        "1629",
        "16291",
        "16292",
        "16293",
        "16294",
        "16295",
        "16299",
        "17",
        "170",
        "1701",
        "17010",
        "1702",
        "17021",
        "17022",
        "1709",
        "17091",
        "17092",
        "17093",
        "17094",
        "17099",
        "18",
        "181",
        "1811",
        "18111",
        "18112",
        "18113",
        "18114",
        "18115",
        "18119",
        "1812",
        "18121",
        "18122",
        "18129",
        "182",
        "1820",
        "18200",
        "19",
        "191",
        "1910",
        "19100",
        "192",
        "1920",
        "19201",
        "19202",
        "19209",
        "20",
        "201",
        "2011",
        "20111",
        "20112",
        "20113",
        "20114",
        "20119",
        "2012",
        "20120",
        "2013",
        "20131",
        "20132",
        "20133",
        "202",
        "2021",
        "20210",
        "2022",
        "20221",
        "20222",
        "20229",
        "2023",
        "20231",
        "20232",
        "20233",
        "20234",
        "2024",
        "20241",
        "20242",
        "20249",
        "2029",
        "20291",
        "20292",
        "20293",
        "20294",
        "20295",
        "20296",
        "20297",
        "20298",
        "20299",
        "203",
        "2030",
        "20300",
        "21",
        "210",
        "2101",
        "21011",
        "21012",
        "21013",
        "2102",
        "21021",
        "21022",
        "21023",
        "2103",
        "21030",
        "22",
        "221",
        "2211",
        "22111",
        "22112",
        "22119",
        "2212",
        "22121",
        "22122",
        "2219",
        "22191",
        "22192",
        "22193",
        "22194",
        "22199",
        "222",
        "2221",
        "22211",
        "22212",
        "22213",
        "22214",
        "22215",
        "22216",
        "22217",
        "22218",
        "22219",
        "2222",
        "22220",
        "23",
        "231",
        "2310",
        "23100",
        "239",
        "2391",
        "23911",
        "23912",
        "23919",
        "2393",
        "23931",
        "23939",
        "2394",
        "23940",
        "2395",
        "23951",
        "23959",
        "2396",
        "23960",
        "2399",
        "23991",
        "23992",
        "23993",
        "23994",
        "23995",
        "23999",
        "24",
        "241",
        "2410",
        "24101",
        "24102",
        "24109",
        "242",
        "2420",
        "24201",
        "24202",
        "24209",
        "243",
        "2431",
        "24310",
        "2432",
        "24320",
        "25",
        "251",
        "2511",
        "25111",
        "25112",
        "25113",
        "25114",
        "25119",
        "2512",
        "25120",
        "2513",
        "25131",
        "25139",
        "252",
        "2520",
        "25200",
        "259",
        "2591",
        "25911",
        "25912",
        "25913",
        "25914",
        "25919",
        "2592",
        "25921",
        "25922",
        "25923",
        "25924",
        "25929",
        "2593",
        "25931",
        "25932",
        "25939",
        "2594",
        "25941",
        "25949",
        "2595",
        "25951",
        "25952",
        "25959",
        "2599",
        "25991",
        "25992",
        "25993",
        "25994",
        "25995",
        "25996",
        "25997",
        "25998",
        "25999",
        "26",
        "261",
        "2611",
        "26111",
        "26112",
        "26113",
        "26114",
        "26115",
        "26119",
        "2612",
        "26121",
        "26122",
        "26123",
        "26124",
        "26125",
        "26126",
        "26129",
        "262",
        "2620",
        "26201",
        "26202",
        "26203",
        "26204",
        "26209",
        "263",
        "2630",
        "26301",
        "26302",
        "26303",
        "26304",
        "26309",
        "264",
        "2640",
        "26400",
        "265",
        "2651",
        "26511",
        "26512",
        "26513",
        "2652",
        "26521",
        "26522",
        "26523",
        "26524",
        "266",
        "2660",
        "26601",
        "26602",
        "267",
        "2670",
        "26701",
        "26709",
        "268",
        "2680",
        "26801",
        "26802",
        "27",
        "271",
        "2710",
        "27101",
        "27102",
        "27103",
        "27104",
        "27109",
        "272",
        "2720",
        "27201",
        "27202",
        "273",
        "2732",
        "27321",
        "27322",
        "27323",
        "27324",
        "27329",
        "2733",
        "27330",
        "274",
        "2740",
        "27400",
        "275",
        "2750",
        "27501",
        "27509",
        "279",
        "2790",
        "27901",
        "27902",
        "28",
        "281",
        "2811",
        "28111",
        "28112",
        "2812",
        "28121",
        "28122",
        "28129",
        "2814",
        "28141",
        "28142",
        "2815",
        "28150",
        "2816",
        "28161",
        "28162",
        "28169",
        "2817",
        "28171",
        "28172",
        "2818",
        "28181",
        "28182",
        "28189",
        "2819",
        "28191",
        "28192",
        "28193",
        "28194",
        "28195",
        "28199",
        "282",
        "2821",
        "28210",
        "2822",
        "28221",
        "28222",
        "28223",
        "28224",
        "28225",
        "28229",
        "2824",
        "28241",
        "28242",
        "28243",
        "28249",
        "2825",
        "28251",
        "28252",
        "28253",
        "2826",
        "28260",
        "2827",
        "28271",
        "28272",
        "28273",
        "28274",
        "2829",
        "28291",
        "28292",
        "28293",
        "28294",
        "28299",
        "283",
        "2830",
        "28300",
        "29",
        "291",
        "2910",
        "29100",
        "292",
        "2920",
        "29200",
        "293",
        "2930",
        "29300",
        "30",
        "301",
        "3011",
        "30110",
        "3012",
        "30120",
        "302",
        "3020",
        "30200",
        "303",
        "3030",
        "30301",
        "30302",
        "304",
        "3040",
        "30400",
        "309",
        "3091",
        "30910",
        "3092",
        "30920",
        "3099",
        "30990",
        "31",
        "310",
        "3100",
        "31001",
        "31002",
        "31003",
        "31004",
        "31005",
        "31006",
        "31009",
        "32",
        "321",
        "3211",
        "32111",
        "32112",
        "32119",
        "3212",
        "32120",
        "322",
        "3220",
        "32200",
        "323",
        "3230",
        "32300",
        "324",
        "3240",
        "32400",
        "325",
        "3250",
        "32501",
        "32502",
        "32503",
        "32504",
        "32509",
        "329",
        "3290",
        "32901",
        "32909",
      ],
    },
    {
      name: "ELECTRICITY, GAS, STEAM AND AIR-CONDITIONING SUPPLY",
      value: [
        "35",
        "351",
        "3510",
        "35101",
        "35102",
        "35103",
        "35104",
        "352",
        "3520",
        "35201",
        "35202",
        "35203",
        "353",
        "3530",
        "35300",
      ],
    },
    {
      name: "WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES",
      value: [
        "36",
        "360",
        "3600",
        "36000",
        "37",
        "370",
        "3700",
        "37000",
        "38",
        "381",
        "3810",
        "38100",
        "382",
        "3820",
        "38200",
        "383",
        "3830",
        "38301",
        "38309",
      ],
    },
    {
      name: "CONSTRUCTION",
      value: [
        "41",
        "410",
        "4100",
        "41001",
        "41002",
        "41009",
        "42",
        "421",
        "4210",
        "42101",
        "42102",
        "42103",
        "422",
        "4220",
        "42201",
        "42202",
        "429",
        "4290",
        "42901",
        "42902",
        "42903",
        "42909",
        "43",
        "431",
        "4311",
        "43110",
        "4312",
        "43121",
        "43122",
        "43129",
        "432",
        "4321",
        "43210",
        "4322",
        "43220",
        "4329",
        "43291",
        "43292",
        "43293",
        "43294",
        "43295",
        "43296",
        "43299",
        "433",
        "4330",
        "43301",
        "43302",
        "43303",
        "43304",
        "43305",
        "43306",
        "43307",
        "43309",
        "439",
        "4390",
        "43901",
        "43902",
        "43903",
        "43904",
        "43905",
        "43906",
        "43907",
        "43909",
      ],
    },
    {
      name: "WHOLESALE AND RETAIL TRADE",
      value: [
        "46",
        "461",
        "4610",
        "46100",
        "462",
        "4621",
        "46211",
        "46212",
        "46213",
        "46219",
        "4622",
        "46221",
        "46222",
        "46223",
        "46224",
        "46225",
        "46229",
        "463",
        "4630",
        "46301",
        "46302",
        "46303",
        "46304",
        "46305",
        "46306",
        "46307",
        "46308",
        "46309",
        "464",
        "4641",
        "46411",
        "46412",
        "46413",
        "46414",
        "46415",
        "46416",
        "4642",
        "46421",
        "46422",
        "46423",
        "46424",
        "46429",
        "4643",
        "46431",
        "46432",
        "46433",
        "46434",
        "46435",
        "46436",
        "46437",
        "46439",
        "4644",
        "46441",
        "46442",
        "46443",
        "46444",
        "46449",
        "4645",
        "46451",
        "46452",
        "46453",
        "46459",
        "4646",
        "46461",
        "46462",
        "4647",
        "46471",
        "46472",
        "46473",
        "46474",
        "46479",
        "4649",
        "46491",
        "46492",
        "46499",
        "465",
        "4651",
        "46511",
        "46512",
        "46513",
        "46514",
        "4652",
        "46521",
        "46522",
        "46523",
        "4653",
        "46530",
        "4654",
        "46541",
        "46542",
        "46543",
        "46544",
        "46549",
        "4655",
        "46551",
        "46552",
        "46559",
        "4656",
        "46561",
        "46562",
        "46563",
        "4659",
        "46591",
        "46592",
        "46593",
        "46594",
        "46595",
        "46599",
        "466",
        "4661",
        "46610",
        "4662",
        "46620",
        "4663",
        "46631",
        "46632",
        "46633",
        "46634",
        "46635",
        "46639",
        "4664",
        "46641",
        "46642",
        "46643",
        "46649",
        "4665",
        "46651",
        "46659",
        "4666",
        "46661",
        "46662",
        "469",
        "4690",
        "46900",
        "47",
        "471",
        "4710",
        "47101",
        "47102",
        "47103",
        "47109",
        "472",
        "4721",
        "47211",
        "47212",
        "47213",
        "47214",
        "47219",
        "4722",
        "47220",
        "4723",
        "47230",
        "473",
        "4731",
        "47311",
        "47312",
        "47313",
        "47314",
        "4732",
        "47320",
        "474",
        "4741",
        "47411",
        "47412",
        "47413",
        "47414",
        "47415",
        "4742",
        "47420",
        "475",
        "4751",
        "47510",
        "4752",
        "47521",
        "47522",
        "47529",
        "4753",
        "47531",
        "47532",
        "47533",
        "47534",
        "47535",
        "47536",
        "47537",
        "47539",
        "476",
        "4761",
        "47610",
        "4762",
        "47620",
        "4763",
        "47630",
        "4764",
        "47640",
        "477",
        "4771",
        "47711",
        "47712",
        "47713",
        "47714",
        "47715",
        "47719",
        "4772",
        "47721",
        "47722",
        "47723",
        "47729",
        "4773",
        "47731",
        "47732",
        "47733",
        "47739",
        "4774",
        "47741",
        "47742",
        "47743",
        "47744",
        "47745",
        "47746",
        "47749",
        "4775",
        "47751",
        "47752",
        "47759",
        "4776",
        "47761",
        "47762",
        "47769",
        "4777",
        "47770",
        "478",
        "4780",
        "47801",
        "47802",
      ],
    },
    {
      name: "TRANSPORTATION AND STORAGE",
      value: [
        "49",
        "491",
        "4910",
        "49101",
        "49102",
        "492",
        "4921",
        "49211",
        "49212",
        "49213",
        "49214",
        "49215",
        "4922",
        "49220",
        "4923",
        "49231",
        "49232",
        "49233",
        "493",
        "4930",
        "49300",
        "50",
        "500",
        "5001",
        "50011",
        "50012",
        "50013",
        "50014",
        "5002",
        "50021",
        "50022",
        "50023",
        "51",
        "510",
        "5100",
        "51001",
        "51002",
        "51003",
        "51004",
        "51005",
        "52",
        "521",
        "5210",
        "52101",
        "52102",
        "52103",
        "52109",
        "522",
        "5221",
        "52211",
        "52212",
        "52219",
        "5222",
        "52221",
        "52222",
        "52223",
        "52224",
        "52225",
        "52226",
        "52227",
        "52229",
        "5223",
        "52231",
        "52232",
        "52233",
        "52234",
        "52239",
        "5224",
        "52241",
        "52242",
        "52243",
        "5225",
        "52251",
        "52252",
        "5229",
        "52291",
        "52292",
        "53",
        "531",
        "5310",
        "53100",
        "532",
        "5320",
        "53200",
      ],
    },
    {
      name: "ACCOMMODATION AND FOOD SERVICE ACTIVITIES",
      value: [
        "55",
        "551",
        "5510",
        "55101",
        "55102",
        "55103",
        "559",
        "5590",
        "55900",
        "56",
        "561",
        "5611",
        "56111",
        "56112",
        "5612",
        "56121",
        "56122",
        "56123",
        "5613",
        "56130",
        "5614",
        "56140",
        "562",
        "5620",
        "56200",
      ],
    },
    {
      name: "INFORMATION AND COMMUNICATIONS",
      value: [
        "58",
        "581",
        "5811",
        "58110",
        "5812",
        "58120",
        "5813",
        "58131",
        "58132",
        "5819",
        "58190",
        "582",
        "5820",
        "58201",
        "58202",
        "59",
        "591",
        "5911",
        "59111",
        "59112",
        "59113",
        "59114",
        "59119",
        "5912",
        "59120",
        "5913",
        "59131",
        "59132",
        "59139",
        "5914",
        "59140",
        "592",
        "5920",
        "59201",
        "59202",
        "60",
        "601",
        "6010",
        "60100",
        "602",
        "6020",
        "60200",
        "61",
        "610",
        "6101",
        "61011",
        "61012",
        "61013",
        "6109",
        "61091",
        "61092",
        "61099",
        "62",
        "620",
        "6201",
        "62011",
        "62012",
        "62013",
        "6202",
        "62021",
        "62022",
        "62023",
        "6209",
        "62090",
        "63",
        "631",
        "6311",
        "63111",
        "63112",
        "63119",
        "6312",
        "63120",
        "632",
        "6320",
        "63201",
        "63202",
        "63203",
        "63204",
        "63205",
        "63209",
        "639",
        "6390",
        "63901",
        "63909",
      ],
    },
    {
      name: "FINANCIAL AND INSURANCE ACTIVITIES",
      value: [
        "64",
        "641",
        "6411",
        "64110",
        "6412",
        "64120",
        "6413",
        "64130",
        "6414",
        "64140",
        "6415",
        "64150",
        "6419",
        "64190",
        "642",
        "6420",
        "64201",
        "64202",
        "643",
        "6430",
        "64300",
        "649",
        "6491",
        "64910",
        "6492",
        "64921",
        "64922",
        "64923",
        "64924",
        "64925",
        "64929",
        "6499",
        "64991",
        "64992",
        "64993",
        "64994",
        "64999",
        "65",
        "651",
        "6511",
        "65110",
        "6512",
        "65121",
        "65122",
        "65123",
        "65124",
        "652",
        "6520",
        "65201",
        "65202",
        "653",
        "6530",
        "65301",
        "65302",
        "66",
        "661",
        "6611",
        "66110",
        "6612",
        "66121",
        "66122",
        "66123",
        "66124",
        "66125",
        "66126",
        "66129",
        "6619",
        "66191",
        "66192",
        "66193",
        "66194",
        "66195",
        "66199",
        "662",
        "6621",
        "66210",
        "6622",
        "66221",
        "66222",
        "6629",
        "66291",
        "66292",
        "66299",
        "663",
        "6630",
        "66301",
        "66302",
        "66303",
        "66304",
        "66305",
        "66306",
        "66307",
        "66309",
      ],
    },
    {
      name: "REAL ESTATE ACTIVITIES",
      value: [
        "68",
        "681",
        "6810",
        "68101",
        "68102",
        "68103",
        "68104",
        "68105",
        "68106",
        "682",
        "6820",
        "68201",
        "68202",
        "68203",
        "68209",
      ],
    },
    {
      name: "PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES",
      value: [
        "69",
        "691",
        "6910",
        "69101",
        "69102",
        "692",
        "6920",
        "69201",
        "69202",
        "70",
        "701",
        "7010",
        "70101",
        "70102",
        "702",
        "7020",
        "70201",
        "70202",
        "70203",
        "70204",
        "70205",
        "70206",
        "70209",
        "71",
        "711",
        "7111",
        "71111",
        "71112",
        "71113",
        "71114",
        "71119",
        "7112",
        "71121",
        "71122",
        "71123",
        "71124",
        "71125",
        "71126",
        "71129",
        "712",
        "7120",
        "71200",
        "72",
        "721",
        "7210",
        "72101",
        "72102",
        "72103",
        "72104",
        "72105",
        "72106",
        "72109",
        "722",
        "7220",
        "72200",
        "73",
        "731",
        "7310",
        "73100",
        "732",
        "7320",
        "73200",
        "74",
        "741",
        "7411",
        "74111",
        "74112",
        "74113",
        "74119",
        "7419",
        "74191",
        "74192",
        "74193",
        "74194",
        "74199",
        "742",
        "7420",
        "74200",
        "749",
        "7490",
        "74901",
        "74902",
        "74903",
        "74904",
        "74905",
        "74909",
        "75",
        "750",
        "7500",
        "75000",
      ],
    },
    {
      name: "ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES",
      value: [
        "77",
        "771",
        "7710",
        "77101",
        "77102",
        "77109",
        "772",
        "7721",
        "77210",
        "7722",
        "77220",
        "7729",
        "77291",
        "77292",
        "77299",
        "773",
        "7731",
        "77310",
        "7732",
        "77320",
        "7733",
        "77330",
        "7734",
        "77341",
        "77342",
        "7739",
        "77391",
        "77392",
        "77399",
        "774",
        "7740",
        "77400",
        "78",
        "781",
        "7810",
        "78101",
        "78102",
        "78103",
        "78104",
        "783",
        "7830",
        "78300",
        "79",
        "791",
        "7910",
        "79101",
        "79102",
        "792",
        "7920",
        "79200",
        "80",
        "801",
        "8010",
        "80100",
        "802",
        "8020",
        "80200",
        "81",
        "812",
        "8121",
        "81211",
        "81212",
        "8129",
        "81291",
        "81292",
        "81299",
        "813",
        "8130",
        "81300",
        "82",
        "821",
        "8211",
        "82110",
        "8219",
        "82191",
        "82192",
        "82199",
        "822",
        "8220",
        "82200",
        "823",
        "8230",
        "82301",
        "82302",
        "82303",
        "82304",
        "829",
        "8291",
        "82911",
        "82912",
        "8292",
        "82920",
        "8299",
        "82991",
        "82999",
      ],
    },
    {
      name: "PUBLIC ADMINISTRATION AND DEFENCE",
      value: [
        "84",
        "841",
        "8411",
        "84110",
        "8412",
        "84120",
        "842",
        "8421",
        "84210",
        "8422",
        "84221",
        "84229",
        "8423",
        "84231",
        "84232",
        "84233",
        "84234",
        "84235",
        "84239",
      ],
    },
    {
      name: "EDUCATION",
      value: [
        "85",
        "851",
        "8510",
        "85101",
        "85102",
        "852",
        "8521",
        "85211",
        "85212",
        "85213",
        "8522",
        "85220",
        "8523",
        "85230",
        "8524",
        "85240",
        "8525",
        "85250",
        "853",
        "8530",
        "85301",
        "85302",
        "85303",
        "85304",
        "854",
        "8540",
        "85401",
        "85407",
        "85408",
        "85402",
        "85409",
        "85406",
        "85403",
        "85404",
        "85405",
        "855",
        "8550",
        "85501",
        "85502",
        "85509",
      ],
    },
    {
      name: "HEALTH AND SOCIAL SERVICES",
      value: [
        "86",
        "861",
        "8610",
        "86101",
        "86102",
        "86109",
        "862",
        "8620",
        "86201",
        "86202",
        "86203",
        "86204",
        "869",
        "8690",
        "86901",
        "86902",
        "86903",
        "86904",
        "86905",
        "86909",
        "87",
        "870",
        "8701",
        "87010",
        "8702",
        "87021",
        "87022",
        "87029",
        "88",
        "881",
        "8810",
        "88101",
        "88102",
        "889",
        "8891",
        "88911",
        "88912",
        "88913",
        "88919",
        "8892",
        "88920",
        "8899",
        "88991",
        "88992",
        "88999",
      ],
    },
    {
      name: "ARTS, ENTERTAINMENT AND RECREATION",
      value: [
        "90",
        "900",
        "9000",
        "90001",
        "90002",
        "90003",
        "90009",
        "91",
        "910",
        "9101",
        "91010",
        "9102",
        "91021",
        "91029",
        "9103",
        "91030",
        "92",
        "920",
        "9200",
        "92001",
        "92002",
        "93",
        "931",
        "9311",
        "93111",
        "93119",
        "9312",
        "93120",
        "932",
        "9320",
        "93201",
        "93202",
        "93203",
        "93204",
        "93209",
      ],
    },
    {
      name: "OTHER SERVICE ACTIVITIES",
      value: [
        "94",
        "941",
        "9411",
        "94110",
        "9412",
        "94120",
        "942",
        "9420",
        "94200",
        "949",
        "9491",
        "94911",
        "94912",
        "94913",
        "94914",
        "94919",
        "9492",
        "94920",
        "9499",
        "94991",
        "94992",
        "94993",
        "94994",
        "94995",
        "94999",
        "95",
        "951",
        "9511",
        "95110",
        "9512",
        "95120",
        "952",
        "9521",
        "95210",
        "9522",
        "95220",
        "9523",
        "95230",
        "9524",
        "95240",
        "9529",
        "95291",
        "95292",
        "95293",
        "95299",
        "953",
        "9530",
        "95301",
        "95302",
        "95303",
        "96",
        "960",
        "9601",
        "96011",
        "96012",
        "9602",
        "96021",
        "96022",
        "96023",
        "96024",
        "96029",
        "9603",
        "96030",
        "9604",
        "96040",
        "9609",
        "96091",
        "96092",
        "96093",
        "96094",
        "96095",
        "96099",
      ],
    },
    {
      name: "ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS OF DOMESTIC PERSONNEL",
      value: ["97", "970", "9700", "97001", "97002"],
    },
    {
      name: "ACTIVITIES OF EXTRA-TERRITORIAL ORGANISATIONS AND BODIES",
      value: ["99", "990", "9901", "99010", "9902", "99020", "9909", "99090"],
    },
  ];

  const tourSteps = [
    {
      selector: ".step1s",
      content:
        "Here, you can access individual and business information about the borrower. Click on Borrower Report for a summarized version of the details above.",
    },
    {
      selector: ".step2s",
      content:
        "You can filter your preferred loan criteria here, including options like Preferred Keyman Credit Bureau Rating and Minimum Incorporation Years,etc",
    },
    {
      selector: ".step3s",
      content:
        "Filters apply only during this visit and are cleared when you reopen or refresh this page. Click Reset filter to clear your current selections.",
    },
  ];

  const [allCBSData, setAllCBSData] = useState([]);
  const findGroupByCode = (code) => {
    const codeStr = String(code); // Convert the input code to a string
    for (const group of SsicCodes) {
      for (const value of group.value) {
        if (String(value) === codeStr) {
          // Compare as strings
          return group.name;
        }
      }
    }
    return null;
  };

  const handleChange = (event, index) => {
    const newDescriptions = [...documentDescriptions];
    newDescriptions[index] = event.target.value;
    setDocumentDescriptions(newDescriptions);
  };

  const addMore = () => {
    setDocumentDescriptions([...documentDescriptions, ""]);
  };

  const remove = (indexToRemove) => {
    setDocumentDescriptions(
      documentDescriptions.filter((_, index) => index !== indexToRemove)
    );
  };

  const [extraRequestInformation, setExtraRequestInformation] = useState({});

  const showModalRequestDocument = (
    loan_id,
    express,
    user_id,
    principal_name,
    created_at
  ) => {
    setIsModalOpen(true);
    setLoanId(loan_id);
    setExpress(express);
    setUserId(user_id);
    setPrincipalName(principal_name);
    setExtraRequestInformation({ created_at: created_at });
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const AdjustViewedBy = async (loan_id, viewed_array) => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/adjustViewedBy",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify({ loan_id: loan_id, viewed_by: viewed_array }),
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  const AdjustDownloadBy = async (loan_id, download_array) => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/adjustDownloadBy",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify({
            loan_id: loan_id,
            download_by: download_array,
          }),
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  const recordLoanMarketplaceAudit = async (loanType, loanId, action) => {
    if (isSupportMode || !authToken || !loanType || !loanId || !action) {
      return;
    }

    try {
      await fetch("https://www.smart-lend.com/api/loan/marketplace-audit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          loan_type: loanType,
          loan_id: loanId,
          action,
        }),
      });
    } catch (error) {
      console.error("Unable to record marketplace audit:", error);
    }
  };

  const getSupportManageDocumentLoanId = (loanType, loan) => {
    if (!loan) return null;
    return loanType === "corporate" ? loan.loan_id : loan.id;
  };

  const getSupportManageDocumentLoanName = () => {
    const { loanType, loan } = manageDocumentModal;
    if (!loan) return "Loan documents";
    if (loanType === "corporate") return loan.principal_name || "Corporate loan";
    if (loanType === "personal") return getPersonalLoanName(loan);
    return getPropertyLoanName(loan);
  };

  const supportManageDocumentEndpoint = (loanType, loanId) =>
    `https://www.smart-lend.com/api/support/loans/${loanType}/${loanId}/documents`;

  const getDefaultSupportDocumentType = (loanType) => {
    if (loanType === "property") return "outstanding_loan";
    return "bank_statement";
  };

  const refreshSupportManagedDocuments = async (loanType, loanId) => {
    if (!isSupportMode || !loanType || !loanId) return;

    setManageDocumentLoading(true);
    try {
      const response = await fetch(supportManageDocumentEndpoint(loanType, loanId), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("support_token")}`,
        },
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to load documents.");
      }

      const options = json?.document_types || [];
      setManageDocumentList(json?.documents || []);
      setManageDocumentTypeOptions(options);
      setManageDocumentType((current) => {
        if (current && options.some((option) => option.value === current)) {
          return current;
        }
        return options?.[0]?.value || getDefaultSupportDocumentType(loanType);
      });
    } catch (error) {
      message.error(error.message || "Unable to load documents.");
    } finally {
      setManageDocumentLoading(false);
    }
  };

  const openSupportManageDocuments = async (loanType, loan) => {
    const loanId = getSupportManageDocumentLoanId(loanType, loan);
    if (!loanId) {
      message.error("Unable to identify this loan request.");
      return;
    }

    setManageDocumentModal({ open: true, loanType, loan });
    setManageDocumentFile(null);
    setManageDocumentGroupKey("");
    setManageDocumentGroupLabel("");
    setManageDocumentType(getDefaultSupportDocumentType(loanType));
    await refreshSupportManagedDocuments(loanType, loanId);
  };

  const closeSupportManageDocuments = () => {
    setManageDocumentModal({ open: false, loanType: null, loan: null });
    setManageDocumentList([]);
    setManageDocumentTypeOptions([]);
    setManageDocumentFile(null);
    setManageDocumentGroupKey("");
    setManageDocumentGroupLabel("");
  };

  const supportLenderActivityEndpoint = (loanType, loanId) =>
    `https://www.smart-lend.com/api/support/loans/${loanType}/${loanId}/lender-activity`;

  const openSupportLenderActivity = async (loanType, loan) => {
    const loanId = getSupportManageDocumentLoanId(loanType, loan);
    if (!isSupportMode || !loanType || !loanId) {
      message.error("Unable to identify this loan request.");
      return;
    }

    setLenderActivityModal({ open: true, loanType, loan });
    setLenderActivityData(null);
    setSelectedCommunicationOffer(null);
    setLenderActivityLoading(true);

    try {
      const response = await fetch(supportLenderActivityEndpoint(loanType, loanId), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("support_token")}`,
          Accept: "application/json",
        },
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to load lender activity.");
      }

      setLenderActivityData(json);
    } catch (error) {
      message.error(error.message || "Unable to load lender activity.");
    } finally {
      setLenderActivityLoading(false);
    }
  };

  const closeSupportLenderActivity = () => {
    setLenderActivityModal({ open: false, loanType: null, loan: null });
    setLenderActivityData(null);
    setSelectedCommunicationOffer(null);
    setSupportAcceptModal({ open: false, offer: null });
    setSupportAcceptForm({});
    setSupportEditModal({ open: false, offer: null });
    setSupportEditForm({});
    setSupportDisbursementModal({ open: false, offer: null });
    setSupportDisbursementForm({});
  };

  const todayInputDate = () => format(new Date(), "yyyy-MM-dd");

  const toNumberOrZero = (value) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : 0;
  };

  const roundMoney = (value) =>
    Math.round((toNumberOrZero(value) + Number.EPSILON) * 100) / 100;

  const toMonthCount = (value) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0 ? Math.round(numeric) : 0;
  };

  const yearsToMonthCount = (value) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0
      ? Math.round(numeric * 12)
      : 0;
  };

  const getSupportOfferTenorMonths = (offer) => {
    if (!offer) return 0;
    const directMonths = toMonthCount(offer.tenor_months);
    if (directMonths > 0) return directMonths;

    const monthsFromYears = yearsToMonthCount(offer.tenor_years);
    if (monthsFromYears > 0) return monthsFromYears;

    return toMonthCount(offer.tenor);
  };

  const calculateCorporateAcceptanceDefaults = (offer) => {
    const amount = toNumberOrZero(offer?.amount);
    const rateDecimal = toNumberOrZero(offer?.rate);
    const period = getSupportOfferTenorMonths(offer) || 1;
    const monthlyInstallment =
      toNumberOrZero(offer?.monthly_installment) ||
      (period > 0 ? amount / period + amount * rateDecimal : 0);
    const principal =
      toNumberOrZero(offer?.principal) || monthlyInstallment * period;
    const totalAdminFee = toNumberOrZero(offer?.total_admin_fee);

    return {
      amount,
      interest_rate: rateDecimal,
      period,
      type: offer?.type || "simple",
      express: Boolean(offer?.express),
      category: offer?.category || "business",
      principal: roundMoney(principal),
      monthly_installment: roundMoney(monthlyInstallment),
      revenue: roundMoney(
        toNumberOrZero(offer?.revenue) || principal - amount - totalAdminFee
      ),
      admin_fee: roundMoney(toNumberOrZero(offer?.admin_fee)),
      total_admin_fee: roundMoney(totalAdminFee),
      processing_fee: toNumberOrZero(offer?.processing_fee),
      repayment_tenor: offer?.repayment_tenor || "Monthly",
      disbursement_date: todayInputDate(),
      support_note: "",
    };
  };

  const calculatePersonalAcceptanceDefaults = (offer) => ({
    amount: toNumberOrZero(offer?.amount),
    rate_pm: toNumberOrZero(offer?.rate_pm ?? offer?.rate),
    tenor_months: getSupportOfferTenorMonths(offer) || 1,
    processing_fee: toNumberOrZero(offer?.processing_fee),
    disbursement_date: todayInputDate(),
    support_note: "",
  });

  const calculateSupportEditDefaults = (offer, loanType) => {
    if (loanType === "corporate") {
      return {
        amount: toNumberOrZero(offer?.amount),
        interest_rate: toNumberOrZero(offer?.rate_pa ?? offer?.rate),
        period: getSupportOfferTenorMonths(offer) || 1,
        support_note: "",
      };
    }

    if (loanType === "personal") return {
      amount: toNumberOrZero(offer?.amount),
      rate_pm: toNumberOrZero(offer?.rate_pm ?? offer?.rate),
      tenor_months: getSupportOfferTenorMonths(offer) || 1,
      processing_fee: toNumberOrZero(offer?.processing_fee),
      support_note: "",
    };

    return {
      amount: toNumberOrZero(offer?.amount),
      rate_pa: toNumberOrZero(offer?.rate_pa ?? offer?.rate),
      tenor_months: getSupportOfferTenorMonths(offer) || 1,
      processing_fee: propertyLoanProcessingFee(offer?.amount),
      support_note: "",
    };
  };

  const isSupportOfferAcceptable = (offer) => {
    const status = String(offer?.status || "").toLowerCase();
    return ![
      "accepted",
      "ongoing",
      "pending_disbursement",
      "funded",
      "completed",
      "rejected",
      "borrower_rejected",
    ].includes(status);
  };

  const isSupportOfferEditable = (offer) => {
    return Boolean(offer?.id);
  };

  const openSupportAcceptOfferModal = (offer) => {
    const loanType = lenderActivityData?.loan_type;
    if (!["corporate", "personal"].includes(loanType)) {
      message.error(
        "Support acceptance is available for corporate and money lender loans."
      );
      return;
    }

    setSupportAcceptForm(
      loanType === "corporate"
        ? calculateCorporateAcceptanceDefaults(offer)
        : calculatePersonalAcceptanceDefaults(offer)
    );
    setSupportAcceptModal({ open: true, offer });
  };

  const closeSupportAcceptOfferModal = () => {
    setSupportAcceptModal({ open: false, offer: null });
    setSupportAcceptForm({});
  };

  const updateSupportAcceptForm = (key, value) => {
    setSupportAcceptForm((prev) => ({ ...prev, [key]: value }));
  };

  const openSupportEditOfferModal = (offer) => {
    const loanType = lenderActivityData?.loan_type;
    if (!["corporate", "personal", "property"].includes(loanType)) {
      message.error("Support editing is not available for this loan type.");
      return;
    }

    setSupportEditForm(calculateSupportEditDefaults(offer, loanType));
    setSupportEditModal({ open: true, offer });
  };

  const closeSupportEditOfferModal = () => {
    setSupportEditModal({ open: false, offer: null });
    setSupportEditForm({});
  };

  const updateSupportEditForm = (key, value) => {
    setSupportEditForm((prev) => ({ ...prev, [key]: value }));
  };

  const submitSupportEditOffer = async () => {
    const offer = supportEditModal.offer;
    const loanType = lenderActivityData?.loan_type;

    if (!offer || !["corporate", "personal", "property"].includes(loanType)) {
      message.error("Unable to identify the selected offer.");
      return;
    }

    try {
      setSupportEditBusy(true);
      const payload = loanType === "corporate"
          ? {
              amount: Number(supportEditForm.amount),
              interest_rate: Number(supportEditForm.interest_rate),
              period: Number(supportEditForm.period),
              support_note: supportEditForm.support_note || null,
            }
          : loanType === "personal" ? {
              amount: Number(supportEditForm.amount),
              rate_pm: Number(supportEditForm.rate_pm),
              tenor_months: Number(supportEditForm.tenor_months),
              processing_fee: Number(supportEditForm.processing_fee || 0),
              support_note: supportEditForm.support_note || null,
            } : {
              amount: Number(supportEditForm.amount),
              rate_pa: Number(supportEditForm.rate_pa),
              tenor_months: Number(supportEditForm.tenor_months),
              processing_fee: propertyLoanProcessingFee(supportEditForm.amount),
              support_note: supportEditForm.support_note || null,
            };

      const response = await fetch(
        `https://www.smart-lend.com/api/support/loans/${loanType}/offers/${offer.id}/edit-on-behalf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("support_token")}`,
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const json = await response.json();

      if (!response.ok) {
        const validationMessage = json?.errors
          ? Object.values(json.errors).flat().join(" ")
          : "";
        throw new Error(
          validationMessage || json?.message || "Unable to update offer."
        );
      }

      message.success(json?.message || "Offer updated on behalf of lender.");
      closeSupportEditOfferModal();
      if (lenderActivityModal.loanType && lenderActivityModal.loan) {
        await openSupportLenderActivity(
          lenderActivityModal.loanType,
          lenderActivityModal.loan
        );
      }
      if (loanType === "personal") fetchPersonalLoans();
      else if (loanType === "property") fetchPropertyLoans();
      else fetchData();
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to update offer.");
    } finally {
      setSupportEditBusy(false);
    }
  };

  const openSupportDisbursementModal = (offer) => {
    setSupportDisbursementForm({
      disbursement_date: String(offer?.disbursement_date || "").slice(0, 10),
      support_note: "",
    });
    setSupportDisbursementModal({ open: true, offer });
  };

  const closeSupportDisbursementModal = () => {
    setSupportDisbursementModal({ open: false, offer: null });
    setSupportDisbursementForm({});
  };

  const submitSupportDisbursementDate = async () => {
    const offer = supportDisbursementModal.offer;
    const loanType = lenderActivityData?.loan_type;
    if (!offer || !loanType || !supportDisbursementForm.disbursement_date) {
      message.error("Please select the updated disbursement date.");
      return;
    }

    try {
      setSupportDisbursementBusy(true);
      const response = await fetch(
        `https://www.smart-lend.com/api/support/loans/${loanType}/offers/${offer.id}/disbursement-date`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("support_token")}`,
            Accept: "application/json",
          },
          body: JSON.stringify(supportDisbursementForm),
        }
      );
      const json = await response.json();
      if (!response.ok) {
        const validationMessage = json?.errors
          ? Object.values(json.errors).flat().join(" ")
          : "";
        throw new Error(
          validationMessage || json?.message || "Unable to update disbursement date."
        );
      }

      message.success(json?.message || "Disbursement date updated.");
      closeSupportDisbursementModal();
      await openSupportLenderActivity(
        lenderActivityModal.loanType,
        lenderActivityModal.loan
      );
      if (loanType === "personal") fetchPersonalLoans();
      else if (loanType === "property") fetchPropertyLoans();
      else fetchData();
    } catch (error) {
      message.error(error.message || "Unable to update disbursement date.");
    } finally {
      setSupportDisbursementBusy(false);
    }
  };

  const submitSupportAcceptOffer = async () => {
    const offer = supportAcceptModal.offer;
    const loanType = lenderActivityData?.loan_type;

    if (!offer || !["corporate", "personal"].includes(loanType)) {
      message.error("Unable to identify the selected offer.");
      return;
    }

    try {
      setSupportAcceptBusy(true);
      const payload =
        loanType === "corporate"
          ? {
              amount: Number(supportAcceptForm.amount),
              interest_rate: Number(supportAcceptForm.interest_rate),
              period: Number(supportAcceptForm.period),
              type: supportAcceptForm.type || "simple",
              express: Boolean(supportAcceptForm.express),
              category: supportAcceptForm.category || "business",
              principal: Number(supportAcceptForm.principal),
              monthly_installment: Number(
                supportAcceptForm.monthly_installment
              ),
              revenue: Number(supportAcceptForm.revenue),
              admin_fee: Number(supportAcceptForm.admin_fee || 0),
              total_admin_fee: Number(supportAcceptForm.total_admin_fee || 0),
              processing_fee: Number(supportAcceptForm.processing_fee || 0),
              repayment_tenor: supportAcceptForm.repayment_tenor || "Monthly",
              disbursement_date: supportAcceptForm.disbursement_date || null,
              support_note: supportAcceptForm.support_note || null,
            }
          : {
              amount: Number(supportAcceptForm.amount),
              rate_pm: Number(supportAcceptForm.rate_pm),
              tenor_months: Number(supportAcceptForm.tenor_months),
              processing_fee: Number(supportAcceptForm.processing_fee || 0),
              disbursement_date: supportAcceptForm.disbursement_date,
              support_note: supportAcceptForm.support_note || null,
            };

      const response = await fetch(
        `https://www.smart-lend.com/api/support/loans/${loanType}/offers/${offer.id}/accept-on-behalf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("support_token")}`,
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const json = await response.json();

      if (!response.ok) {
        const validationMessage = json?.errors
          ? Object.values(json.errors).flat().join(" ")
          : "";
        throw new Error(
          validationMessage || json?.message || "Unable to accept offer."
        );
      }

      message.success(json?.message || "Offer accepted on behalf of borrower.");
      closeSupportAcceptOfferModal();
      if (lenderActivityModal.loanType && lenderActivityModal.loan) {
        await openSupportLenderActivity(
          lenderActivityModal.loanType,
          lenderActivityModal.loan
        );
      }
      loanType === "personal" ? fetchPersonalLoans() : fetchData();
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to accept offer.");
    } finally {
      setSupportAcceptBusy(false);
    }
  };

  const handleSupportDocumentUpload = async () => {
    const { loanType, loan } = manageDocumentModal;
    const loanId = getSupportManageDocumentLoanId(loanType, loan);
    if (!loanType || !loanId || !manageDocumentType) {
      message.error("Please select what document you are uploading.");
      return;
    }
    if (!manageDocumentFile) {
      message.error("Please choose a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("document_type", manageDocumentType);
    formData.append("document", manageDocumentFile);
    if (manageDocumentGroupKey.trim()) {
      formData.append("group_key", manageDocumentGroupKey.trim());
    }
    if (manageDocumentGroupLabel.trim()) {
      formData.append("group_label", manageDocumentGroupLabel.trim());
    }

    setManageDocumentUploading(true);
    try {
      const response = await fetch(supportManageDocumentEndpoint(loanType, loanId), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("support_token")}`,
        },
        body: formData,
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to upload document.");
      }

      message.success(json?.message || "Document uploaded.");
      setManageDocumentFile(null);
      setManageDocumentList(json?.documents || []);
      fetchDataWithRunFilter();
    } catch (error) {
      message.error(error.message || "Unable to upload document.");
    } finally {
      setManageDocumentUploading(false);
    }
  };

  const handleSupportDocumentDelete = async (documentItem) => {
    const { loanType, loan } = manageDocumentModal;
    const loanId = getSupportManageDocumentLoanId(loanType, loan);
    const documentId = documentItem?.document_id;
    if (!loanType || !loanId || !documentId) {
      message.error("Unable to identify this document.");
      return;
    }

    const params = new URLSearchParams({
      document_type: documentItem.document_type || "",
    });
    if (documentItem.group_key) {
      params.append("group_key", documentItem.group_key);
    }

    setManageDocumentDeletingId(documentId);
    try {
      const response = await fetch(
        `${supportManageDocumentEndpoint(loanType, loanId)}/${documentId}?${params.toString()}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${Cookies.get("support_token")}`,
          },
        }
      );
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to delete document.");
      }

      message.success(json?.message || "Document deleted.");
      setManageDocumentList(json?.documents || []);
      fetchDataWithRunFilter();
    } catch (error) {
      message.error(error.message || "Unable to delete document.");
    } finally {
      setManageDocumentDeletingId(null);
    }
  };

  const renderSupportManageDocumentButton = (loanType, loan, disabled = false) => {
    if (!isSupportMode) return null;

    return (
      <button
        className="all_button"
        disabled={disabled}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          openSupportManageDocuments(loanType, loan);
        }}
        style={{
          background: "transparent",
          color: disabled ? "#999" : "#1677ff",
          width: "100%",
          border: "2px solid #91caff",
          borderRadius: "15px",
          padding: "4px 20px",
          fontSize: "12px",
          marginTop: "10px",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        Manage document
      </button>
    );
  };

  const handleRequestMoreDocument = async (
    loan_id,
    express,
    user_id,
    principal_name
  ) => {
    console.log("loanId value in handleRequestMoreDocument", loan_id); // Debug statement
    console.log("user_id value in handleRequestMoreDocument", user_id); // Debug statement
    console.log(
      "principal_name value in handleRequestMoreDocument",
      principal_name
    ); // Debug statement

    // rest of the code
    try {
      let path = "";

      let add_documents = documentDescriptions.map((description, index) => ({
        document_name: description,
        document: "",
      }));

      let item = {
        loan_id,
        express,
        offer_amount: parseFloat(parseFloat(offer_amount).toFixed(2)),
        offer_interest_rate: parseFloat(parseFloat(offer_interest_rate / 100)),
        offer_period: parseInt(offer_period),
        type,
        offer_principal: parseFloat(parseFloat(offer_principal).toFixed(2)),
        offer_monthly_installment: parseFloat(
          parseFloat(offer_monthly_installment).toFixed(2)
        ),
        offer_revenue: parseFloat(parseFloat(offer_revenue).toFixed(2)),
        total_admin_fee: parseFloat(parseFloat(total_admin_fee).toFixed(2)),
        admin_fee: 0,
        processing_fee: parseFloat(offer_processing_fee / 100),
        add_document: JSON.stringify(add_documents),
      };
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/createLoan",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify(item),
        }
      );
      const data = await response.json();
      if (response.status === 200) {
        message.success(data.message || "Loan offer created successfully."); // Display success message
        try {
          let item = {
            user_id: user_id,
            channel: "system",
            subject: "Lender offer",
            message: "Lender had make an  offer",
          };
          const response = await fetch(
            "https://www.smart-lend.com/api/user/notification/sendNotification",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify(item),
            }
          );
          const data = await response.json();
          console.log("Offer created:", data);
        } catch (error) {
          console.error("Error creating offer:", error);
        }

        try {
          const response = await fetch(
            `https://www.smart-lend.com/api/profile/createActivityLog`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify({
                user_id: user_id,
                user_name: principal_name,
                user_account_type: "borrower",
                description: `You've received a request for more document on your loan request ${loan_id} that you've made on ${formatDate(
                  extraRequestInformation.created_at
                    ? extraRequestInformation.created_at
                    : null
                )}`,
              }),
            }
          );
          const data = await response.json();
          console.log("Offer created:", data);
        } catch (error) {
          console.error("Error creating offer:", error);
        }

        try {
          const response = await fetch(
            `https://www.smart-lend.com/api/profile/createActivityLogForSelf`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify({
                description: `You've requested for more document on loan ${loan_id} from ${principal_name}.`,
              }),
            }
          );
          const data = await response.json();
          console.log("Offer created:", data);
        } catch (error) {
          console.error("Error creating offer:", error);
        }

        path = "/pending-acceptance";
        return history.push(path);
      } else if (response.status === 400) {
        message.error(data.message || "Unable to create loan offer."); // Display error message
      } else {
        message.error("An unexpected error has occurred."); // Handle other errors
      }

      console.log("Offer created:", data);
      return history.push(path);
      // Update your UI or close the modal
    } catch (error) {
      console.error("Error creating offer:", error);
    }
  };

  const handleNotInterestedModal = (event) => {
    console.log("Event: ", event);
    const value = event.target.value;
    console.log("Value: ", value);
    setSelectedValue(value);
    setShowOtherInput(value === "others");
  };

  const [showOtherInput, setShowOtherInput] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    "interest_rate_is_too_low"
  );

  const handleNotInterested = async (loan_id, selectedValue) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/notInterestedLoan?loan_id=${loan_id}&reject_reason=${selectedValue}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      const data = await response.json();

      if (response.status === 200) {
        message.success(data.message);
        setNotInterestedIds((prev) =>
          prev.includes(loan_id) ? prev : [...prev, loan_id]
        );
        const markRejected = (loans) => loans.map((loan) =>
          loan.loan_id === loan_id ? { ...loan, rejected_by_me: true } : loan
        );
        setData(markRejected);
        setFilteredData((prev) => Array.isArray(prev) ? markRejected(prev) : prev);
      } else if (response.status === 400) {
        message.error(data.message);
      }
    } catch (error) {
      console.error("Error retrieving Requested Loan Details:", error);
    }

    try {
      let item = {
        user_id: "A00001",
        channel: "system",
        subject: `Not interested Loan`,
        message: `Lender had select an option for not interested with loan ${loan_id}`,
      };
      const response = await fetch(
        "https://www.smart-lend.com/api/user/notification/sendNotification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify(item),
        }
      );
      const data = await response.json();
      console.log("Offer created:", data);
    } catch (error) {
      console.error("Error creating offer:", error);
    }

    // Fetch data again
    fetchDataWithRunFilter();
  };

  const handleLoanPeriodFilterChange = (value) => {
    setLoanPeriodFilter(value);
  };

  const handleCreditScoreMinChange = (event) => {
    setCreditScoreMin(event.target.value);
  };

  const handleCreditScoreMaxChange = (event) => {
    setCreditScoreMax(event.target.value);
  };

  const handleLoanPeriodMinChange = (event) => {
    setLoanPeriodMin(event.target.value);
  };

  const handleLoanPeriodMaxChange = (event) => {
    setLoanPeriodMax(event.target.value);
  };

  const handleCheckboxChange = (isChecked, category) => {
    if (isChecked) {
      setLoanCategoryFilters([...loanCategoryFilters, category]);
    } else {
      setLoanCategoryFilters(loanCategoryFilters.filter((c) => c !== category));
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isPersonalLoansLoading, setIsPersonalLoansLoading] = useState(false);
  const [isPropertyLoansLoading, setIsPropertyLoansLoading] = useState(false);

  const downloadLoanDocuments = async (loanId) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        isSupportMode
          ? "https://www.smart-lend.com/api/support/loans/corporate/documents/download"
          : "https://www.smart-lend.com/api/download-loan-documents",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ loan_id: loanId }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(`Download failed: ${data.message}`);
        return;
      }

      await recordLoanMarketplaceAudit("corporate", loanId, "downloaded");

      const downloadUrl = data.download_url;

      // Create a link and simulate click to download the file
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "loan_documents.zip"); // Optional: suggested filename
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Error downloading zip:", err);
      alert("An error occurred while downloading the ZIP.");
    } finally {
      setIsLoading(false);
    }
  };

  const calculateYearsFromNow = (dateString) => {
    const givenDate = new Date(dateString);
    const currentDate = new Date();

    const yearsDifference = currentDate.getFullYear() - givenDate.getFullYear();

    return yearsDifference;
  };

  const findGroupByName = (name) => {
    return SsicCodes.find((group) => group.name === name);
  };

  const findRatingIndex = (rating) => {
    return possiblecreditrating.findIndex((r) => r.value === rating);
  };

  const runFilter = () => {
    let filtered = data;

    console.log(filtered);
    // Filter the data based on the query parameters
    if (minLoanAmount) {
      filtered = filtered.filter(
        (item) => item.request_amount >= minLoanAmount
      );
    }
    if (maxLoanAmount) {
      filtered = filtered.filter(
        (item) => item.request_amount <= maxLoanAmount
      );
    }
    if (LoanPeriodMin) {
      filtered = filtered.filter(
        (item) => item.request_period >= LoanPeriodMin
      );
    }
    if (LoanPeriodMax) {
      filtered = filtered.filter(
        (item) => item.request_period <= LoanPeriodMax
      );
    }
    if (LoanInterestMin) {
      filtered = filtered.filter(
        (item) => item.request_interest_rate >= LoanInterestMin / 100
      );
    }
    if (LoanInterestMax) {
      filtered = filtered.filter(
        (item) => item.request_interest_rate <= LoanInterestMax / 100
      );
    }
    if (MinYearOfIncorp) {
      console.log(MinYearOfIncorp);
      filtered = filtered.filter(
        (item) =>
          calculateYearsFromNow(
            JSON.parse(item?.singpass_data)?.entity?.["basic-profile"]?.[
              "registration-date"
            ]?.value
          ) >= MinYearOfIncorp
      );
    }

    if (selectedIndustry) {
      const selectedGroup = findGroupByName(selectedIndustry);
      console.log(selectedGroup);
      if (selectedGroup) {
        filtered = filtered.filter((item) => {
          const ssicCode = JSON.parse(item.singpass_data).entity[
            "basic-profile"
          ]["primary-activity"].code;
          console.log(selectedGroup.value.includes(ssicCode));
          return selectedGroup.value.includes(ssicCode);
        });
      }
    }

    if (selectedCreditRating) {
      const selectedIndex = findRatingIndex(selectedCreditRating);
      console.log(selectedIndex);
      filtered = filtered.filter((item) => {
        const creditReportData = item.credit_report_data || {};
        const creditRating = creditReportData.RiskGrade
          ? creditReportData.RiskGrade.replace(/\s+/g, "")
          : null;
        if (creditRating === null) {
          return false; // Skip items with null or undefined RiskGrade
        }
        const itemRatingIndex = findRatingIndex(creditRating);
        console.log(itemRatingIndex);
        if (itemRatingIndex > -1 && selectedIndex > -1) {
          return itemRatingIndex <= selectedIndex;
        }
        return false; // Skip items where itemRatingIndex or selectedIndex is invalid
      });
    }

    if (loanCategoryFilters.length > 0) {
      filtered = filtered.filter((item) =>
        loanCategoryFilters.includes(item.category)
      );
    }
    // Set filteredData only if it's not empty
    console.log(filtered);
    if (filtered.length > 0) {
      setFilteredData(filtered);
    } else if (filtered !== data) {
      setFilteredData([]);
      // console.log("no");
      setempty("1");
    }
  };

  useEffect(() => {
    let filtered = data;

    console.log(filtered);
    // Filter the data based on the query parameters
    if (minLoanAmount) {
      filtered = filtered.filter(
        (item) => item.request_amount >= minLoanAmount
      );
    }
    if (maxLoanAmount) {
      filtered = filtered.filter(
        (item) => item.request_amount <= maxLoanAmount
      );
    }
    if (LoanPeriodMin) {
      filtered = filtered.filter(
        (item) => item.request_period >= LoanPeriodMin
      );
    }
    if (LoanPeriodMax) {
      filtered = filtered.filter(
        (item) => item.request_period <= LoanPeriodMax
      );
    }
    if (LoanInterestMin) {
      filtered = filtered.filter(
        (item) => item.request_interest_rate >= LoanInterestMin / 100
      );
    }
    if (LoanInterestMax) {
      filtered = filtered.filter(
        (item) => item.request_interest_rate <= LoanInterestMax / 100
      );
    }
    if (MinYearOfIncorp) {
      console.log(MinYearOfIncorp);
      filtered = filtered.filter(
        (item) =>
          calculateYearsFromNow(
            JSON.parse(item?.singpass_data)?.entity?.["basic-profile"]?.[
              "registration-date"
            ]?.value
          ) >= MinYearOfIncorp
      );
    }

    if (selectedIndustry) {
      const selectedGroup = findGroupByName(selectedIndustry);
      console.log(selectedGroup);
      if (selectedGroup) {
        filtered = filtered.filter((item) => {
          const ssicCode = JSON.parse(item.singpass_data).entity[
            "basic-profile"
          ]["primary-activity"].code;
          console.log(selectedGroup.value.includes(ssicCode));
          return selectedGroup.value.includes(ssicCode);
        });
      }
    }

    if (selectedCreditRating) {
      const selectedIndex = findRatingIndex(selectedCreditRating);
      console.log(selectedIndex);
      filtered = filtered.filter((item) => {
        const creditReportData = item.credit_report_data || {};
        const creditRating = creditReportData.RiskGrade
          ? creditReportData.RiskGrade.replace(/\s+/g, "")
          : null;
        if (creditRating === null) {
          return false; // Skip items with null or undefined RiskGrade
        }
        const itemRatingIndex = findRatingIndex(creditRating);
        console.log(itemRatingIndex);
        if (itemRatingIndex > -1 && selectedIndex > -1) {
          return itemRatingIndex <= selectedIndex;
        }
        return false; // Skip items where itemRatingIndex or selectedIndex is invalid
      });
    }

    if (loanCategoryFilters.length > 0) {
      filtered = filtered.filter((item) =>
        loanCategoryFilters.includes(item.category)
      );
    }
    // Set filteredData only if it's not empty

    if (filtered.length > 0) {
      setFilteredData(filtered);
    } else if (filtered !== data) {
      setFilteredData([]);
      // console.log("no");
      setempty("1");
    }
  }, [
    selectedCreditRating,
    selectedIndustry,
    MinYearOfIncorp,
    minLoanAmount,
    maxLoanAmount,
    LoanInterestMin,
    LoanInterestMax,
    LoanPeriodMin,
    LoanPeriodMax,
    loanCategoryFilters,
  ]);

  useEffect(() => {
    if (isSupportMode) {
      return;
    }

    // To redirect user if not authenticated
    const isAuthenticated = Cookies.get("token");
    const user_account_type = Cookies.get("user_account_type");

    if (!isAuthenticated) {
      history.push("/auth/signin");
    } else if (user_account_type === "borrower") {
      history.push("/b-dashboard");
    }
  }, [history, isSupportMode]);

  useEffect(() => {
    const storedDate = Cookies.get("countdownTargetDate");
    if (storedDate) {
      setTargetDate(Number(storedDate));
    } else {
      const newTargetDate = new Date().getTime() + 1000 * 60 * 60 * 24; // 1 day from now
      Cookies.set("countdownTargetDate", newTargetDate);
      setTargetDate(newTargetDate);
    }
  }, []);

  const timerStyle = {
    color: "grey",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "400",
    fontSize: "12px",
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    let timeLeft = "";

    if (completed) {
      return <span style={timerStyle}>Time's up!</span>;
    } else {
      if (days > 0) {
        timeLeft = `${days}d ${hours}h ${minutes}m`;
      } else if (hours > 0) {
        timeLeft = `${hours}h ${minutes}m ${seconds}s`;
      } else {
        timeLeft = `${minutes}m ${seconds}s`;
      }

      return <span style={timerStyle}>{timeLeft}</span>;
    }
  };

  const handleLoanAmountChange = (e) => {
    setLoanAmount(e.target.value);
  };

  const handleGridPath = () => {
    // history.push('../loan-request-grid')
  };

  const handleListPath = () => {
    history.push("../loan-request");
  };

  const handleInterestRateChange = (e) => {
    let value = e.target.value;
    setInterestRate(value);
  };

  const handleLoanPeriodChange = (e) => {
    setSelectedLoanPeriod(e.target.value);
  };

  useEffect(() => {
    const calculateLoan = () => {
      if (type === "simple") {
        const offer_monthly_installment =
          (loanRepaymentTenor === ""
            ? (offer_amount / offer_period +
                offer_amount * (offer_interest_rate / 100)) *
              1.0
            : loanRepaymentTenor === "Weekly"
            ? ((offer_amount / offer_period +
                offer_amount * (offer_interest_rate / 100)) *
                1.0) /
              4
            : ((offer_amount / offer_period +
                offer_amount * (offer_interest_rate / 100)) *
                1.0) /
              2) || "0";
        const offer_principal =
          (offer_amount / offer_period +
            offer_amount * (offer_interest_rate / 100)) *
            1.0 *
            offer_period || "0";
        const total_admin_fee =
          (offer_amount / offer_period +
            offer_amount * (offer_interest_rate / 100)) *
            0.0 *
            offer_period || "0";
        const offer_revenue =
          offer_principal - offer_amount - total_admin_fee || "0";
        const admin_fee =
          (offer_amount / offer_period +
            offer_amount * (offer_interest_rate / 100)) *
          0.0;
        setAdminFee(admin_fee);
        setLoanPrincipal(offer_principal);
        setExpectedMonthlyInstallment(offer_monthly_installment);
        setGuaranteedRevenue(offer_revenue);
        setTotalAdminFee(total_admin_fee);
      } else if (type === "effective") {
        const offer_monthly_installment =
          ((offer_amount *
            (offer_interest_rate / 1200) *
            (1 + offer_interest_rate / 1200) ** offer_period) /
            ((1 + offer_interest_rate / 1200) ** offer_period - 1)) *
            1.05 || "0";
        const offer_principal = offer_monthly_installment * offer_period || "0";
        const total_admin_fee =
          ((offer_amount *
            (offer_interest_rate / 1200) *
            (1 + offer_interest_rate / 1200) ** offer_period) /
            ((1 + offer_interest_rate / 1200) ** offer_period - 1)) *
            1.05 *
            0.05 *
            offer_period || "0";
        const offer_revenue =
          offer_principal - offer_amount - total_admin_fee || "0";
        const admin_fee = offer_monthly_installment * 0.05;
        setAdminFee(admin_fee);
        setLoanPrincipal(offer_principal);
        setExpectedMonthlyInstallment(offer_monthly_installment);
        setGuaranteedRevenue(offer_revenue);
        setTotalAdminFee(total_admin_fee);
      }
    };
    calculateLoan();
  }, [
    loanRepaymentTenor,
    offer_amount,
    offer_interest_rate,
    offer_period,
    type,
    offer_principal,
    offer_monthly_installment,
    offer_revenue,
    total_admin_fee,
    admin_fee,
  ]);

  const handleLoanTypeChange = (e) => {
    setLoanType(e.target.value);
  };

  const fetchLoanDetails = async (loan_id) => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + authToken);

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/loanRequest/viewLoanRequestDetail?loan_id=${loan_id}`,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      setLoanDetails(data);
    } catch (error) {
      console.error(error);
    }
  };

  const [modalStates, setModalStates] = useState({});
  const [modalStates2, setModalStates2] = useState({});
  const [modalStates3, setModalStates3] = useState({});
  const [modalStates4, setModalStates4] = useState({});

  useEffect(() => {
    const initialStates = {};
    const initialStates2 = {};
    const initialStates3 = {};
    const initialStates4 = {};

    data.forEach((item) => {
      initialStates[item.loan_id] = false;
      initialStates2[item.loan_id] = false;
      initialStates3[item.loan_id] = false;
      initialStates4[item.loan_id] = false;
    });
    setModalStates(initialStates);
    setModalStates2(initialStates2);
    setModalStates3(initialStates3);
    setModalStates4(initialStates4);
  }, [data]);

  const [floatingLoanAmount, setFloatingLoanAmount] = useState({
    loanId: "",
    totalLoanedAmount: "",
  });
  const [warningLenderModal, setWarningLenderModal] = useState(false);

  const openMakeAnOfferModal = () => {
    setModalStates((prevStates) => ({
      ...prevStates,
      [floatingLoanAmount.loanId]: true,
    }));
  };

  const showModal = (loanId, totalLoanedAmount) => {
    if (totalLoanedAmount !== 0) {
      console.log();
      setFloatingLoanAmount({
        loanId: loanId,
        totalLoanedAmount: totalLoanedAmount,
      });
      setWarningLenderModal(true);
    } else {
      setModalStates((prevStates) => ({
        ...prevStates,
        [loanId]: true,
      }));
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const showModal2 = (loanId) => {
    setModalStates2((prevStates) => ({
      ...prevStates,
      [loanId]: true,
    }));
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const showModal3 = (loanId) => {
    setModalStates3((prevStates) => ({
      ...prevStates,
      [loanId]: true,
    }));
  };

  const handleClose3 = () => {
    setOpen3(false);
  };

  const showModal4 = (loanId) => {
    setModalStates4((prevStates) => ({
      ...prevStates,
      [loanId]: true,
    }));
  };

  const handleClose4 = () => {
    setOpen4(false);
  };

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);

  //Condition to allow only one checkbox selected based on checkbox ID
  const handleLoanAmountCheckbox = (id, min, max) => {
    if (selectedCheckbox === id) {
      setSelectedCheckbox(null);
      setMinLoanAmount("");
      setMaxLoanAmount("");
    } else {
      setSelectedCheckbox(id);
      setMinLoanAmount(min);
      setMaxLoanAmount(max);
    }
  };
  const handleLoanPeriodCheckbox = (id, min, max) => {
    if (selectedCheckbox1 === id) {
      setSelectedCheckbox1(null);
      setLoanPeriodMin("");
      setLoanPeriodMax("");
    } else {
      setSelectedCheckbox1(id);
      setLoanPeriodMin(min);
      setLoanPeriodMax(max);
    }
  };
  const handleLoanInterestCheckbox = (id, min, max) => {
    if (selectedCheckbox2 === id) {
      setSelectedCheckbox2(null);
      setLoanInterestMin("");
      setLoanInterestMax("");
    } else {
      setSelectedCheckbox2(id);
      setLoanInterestMin(min);
      setLoanInterestMax(max);
    }
  };

  const handleDownloadBankStatement = async (loan_id, event) => {
    event.preventDefault();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/viewBankStatement?loan_id=${loan_id}`,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      if (data && data.data) {
        window.open(data.data, "_blank"); // open the url in a new tab
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDownloadCreditReport = async (userId, event) => {
    event.preventDefault();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/viewCreditReport?user_id=${userId}`,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;

      // the filename you want
      a.download = "CreditReport.pdf"; // You can dynamically set the filename based on content-disposition header or any other logic

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error(error);
    }
  };

  const handleMakeOffer = async (
    loan_id,
    express,
    user_id,
    principal_name,
    created_at
  ) => {
    if (!ensureSupportLenderSelected()) return;
    console.log("loanId value in handleMakeOffer", loan_id); // Debug statement
    console.log("principal_name value in handleMakeOffer", principal_name); // Debug statement
    // rest of the code
    try {
      let path = "";
      let item = {
        loan_id,
        express,
        offer_amount: parseFloat(parseFloat(offer_amount).toFixed(2)),
        offer_interest_rate: parseFloat(parseFloat(offer_interest_rate / 100)),
        offer_period: parseInt(offer_period),
        type,
        offer_principal: parseFloat(parseFloat(offer_principal).toFixed(2)),
        offer_monthly_installment: parseFloat(
          parseFloat(offer_monthly_installment).toFixed(2)
        ),
        offer_revenue: parseFloat(parseFloat(offer_revenue).toFixed(2)),
        total_admin_fee: parseFloat(parseFloat(total_admin_fee).toFixed(2)),
        admin_fee: 0,
        processing_fee: parseFloat(offer_processing_fee / 100),
        repayment_tenor: loanRepaymentTenor,
        loan_type: "corporate",
        lender_user_id: selectedSupportLenderId || undefined,
      };
      const response = await fetch(
        isSupportMode
          ? "https://www.smart-lend.com/api/support/loans/offers/on-behalf"
          : "https://www.smart-lend.com/api/loan/createLoan",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              (isSupportMode ? Cookies.get("support_token") : Cookies.get("token")),
          },
          body: JSON.stringify(item),
        }
      );
      const data = await response.json();
      if (response.status === 200) {
        message.success(data.message || "Loan offer created successfully."); // Display success message

        if (isSupportMode) {
          if (loan_id) {
            setModalStates((prevStates) => ({
              ...prevStates,
              [loan_id]: false,
            }));
          }
          setMakeOfferData(null);
          setSelectedSupportLenderId("");
          fetchData();
          return;
        }

        try {
          let item = {
            user_id: user_id,
            channel: "system",
            subject: "Lender offer",
            message: "Lender had make an  offer",
          };
          const response = await fetch(
            "https://www.smart-lend.com/api/user/notification/sendNotification",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify(item),
            }
          );
          const data = await response.json();
          console.log("Offer created:", data);
        } catch (error) {
          console.error("Error creating offer:", error);
        }

        try {
          const response = await fetch(
            `https://www.smart-lend.com/api/profile/createActivityLog`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify({
                user_id: user_id,
                user_name: principal_name,
                user_account_type: "borrower",
                description: `You've received a loan offer on your loan request ${loan_id} that you've made on ${formatDate(
                  created_at ? created_at : null
                )}`,
              }),
            }
          );
          const json = await response.json();
          console.log(json);
          console.log("Offer created:", data);
        } catch (error) {
          console.error("Error creating offer:", error);
        }

        try {
          const response = await fetch(
            `https://www.smart-lend.com/api/profile/createActivityLogForSelf`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify({
                description: `You've made a loan offer on loan ${loan_id} from ${principal_name}.`,
              }),
            }
          );
          const data = await response.json();
          console.log("Offer created:", data);
        } catch (error) {
          console.error("Error creating offer:", error);
        }

        path = "/pending-acceptance";
        return history.push(path);
      } else if (response.status === 400) {
        message.error(data.message || "Unable to create loan offer."); // Display error message
      } else {
        message.error("An unexpected error has occurred."); // Handle other errors
      }
    } catch (error) {
      console.error("Error creating offer:", error);
    }
  };
  const buttonStyleExpress = {
    fontFamily: "Poppins, sans-serif",
    fontWeight: "600",
    fontSize: "15px",
    color: "#FFFFFF",
    textAlign: "center",
    background: "#FED065",
    border: "none",
    borderRadius: "1000px",
    width: "90%",
    height: "40px",
    marginTop: "5px",
    marginBottom: "15px",
  };

  const buttonStyleBorrower = {
    fontFamily: "Poppins, sans-serif",
    fontWeight: "600",
    fontSize: "15px",
    color: "#FFFFFF",
    textAlign: "center",
    background:
      "linear-gradient(90deg, rgba(138, 156, 197, 0.8) 0%, rgba(21,87,169,1) 100%)",
    border: "none",
    borderRadius: "1000px",
    width: "90%",
    height: "40px",
    marginTop: "5px",
    marginBottom: "7px",
  };

  const buttonStyleNotInterested = {
    fontFamily: "Poppins, sans-serif",
    fontWeight: "600",
    fontSize: "15px",
    color: "grey",
    textAlign: "center",
    background: "transparent",
    border: "1px solid grey",
    borderRadius: "1000px",
    width: "90%",
    height: "40px",
    marginTop: "5px",
    marginBottom: "15px",
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-"; // Return a default value if the date string is not provided

    const date = new Date(dateString); // Create a Date object from the date string
    const formattedDate = format(date, "MMM dd, yyyy"); // Use date-fns to format the date in the desired format

    return formattedDate;
  };

  const formatPersonalRate = (value) => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    return `${numeric}% p.m.`;
  };

  const formatPersonalAmount = (value) => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    return numeric.toLocaleString("en-US", {
      style: "currency",
      currency: "SGD",
    });
  };

  const formatPersonalTenor = (value) => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    return formatTenorMonths(numeric);
  };

  const formatTenorMonths = (value) => {
    const months = toMonthCount(value);
    if (months <= 0) return "-";

    const years = Math.floor(months / 12);
    const remainingMonths = months % 12;
    const parts = [];

    if (years > 0) {
      parts.push(`${years} Year${years === 1 ? "" : "s"}`);
    }
    if (remainingMonths > 0) {
      parts.push(
        `${remainingMonths} Month${remainingMonths === 1 ? "" : "s"}`
      );
    }

    return parts.length ? parts.join(" ") : "0 Months";
  };

  const splitTenorMonths = (value) => {
    const months = toMonthCount(value);
    return {
      years: Math.floor(months / 12),
      months: months % 12,
    };
  };

  const renderSupportTenorInput = (value, onChange) => {
    const tenor = splitTenorMonths(value);
    const updateTenor = (years, months) => {
      const yearCount = Math.max(0, Math.round(toNumberOrZero(years)));
      const monthCount = Math.min(
        11,
        Math.max(0, Math.round(toNumberOrZero(months)))
      );
      onChange(Math.max(1, yearCount * 12 + monthCount));
    };

    return (
      <div style={{ display: "grid", gap: 6 }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 8,
          }}
        >
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            step={1}
            value={tenor.years}
            addonAfter="Years"
            onChange={(nextYears) => updateTenor(nextYears, tenor.months)}
          />
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            max={11}
            step={1}
            value={tenor.months}
            addonAfter="Months"
            onChange={(nextMonths) => updateTenor(tenor.years, nextMonths)}
          />
        </div>
        <div style={{ color: "#64748b", fontSize: 12 }}>
          {formatTenorMonths(value)}
        </div>
      </div>
    );
  };

  const formatSupportOfferRate = (offer) => {
    if (!offer) return "-";
    if (
      offer.loan_type === "personal" &&
      offer.rate_pm !== undefined &&
      offer.rate_pm !== null &&
      offer.rate_pm !== ""
    ) {
      return `${Number(offer.rate_pm)}% p.m.`;
    }
    const rate = offer.rate_pa ?? offer.rate;
    if (rate === undefined || rate === null || rate === "") return "-";
    const numeric = Number(rate);
    if (Number.isNaN(numeric)) return `${rate}`;
    return `${numeric}% p.a.`;
  };

  const formatSupportOfferTenor = (offer) => {
    if (!offer) return "-";
    return formatTenorMonths(getSupportOfferTenorMonths(offer));
  };

  const formatSupportProcessingFee = (value) => {
    if (value === undefined || value === null || value === "") return "-";
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    if (numeric > 0 && numeric < 1) return `${numeric * 100}%`;
    return `${numeric}%`;
  };

  const formatCommunicationTimestamp = (timestamp) => {
    if (!timestamp) return "";
    const parsed = new Date(timestamp);
    if (Number.isNaN(parsed.getTime())) return timestamp;
    return format(parsed, "MMM dd, yyyy h:mm a");
  };

  const renderSupportMessageAttachments = (attachments) => {
    if (!Array.isArray(attachments) || attachments.length === 0) return null;

    return (
      <div style={{ display: "grid", gap: 6, marginTop: 8 }}>
        {attachments.map((attachment, index) => (
          <a
            key={`${attachment?.url || attachment?.name || "attachment"}-${index}`}
            href={attachment?.url}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#0e5aa5", fontSize: 12, fontWeight: 700 }}
          >
            {attachment?.name || `Attachment ${index + 1}`}
          </a>
        ))}
      </div>
    );
  };

  const renderSupportActivityMetric = (label, value, options = {}) => (
    <div
      style={{
        minHeight: 76,
        padding: "12px 14px",
        borderRadius: 10,
        background: options.accent ? "#f0f7ff" : "#fff",
        border: `1px solid ${options.accent ? "#bfdbfe" : "#e6ebf5"}`,
        boxShadow: "0 8px 20px rgba(15, 35, 55, 0.04)",
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: "#64748b",
          fontWeight: 800,
          textTransform: "uppercase",
          letterSpacing: 0,
          marginBottom: 6,
        }}
      >
        {label}
      </div>
      <div
        style={{
          color: "#172033",
          fontSize: options.large ? 18 : 14,
          fontWeight: 800,
          lineHeight: 1.25,
          wordBreak: "break-word",
        }}
      >
        {value || "-"}
      </div>
    </div>
  );

  const renderSupportOfferMetric = (label, value, options = {}) => (
    <div
      style={{
        padding: "10px 12px",
        borderRadius: 10,
        background: options.highlight ? "#f0fdf4" : "#f8fafc",
        border: `1px solid ${options.highlight ? "#bbf7d0" : "#e2e8f0"}`,
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: "#64748b",
          fontWeight: 800,
          marginBottom: 5,
        }}
      >
        {label}
      </div>
      <div
        style={{
          color: "#172033",
          fontSize: 14,
          fontWeight: 800,
          lineHeight: 1.25,
          wordBreak: "break-word",
        }}
      >
        {value || "-"}
      </div>
    </div>
  );

  const renderSupportRepaymentSchedule = (offer) => {
    const schedule = Array.isArray(offer?.repayment_schedules)
      ? offer.repayment_schedules
      : [];
    if (!isSupportOfferOngoing(offer)) return null;

    return (
      <div
        style={{
          marginTop: 16,
          borderTop: "1px solid #e2e8f0",
          paddingTop: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            flexWrap: "wrap",
            marginBottom: 10,
          }}
        >
          <div>
            <div style={{ fontWeight: 900, color: "#172033" }}>
              Repayment schedule
            </div>
            <div style={{ color: "#64748b", fontSize: 12, marginTop: 3 }}>
              Disbursed {offer.disbursement_date ? formatDate(offer.disbursement_date) : "-"}
            </div>
          </div>
          <Button
            onClick={() => openSupportDisbursementModal(offer)}
            style={{ borderRadius: 10, fontWeight: 800 }}
          >
            Adjust disbursement date
          </Button>
        </div>
        {schedule.length ? (
          <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: 10 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 680 }}>
              <thead>
                <tr style={{ background: "#f8fafc", color: "#475569" }}>
                  {["#", "Due date", "Principal", "Interest", "Total due", "Balance", "Status"].map((label) => (
                    <th key={label} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, textTransform: "uppercase" }}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {schedule.map((repayment, index) => (
                  <tr key={repayment.id || `${repayment.due_date}-${index}`} style={{ borderTop: "1px solid #e2e8f0" }}>
                    <td style={{ padding: "10px 12px", fontWeight: 800 }}>{index + 1}</td>
                    <td style={{ padding: "10px 12px" }}>{formatDate(repayment.due_date)}</td>
                    <td style={{ padding: "10px 12px" }}>{formatPersonalAmount(repayment.principal_amount)}</td>
                    <td style={{ padding: "10px 12px" }}>{formatPersonalAmount(repayment.interest_amount)}</td>
                    <td style={{ padding: "10px 12px", fontWeight: 800 }}>{formatPersonalAmount(repayment.amount_due)}</td>
                    <td style={{ padding: "10px 12px" }}>{repayment.loan_balance !== undefined && repayment.loan_balance !== null ? formatPersonalAmount(repayment.loan_balance) : "-"}</td>
                    <td style={{ padding: "10px 12px", textTransform: "capitalize" }}>{repaymentStatusLabel(repayment)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: 14, borderRadius: 10, background: "#fff7ed", color: "#9a3412", fontWeight: 700 }}>
            No repayment schedule is available for this running loan.
          </div>
        )}
      </div>
    );
  };

  const normalizePropertyLoanData = (loan) => {
    if (!loan) return {};
    if (loan.loan_data && typeof loan.loan_data === "string") {
      try {
        return JSON.parse(loan.loan_data);
      } catch (error) {
        return {};
      }
    }
    return loan.loan_data || {};
  };

  const getPropertyLoanTypeLabel = (loanData) => {
    const selected = Number(loanData?.selectedLoanType);
    if (selected === 0) return "First Charge Equity Term Loan";
    if (selected === 1) return "Bridging Loan";
    if (selected === 2) return "Half Caveat Loan";
    return "Property Term Loan";
  };

  const getPropertyLoanInterestRange = (loanData) => {
    const selected = Number(loanData?.selectedLoanType);
    if (selected === 0) return "6% - 10% p.a.";
    if (selected === 1 || selected === 2) return "1.5% - 2.5% per month";
    return "-";
  };

  const getPropertyLoanTenorMonths = (loanData) => {
    const selected = Number(loanData?.selectedLoanType);
    if ([0, 1, 2].includes(selected)) return propertyLoanMonths(selected, loanData);
    return null;
  };

  const formatAuditLenderList = (entries) => {
    if (!Array.isArray(entries) || entries.length === 0) {
      return "None yet";
    }

    return entries
      .map((entry) => entry?.name || entry?.email || entry?.user_id)
      .filter(Boolean)
      .join(", ");
  };

  const isSupportOfferRejectedByBorrower = (offer) =>
    ["rejected", "borrower_rejected"].includes(
      String(offer?.status || "").toLowerCase()
    ) || Boolean(offer?.borrower_rejection?.rejected);

  const getSupportRejectedOffers = (offers) =>
    Array.isArray(offers) ? offers.filter(isSupportOfferRejectedByBorrower) : [];

  const isSupportOfferOngoing = (offer) => {
    if (offer?.is_ongoing) return true;
    const status = String(offer?.status || "").toLowerCase();
    if (["ongoing", "funded"].includes(status)) return true;
    if (status !== "pending_disbursement" || !offer?.disbursement_date) {
      return false;
    }
    return String(offer.disbursement_date).slice(0, 10) <= todayInputDate();
  };

  const getSupportOngoingOffers = (offers) =>
    Array.isArray(offers) ? offers.filter(isSupportOfferOngoing) : [];

  const getSupportOfferRejectionReason = (offer) =>
    offer?.borrower_rejection?.reason ||
    offer?.borrower_notes ||
    offer?.rejection_reason ||
    "No reason provided";

  const renderSupportAuditPanel = (loanType, loan) => {
    if (!isSupportMode) {
      return null;
    }

    return (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          openSupportLenderActivity(loanType, loan);
        }}
        style={{
          width: "100%",
          textAlign: "left",
          marginTop: "10px",
          padding: "10px",
          borderRadius: "10px",
          border: "1px solid #dbe7f5",
          background: "#f7fbff",
          color: "#24415f",
          fontSize: "12px",
          lineHeight: 1.45,
          cursor: "pointer",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 8,
            fontWeight: 800,
            color: "#0e5aa5",
            marginBottom: 6,
          }}
        >
          <span>Lender activity</span>
          <span>View details</span>
        </div>
        <div>
          <strong>Viewed:</strong>{" "}
          {formatAuditLenderList(loan?.viewed_by_lenders)}
        </div>
        <div>
          <strong>Downloaded:</strong>{" "}
          {formatAuditLenderList(loan?.downloaded_by_lenders)}
        </div>
        {(loanType === "corporate" || loanType === "personal") && (
          <div>
            <strong>Expressed interest:</strong>{" "}
            {formatAuditLenderList(loan?.interested_lenders)}
          </div>
        )}
        <div>
          <strong>Offered:</strong> {formatAuditLenderList(loan?.offer_lenders)}
        </div>
        <div>
          <strong>Declined by lenders:</strong>{" "}
          {formatAuditLenderList(loan?.rejected_by_lenders)}
        </div>
        <div>
          <strong>Offers rejected by borrower:</strong>{" "}
          {formatAuditLenderList(loan?.rejected_lenders)}
        </div>
        <div>
          <strong>Ongoing:</strong>{" "}
          {formatAuditLenderList(loan?.ongoing_lenders)}
        </div>
      </button>
    );
  };


  const parseMaybeJson = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value;
    if (typeof value !== "string") return null;

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  };

  const getPersonalLoanMyInfoFullName = (loan) => {
    const possibleMyInfoPayloads = [
      loan?.myinfo_data,
      loan?.borrower?.myinfo_data,
      loan?.borrower_summary?.myinfo_data,
      loan?.borrower_data?.myinfo_data,
    ];

    for (const payload of possibleMyInfoPayloads) {
      const parsed = parseMaybeJson(payload);
      const fullName =
        parsed?.name?.value ||
        getPersonData(parsed)?.name?.value ||
        parsed?.entity?.["basic-profile"]?.["entity-name"]?.value;

      if (fullName) {
        return fullName;
      }
    }

    return null;
  };

  const getPersonalLoanName = (loan) =>
    getPersonalLoanMyInfoFullName(loan) ||
    loan?.borrower_summary?.name ||
    loan?.borrower?.entity_name ||
    loan?.borrower?.principal_name ||
    loan?.principal_name ||
    "Borrower";

  const getPersonalLoanUserId = (loan) =>
    loan?.user_id || loan?.borrower_id || loan?.borrower?.user_id;

  const buildSupportBorrowerProfilePayload = (loan, fallbackName) => {
    const borrower = loan?.borrower_data || loan?.borrower || {};
    const summary = loan?.borrower_summary || {};
    const userId =
      loan?.user_id ||
      loan?.borrower_id ||
      borrower?.user_id ||
      summary?.user_id;
    const singpassPayload =
      borrower?.singpass_data ||
      summary?.singpass_data ||
      loan?.singpass_data ||
      loan?.borrower_data?.singpass_data;
    const myinfoPayload =
      borrower?.myinfo_data ||
      summary?.myinfo_data ||
      loan?.myinfo_data ||
      loan?.borrower_data?.myinfo_data;
    const displayName =
      fallbackName ||
      summary?.borrower_display_name ||
      summary?.name ||
      borrower?.borrower_display_name ||
      borrower?.entity_name ||
      borrower?.principal_name ||
      loan?.principal_name ||
      "Borrower";

    return {
      ...summary,
      ...borrower,
      user_id: userId,
      company_name:
        fallbackName ||
        borrower?.entity_name ||
        borrower?.principal_name ||
        summary?.name ||
        loan?.principal_name ||
        displayName,
      borrower_display_name: displayName,
      email: borrower?.email || summary?.email || loan?.email || "",
      mobile_no:
        borrower?.mobile_no ||
        summary?.mobile_no ||
        loan?.mobile_no ||
        loan?.contact_phone ||
        "",
      registered_at:
        borrower?.created_at ||
        borrower?.registered_at ||
        summary?.registered_at ||
        loan?.registered_at ||
        loan?.created_at,
      bti_rating:
        borrower?.credit_score ??
        borrower?.bti_rating ??
        summary?.bti_rating ??
        loan?.bti_rating ??
        loan?.credit_score,
      support_status:
        borrower?.support_status ?? summary?.support_status ?? loan?.support_status,
      support_follow_up_date:
        borrower?.support_follow_up_date ??
        summary?.support_follow_up_date ??
        loan?.support_follow_up_date,
      support_is_favourite: Boolean(
        borrower?.support_is_favourite ||
          summary?.support_is_favourite ||
          loan?.support_is_favourite
      ),
      assigned_support_id:
        borrower?.assigned_support_id ??
        summary?.assigned_support_id ??
        loan?.assigned_support_id,
      assigned_support_name:
        borrower?.assigned_support_name ??
        summary?.assigned_support_name ??
        loan?.assigned_support_name,
      employee_id: borrower?.employee_id ?? summary?.employee_id ?? loan?.employee_id,
      employee_name:
        borrower?.employee_name ?? summary?.employee_name ?? loan?.employee_name,
      singpass_data: singpassPayload,
      myinfo_data: myinfoPayload,
      has_singpass_data: Boolean(
        borrower?.has_singpass_data || summary?.has_singpass_data || singpassPayload
      ),
      has_myinfo_data: Boolean(
        borrower?.has_myinfo_data || summary?.has_myinfo_data || myinfoPayload
      ),
      has_cbs_report: Boolean(
        borrower?.has_cbs_report ||
          summary?.has_cbs_report ||
          loan?.has_cbs_report ||
          borrower?.credit_report ||
          borrower?.credit_report_data ||
          loan?.credit_report_data
      ),
    };
  };

  const getSupportLenderAllowedProducts = (lender) => {
    const products = lender?.lender_allowed_products;
    if (Array.isArray(products)) return products;
    if (typeof products === "string") {
      try {
        const parsed = JSON.parse(products);
        if (Array.isArray(parsed)) return parsed;
      } catch {
        return products
          .split(",")
          .map((product) => product.trim())
          .filter(Boolean);
      }
    }
    return [];
  };

  const getSupportLenderOptions = (loanType) =>
    supportLenders
      .filter((lender) => {
        const allowedProducts = getSupportLenderAllowedProducts(lender);
        return (
          allowedProducts.length === 0 || allowedProducts.includes(loanType)
        );
      })
      .map((lender) => ({
        value: lender.user_id,
        label:
          lender.name ||
          lender.entity_name ||
          lender.principal_name ||
          lender.email ||
          lender.user_id,
      }));

  const ensureSupportLenderSelected = () => {
    if (!isSupportMode) return true;
    if (selectedSupportLenderId) return true;
    message.error("Please select the lender you are making this offer on behalf of.");
    return false;
  };

  const renderSupportLenderSelect = (loanType) => {
    if (!isSupportMode) return null;

    return (
      <div className="sl-loan-modal-field full">
        <div style={{ fontWeight: 700, marginBottom: 6 }}>
          Making offer on behalf of
        </div>
        <Select
          showSearch
          style={{ width: "100%" }}
          value={selectedSupportLenderId || undefined}
          loading={supportLendersLoading}
          placeholder="Select lender"
          optionFilterProp="label"
          onChange={setSelectedSupportLenderId}
          options={getSupportLenderOptions(loanType)}
        />
      </div>
    );
  };

  const getPropertyLoanName = (loan) =>
    loan?.borrower_data?.entity_name ||
    loan?.borrower_data?.principal_name ||
    loan?.borrower?.entity_name ||
    loan?.borrower?.principal_name ||
    "Borrower";

  const getPropertyLoanUserId = (loan) =>
    loan?.user_id ||
    loan?.borrower_data?.user_id ||
    loan?.borrower?.user_id;

  const openPersonalOfferModal = (loan) => {
    const requestedDocs = loan?.my_offer?.offer_data?.requested_documents?.map(
      (doc) => (typeof doc === "string" ? doc : doc?.name)
    ) || [""];
    setPersonalOfferForm({
      amount: loan?.amount ?? "",
      rate_pa: MONEY_LENDER_INTEREST_RATE_PM,
      tenor_months: loan?.desired_tenor_months ?? "",
    });
    setPersonalOfferMessage("");
    setPersonalOfferDocuments(requestedDocs.length ? requestedDocs : [""]);
    setSelectedSupportLenderId("");
    setPersonalOfferModal({ open: true, loan });
  };

  const closePersonalOfferModal = () => {
    setPersonalOfferModal({ open: false, loan: null });
    setPersonalOfferForm({
      amount: "",
      rate_pa: MONEY_LENDER_INTEREST_RATE_PM,
      tenor_months: "",
    });
    setPersonalOfferMessage("");
    setPersonalOfferDocuments([""]);
    setSelectedSupportLenderId("");
  };

  const submitPersonalOffer = async () => {
    if (!personalOfferModal.loan) return;
    if (!ensureSupportLenderSelected()) return;
    try {
      setPersonalOfferBusy(true);
      const requested_documents = personalOfferDocuments
        .map((doc) => (doc || "").trim())
        .filter(Boolean)
        .map((doc) => ({ name: doc }));
      const response = await fetch(
        isSupportMode
          ? "https://www.smart-lend.com/api/support/loans/offers/on-behalf"
          : "https://www.smart-lend.com/api/personalLoans/offers/upsert",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${
              isSupportMode ? Cookies.get("support_token") : Cookies.get("token")
            }`,
          },
          body: JSON.stringify({
            loan_type: "personal",
            lender_user_id: selectedSupportLenderId || undefined,
            personal_loan_request_id: personalOfferModal.loan.id,
            offer_data: {
              amount: Number(personalOfferForm.amount),
              rate_pa: MONEY_LENDER_INTEREST_RATE_PM,
              rate_pm: MONEY_LENDER_INTEREST_RATE_PM,
              tenor_years: Number(personalOfferForm.tenor_months) / 12,
              processing_fee: PERSONAL_LOAN_PROCESSING_FEE_RATE,
              requested_documents,
            },
            lender_message: personalOfferMessage || null,
          }),
        }
      );

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data?.message || "Unable to submit offer.");
      }

      message.success("Personal loan offer submitted.");
      closePersonalOfferModal();
      fetchPersonalLoans();
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to submit offer.");
    } finally {
      setPersonalOfferBusy(false);
    }
  };

  const handlePersonalDocumentChange = (value, index) => {
    setPersonalOfferDocuments((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  };

  const addPersonalDocument = () => {
    setPersonalOfferDocuments((prev) => [...prev, ""]);
  };

  const removePersonalDocument = (indexToRemove) => {
    setPersonalOfferDocuments((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const openPersonalRejectionModal = async (loan) => {
    setPersonalRejectionModal({ open: true, loan });
    if (personalRejectionOptions.length === 0) {
      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/personalLoans/options/rejection-reasons",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setPersonalRejectionOptions(data.options || []);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const closePersonalRejectionModal = () => {
    setPersonalRejectionModal({ open: false, loan: null });
    setPersonalRejectionForm({ reason: undefined, notes: "" });
  };

  const submitPersonalRejection = async () => {
    if (!personalRejectionModal.loan) return;
    try {
      setPersonalRejectionBusy(true);
      const response = await fetch(
        `https://www.smart-lend.com/api/personalLoans/${personalRejectionModal.loan.id}/reject`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            reason: personalRejectionForm.reason,
            notes: personalRejectionForm.notes,
          }),
        }
      );
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data?.message || "Unable to reject request.");
      }
      message.success("Personal loan request rejected.");
      const rejectedLoanId = personalRejectionModal.loan.id;
      setPersonalLoans((prev) =>
        prev.map((loan) => loan.id === rejectedLoanId
          ? { ...loan, rejected_by_me: true } : loan)
      );
      closePersonalRejectionModal();
      fetchPersonalLoans();
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to reject request.");
    } finally {
      setPersonalRejectionBusy(false);
    }
  };

  const openPropertyOfferModal = (loan) => {
    const loanData = normalizePropertyLoanData(loan);
    const requestedDocs =
      loan?.my_offer?.offer_data?.requested_documents?.map((doc) =>
        typeof doc === "string" ? doc : doc?.name
      ) || [""];
    setPropertyOfferForm({
      amount: loanData?.loanAmount ?? "",
      rate_pa: "",
      tenor_years: getPropertyLoanTenorMonths(loanData)
        ? getPropertyLoanTenorMonths(loanData) / 12
        : "",
    });
    setPropertyOfferMessage("");
    setPropertyOfferDocuments(requestedDocs.length ? requestedDocs : [""]);
    setSelectedSupportLenderId("");
    setPropertyOfferModal({ open: true, loan });
  };

  const closePropertyOfferModal = () => {
    setPropertyOfferModal({ open: false, loan: null });
    setPropertyOfferForm({ amount: "", rate_pa: "", tenor_years: "" });
    setPropertyOfferMessage("");
    setPropertyOfferDocuments([""]);
    setSelectedSupportLenderId("");
  };

  const submitPropertyOffer = async () => {
    if (!propertyOfferModal.loan) return;
    if (!ensureSupportLenderSelected()) return;
    try {
      setPropertyOfferBusy(true);
      const requested_documents = propertyOfferDocuments
        .map((doc) => (doc || "").trim())
        .filter(Boolean)
        .map((doc) => ({ name: doc }));
      const response = await fetch(
        isSupportMode
          ? "https://www.smart-lend.com/api/support/loans/offers/on-behalf"
          : "https://www.smart-lend.com/api/propTermLoan/createPropLoanOffers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${
              isSupportMode ? Cookies.get("support_token") : Cookies.get("token")
            }`,
          },
          body: JSON.stringify({
            loan_type: "property",
            lender_user_id: selectedSupportLenderId || undefined,
            prop_loan_request_id: propertyOfferModal.loan.id,
            offer_data: {
              amount: Number(propertyOfferForm.amount),
              ...propertyLoanProcessingFeeTerms(propertyOfferForm.amount),
              rate_pa: Number(propertyOfferForm.rate_pa),
              tenor_years: Number(propertyOfferForm.tenor_years),
              requested_documents,
            },
            lender_message: propertyOfferMessage || null,
          }),
        }
      );

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data?.message || "Unable to submit offer.");
      }

      message.success("Property loan offer submitted.");
      closePropertyOfferModal();
      fetchPropertyLoans();
      if (!isSupportMode) {
        history.push("/pending-acceptance");
      }
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to submit offer.");
    } finally {
      setPropertyOfferBusy(false);
    }
  };

  const handlePropertyDocumentChange = (value, index) => {
    setPropertyOfferDocuments((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  };

  const addPropertyDocument = () => {
    setPropertyOfferDocuments((prev) => [...prev, ""]);
  };

  const removePropertyDocument = (indexToRemove) => {
    setPropertyOfferDocuments((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const openPropertyRejectionModal = async (loan) => {
    setPropertyRejectionModal({ open: true, loan });
    if (propertyRejectionOptions.length === 0) {
      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/propTermLoan/options/rejection-reasons",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setPropertyRejectionOptions(data.options || []);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const closePropertyRejectionModal = () => {
    setPropertyRejectionModal({ open: false, loan: null });
    setPropertyRejectionForm({ reason: undefined, notes: "" });
  };

  const submitPropertyRejection = async () => {
    if (!propertyRejectionModal.loan) return;
    try {
      setPropertyRejectionBusy(true);
      const response = await fetch(
        `https://www.smart-lend.com/api/propTermLoan/${propertyRejectionModal.loan.id}/reject`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            reason: propertyRejectionForm.reason,
            notes: propertyRejectionForm.notes,
          }),
        }
      );
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data?.message || "Unable to reject request.");
      }
      message.success("Property loan request rejected.");
      const rejectedLoanId = propertyRejectionModal.loan.id;
      setPropertyLoans((prev) => prev.map((loan) => loan.id === rejectedLoanId
        ? { ...loan, rejected_by_me: true } : loan));
      closePropertyRejectionModal();
      fetchPropertyLoans();
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to reject request.");
    } finally {
      setPropertyRejectionBusy(false);
    }
  };

  const calculateCountdown = (expiredDate) => {
    const now = new Date().getTime();
    const targetDate = new Date(expiredDate).getTime();
    const timeDiff = targetDate - now;

    if (timeDiff <= 0) {
      return "Expired";
    }

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

    return `${days}d: ${hours}h: ${minutes}m`;
  };

  const isExpiredDate = (date) => calculateCountdown(date) === "Expired";

  const calculateThirtyDayCountdown = (createdAt) => {
    if (!createdAt) return "";
    const targetDate = new Date(createdAt);
    targetDate.setDate(targetDate.getDate() + 30);
    return calculateCountdown(targetDate);
  };

  const isExpiredThirtyDaysAfterCreation = (createdAt) => {
    if (!createdAt) return false;
    const targetDate = new Date(createdAt);
    targetDate.setDate(targetDate.getDate() + 30);
    return isExpiredDate(targetDate);
  };

  const eligibleForBizcap = (creditReport, singpass) => {
    if (userDetails) {
      let eligibilityCode = 0;
      const creditReportData = creditReport;
      const singpassData = JSON.parse(singpass);

      const registrationDateString =
        singpassData?.entity?.["basic-profile"]?.["registration-date"]?.value;

      const companyName =
        singpassData?.entity?.["basic-profile"]?.[
          "entity-name"
        ]?.value?.toLowerCase();

      const primaryActivityCode =
        singpassData?.entity?.["basic-profile"]?.[
          "primary-activity"
        ]?.code?.toString();

      const CBSRating = creditReportData?.RiskGrade;
      const bankruptcyProceedings = creditReportData?.bankcruptcyProceedings;
      const revenue = userDetails?.estimated_annual_revenue || "under 200k";

      // --- INDUSTRY EXCLUSIONS ---
      const disallowedPrefixes = [
        "643",
        "649",
        "641",
        "663",
        "80",
        "801",
        "802",
        "81",
      ];
      const disallowedExact = [
        "66122",
        "66123",
        "66124",
        "66126",
        "66129",
        "77101",
      ];

      const hasDisallowedPrefix = disallowedPrefixes.some((prefix) =>
        primaryActivityCode?.startsWith(prefix)
      );
      const isDisallowedExact = disallowedExact.includes(primaryActivityCode);

      if (primaryActivityCode && (hasDisallowedPrefix || isDisallowedExact)) {
        return 0;
      }

      if (registrationDateString && companyName) {
        const registrationDate = new Date(registrationDateString);
        const now = new Date();
        const monthsSinceIncorporation =
          (now.getFullYear() - registrationDate.getFullYear()) * 12 +
          (now.getMonth() - registrationDate.getMonth());

        const hasValidEntityType =
          companyName.includes("pte") || companyName.includes("llp");

        if (!hasValidEntityType || bankruptcyProceedings !== 0) {
          eligibilityCode = 0;
        } else {
          // ----------------- START-UP (Less than 12 months) -----------------
          if (monthsSinceIncorporation < 12) {
            if (revenue !== "under 200k") {
              eligibilityCode = 1;
            }
          }

          // ----------------- GROWING START-UP (12–47 months) -----------------
          else if (
            monthsSinceIncorporation >= 12 &&
            monthsSinceIncorporation < 48
          ) {
            const badRatings = ["HH", "GG", "FF"];
            if (
              !badRatings.includes(CBSRating) &&
              revenue !== "under 200k" &&
              revenue !== "between 200 and 599"
            ) {
              eligibilityCode = 2;
            }
          }

          // ----------------- ESTABLISHED BUSINESS (48+ months) -----------------
          else if (monthsSinceIncorporation >= 48) {
            const worseRatings = ["HH", "GG", "FF", "DD", "EE"];
            if (
              !worseRatings.includes(CBSRating) &&
              revenue !== "under 200k" &&
              revenue !== "between 200 and 599" &&
              revenue !== "between 600 and 2"
            ) {
              eligibilityCode = 3;
            }
          }
        }
      }

      return eligibilityCode;
    }
  };

  const Container = ({
    icon,
    title,
    subtitle,
    label,
    description,
    label1,
    label2,
    description1,
    description2,
    index,
    credit_score,
    loan_id,
    userId,
    loanOfferCount,
    countDown,
    createdAt,
    onClickModal,
    item,
  }) => {
    const openSupportBorrowerProfile = () => {
      if (!isSupportMode || !onOpenBorrowerProfile || !item?.user_id) {
        return false;
      }

      onOpenBorrowerProfile(
        buildSupportBorrowerProfilePayload(item, item.principal_name)
      );
      return true;
    };
    const preferredRate =
      item.request_interest_rate === 2
        ? "1.1% - 2%"
        : item.request_interest_rate === 3
        ? "2.1% - 3%"
        : "3.1% - 5%";
    const processingFee =
      item.admin_fee === 3
        ? "1% - 3%"
        : item.admin_fee === 5
        ? "3.1% - 5%"
        : "5.1% - 7%";
    const itemIsNoContact = isNoContactLoan(item);
    const itemIsExpired = isExpiredDate(countDown);
    const itemIsRejected = !isSupportMode &&
      (isTruthyFlag(item?.rejected_by_me) || notInterestedIds.includes(loan_id));
    const itemBlocksActions = (itemIsExpired || itemIsRejected) && !isSupportMode;
    const corporateTooltipTop = itemIsExpired ? 56 : 20;
    const loanRemark = parseLoanRemark(item.loan_remark);
    const loanRemarkIsGood = loanRemark?.type === "Good";
    const cardTooltipProps = {
      placement: "bottomLeft",
      overlayStyle: { maxWidth: 280 },
      getPopupContainer: () => document.body,
    };
    return (
      <>
        <div
          className={
            `sl-rebrand-loan-card sl-corporate-loan-card ${
              itemIsNoContact ? "sl-concierge-loan-card" : ""
            } ${
              getSupportLoanCardClass(item, "corporate")
            } ${itemIsRejected ? "sl-lender-rejected" : ""} ${
              eligibleForBizcap(item.credit_report_data, item.singpass_data) &&
              userDetails?.user_id === "L66489"
                ? "blinking-background"
                : ""
            }`
          }
          style={{
            width: "100%",
            textAlign: "center",
            border:
              subtitle === "Express Applicant"
                ? "1px solid rgb(242, 193, 80)"
                : "none",
            borderRadius: "10px",
            backgroundColor: "#ffffffb3", // default value
            display: "inline-block",
            flexDirection: "column",
            justifyContent: "center",
            minHeight: screenWidth > 1200 ? "40vh" : "auto",
            position: "relative",
            height: "auto",
            cursor: itemBlocksActions ? "not-allowed" : "pointer",
            marginBottom: "15px",
            breakInside: "avoid",
            WebkitColumnBreakInside: "avoid",
            pageBreakInside: "avoid",
          }}
          onClick={() => {
            if (itemBlocksActions) {
              return;
            }

            if (openSupportBorrowerProfile()) {
              return;
            }

            console.log(getPersonData(JSON.parse(item.singpass_data))?.name?.value);
            setIsPersonalLoanProfile(false);
            setBankAnalysisContext({
              loanId: item.loan_id,
              loanType: "corporate",
              enabled: Boolean(item?.precheck),
            });
            setBadgeVerified(item.badge_verified);
            setBackupContact(item.user_id);
            setHideContactInfo(shouldHideProfileContactInfo(item));
            const dataToPush = [
              {
                name: getPersonData(JSON.parse(item.singpass_data))?.name?.value,
                cbs_data: item.credit_report_data,
              },
            ];
            for (const dat of item.loan_authorizations) {
              dataToPush.push({
                name: dat.director_name,
                cbs_data: dat.credit_report_data,
              });
            }
            console.log(dataToPush);
            setAllCBSData(dataToPush);
            singpassDetails(
              item.user_id,
              item.authorization_required,
              item.loan_id,
              item.keyman,
              item.notes,
              item.platform_notes,
              item.loan_remark
            );
            recordLoanMarketplaceAudit("corporate", item.loan_id, "viewed");
          }}
        >
          <div className="sl-countdown-badge">
            {calculateCountdown(countDown)}
          </div>
          {itemIsNoContact ? (
            <Tooltip
              {...cardTooltipProps}
              title="The borrower has opt-in to our concierge service where SmartLend will provide a personalized service to the borrower to match them with the right lender, if you're interested in making an offer to this borrower, you can click on the express interest button below and our concierge team will be in touch with you shortly."
            >
              <div
                className={`sl-loan-card-tooltip ${
                  itemIsExpired ? "is-expired" : ""
                }`}
                style={{
                  position: "absolute",
                  top: corporateTooltipTop,
                  right: 20,
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#5d24c7",
                  zIndex: 40,
                }}
              >
                <AutoAwesomeIcon
                  className="tooltip-target"
                  style={{ color: "white", fontSize: "16px" }}
                />
              </div>
            </Tooltip>
          ) : loanRemark ? (
            <Tooltip {...cardTooltipProps} title={loanRemark.message}>
              <div
                className={`sl-loan-card-tooltip ${
                  itemIsExpired ? "is-expired" : ""
                }`}
                style={{
                  position: "absolute",
                  top: corporateTooltipTop,
                  right: 20,
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: loanRemarkIsGood ? "rgb(14, 90, 165)" : "red",
                  zIndex: 40,
                }}
              >
                {loanRemarkIsGood ? (
                  <AutoAwesomeIcon
                    className="tooltip-target"
                    style={{ color: "white", fontSize: "16px" }}
                  />
                ) : (
                  <GppMaybeIcon
                    className="tooltip-target"
                    style={{ color: "white", fontSize: "16px" }}
                  />
                )}
              </div>
            </Tooltip>
          ) : null}
          <div
            style={{ borderRadius: "12px", overflow: "visible" }}
            className={
              itemIsNoContact
                ? "animated-border-container-concierge"
                : isSlCreatedLoan(item)
                ? "animated-border-container-sl-created"
                : loanRemark
                ? loanRemark.type === "Good"
                  ? "animated-border-container"
                  : loanRemark.type === "Bad"
                  ? "animated-border-container-red"
                  : ""
                : ""
            }
          >
            <div className="main_inner_content">

              <div
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  display: subtitle === "Express Applicant" ? "block" : "none",
                }}
              >
                <StarIcon
                  style={{ color: "rgba(242, 193, 80)", fontSize: "25px" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  width: "100%",
                  position: "relative",
                }}
              >
                <div
                  className={
                    isSlCreatedLoan(item)
                      ? "animated-border-container-round-sl-created"
                      : "animated-border-container-round"
                  }
                  style={{
                    position: "absolute",
                    height: "60px",
                    width: "60px",
                    top: "50%",
                    transform: "translate(0, -50%)",
                    left: "-2.5px",
                    borderRadius: "50%",
                  }}
                ></div>
                <div
                  className="step1s main_inner_content sl-loan-avatar"
                  style={{
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    background: isSlCreatedLoan(item)
                      ? "#d4380d"
                      : "rgb(140,140,170)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: itemBlocksActions ? "not-allowed" : "pointer",
                    color: "white",
                    fontSize: 20,
                    fontWeight: 600,
                    position: "relative",
                    zIndex: 20,
                  }}
                  onClick={() => {
                    if (itemBlocksActions) {
                      return;
                    }

                    if (openSupportBorrowerProfile()) {
                      return;
                    }

                    console.log(
                      getPersonData(JSON.parse(item.singpass_data))?.name?.value
                    );
                    setIsPersonalLoanProfile(false);
                    setBadgeVerified(item.badge_verified);
                    setBackupContact(item.user_id);
                    setHideContactInfo(shouldHideProfileContactInfo(item));
                    const dataToPush = [
                      {
                        name: getPersonData(JSON.parse(item.singpass_data))?.name
                          ?.value,
                        cbs_data: item.credit_report_data,
                      },
                    ];
                    for (const dat of item.loan_authorizations) {
                      dataToPush.push({
                        name: dat.director_name,
                        cbs_data: dat.credit_report_data,
                      });
                    }
                    console.log(dataToPush);
                    setAllCBSData(dataToPush);
                    singpassDetails(
                      item.user_id,
                      item.authorization_required,
                      item.loan_id,
                      item.keyman,
                      item.notes,
                      item.platform_notes,
                      item.loan_remark
                    );
                    recordLoanMarketplaceAudit(
                      "corporate",
                      item.loan_id,
                      "viewed"
                    );
                  }}
                >
                  {title ? getInitials(title) : "SL"}
                  {item.badge_verified ? (
                    <div
                      className="tooltip-container sl-verified-badge-tooltip"
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "rgb(14, 90, 165)",
                      }}
                    >
                      <LocalPoliceIcon
                        className="tooltip-target"
                        style={{ color: "white", fontSize: "14px" }}
                      />
                      <span className="tooltip-text" style={{ color: "white" }}>
                        Verified borrowers have undergone SmartLend's
                        authentication process, demonstrating legitimate
                        business operations. This includes providing evidence
                        such as current tenancy agreements, business premises
                        signage, or recent invoices matching their bank
                        statements
                      </span>
                    </div>
                  ) : null}
                </div>
                <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
                  <h3
                    style={{
                      fontWeight: "700",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "16px",
                      color: "#142C44CC",
                      textAlign: "left",
                      margin: "0px",
                    }}
                  >
                    {title.length > 20 ? title.slice(0, 20) + "..." : title}
                  </h3>
                  <p
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "600",
                      fontSize: "12px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                      margin: "0px",
                    }}
                  >
                    Corporate Loan
                  </p>
                  {isSupportMode ? <SupportLoanStatusPills loan={item} loanType="corporate" /> : null}
                  <tooltip
                    placement="topRight"
                    title="This application qualifies for our 24-hour service 
guarantee based on our credit scoring. Be the first to fund them within 24 hours!"
                  >
                    <p
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: "600",
                        fontSize: "14px",
                        color: "rgba(0,0,0,0.4)",
                        textAlign: "left",
                        margin: "0px",
                      }}
                    >
                      {item.badge_verified ? subtitle : null}
                    </p>
                  </tooltip>
                </div>
              </div>
              <div
                className="sl-loan-card-body"
              >
                <div className="sl-amount-block">
                  <span className="sl-field-label">Requested amount</span>
                  <div className="sl-loan-amount">{description1}</div>
                </div>
                <div className="sl-field-grid">
                  <div className="sl-field">
                    <p className="sl-field-label">Preferred rate</p>
                    <p className="sl-field-value">{preferredRate}</p>
                  </div>
                  <div className="sl-field">
                    <p className="sl-field-label">Preferred tenor</p>
                    <p className="sl-field-value">{description2}</p>
                  </div>
                  <div className="sl-field">
                    <p className="sl-field-label">Processing fee</p>
                    <p className="sl-field-value">{processingFee}</p>
                  </div>
                </div>
                <div className="sl-loan-card-meta">
                  <span className="sl-tag-green">{loanOfferCount}</span>
                  <span>{item?.keen_interest || 0} lenders keen</span>
                  <span>Applied {formatDate(createdAt)}</span>
                </div>
                {renderSupportAuditPanel("corporate", item)}
              </div>
              {/* <div style={{ marginBottom: "10px" }}>
            <CountdownWithHover targetDate={targetDate} renderer={renderer} />
          </div> */}
              <>
                <div key={loan_id} className="sl-loan-card-actions">
                  {!itemBlocksActions ? (
                    <button
                      className="all_button"
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        downloadLoanDocuments(item?.loan_id);
                      }}
                      style={{
                        background: "transparent",
                        color: "grey",
                        width: "100%",
                        border: "2px solid lightgrey",
                        borderRadius: "15px",
                        padding: "4px 20px",
                        fontSize: "12px",
                        margin: "0px",
                      }}
                    >
                      Download Company Financial Information
                    </button>
                  ) : null}
                  {/* <button
                className="all_button"
                onClick={(event) => handleDownloadCreditReport(userId, event)}
                style={{
                  background: "transparent",
                  color: "grey",
                  width: "100%",
                  border: "2px solid lightgrey",
                  borderRadius: "15px",
                  padding: "4px 20px",
                  fontSize: "12px",
                  marginTop: "10px",
                }}
              >
                Download Financial Report
              </button> */}
                  {shouldShowLenderActions && !itemIsNoContact && !itemBlocksActions ? (
                    <button
                      className="all_button"
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        increaseKeenCount(item.loan_id);
                        const url = `/l-messages?principelname=${item.principal_name}&userid=${item.user_id}&requestamount=${item.request_amount}`;
                        history.push(url);
                      }}
                      style={{
                        background: "transparent",
                        color: "grey",
                        width: "100%",
                        border: "2px solid lightgrey",
                        borderRadius: "15px",
                        padding: "4px 20px",
                        fontSize: "12px",
                        marginTop: "10px",
                      }}
                    >
                      Message borrower
                    </button>
                  ) : null}
                  {isSupportMode ? (
                    <>
                      {renderSupportManageDocumentButton(
                        "corporate",
                        item,
                        itemBlocksActions
                      )}
                      <button
                        className="all_button"
                        disabled={itemBlocksActions}
                        onClick={(event) => {
                          event.stopPropagation();
                          event.preventDefault();
                          if (itemBlocksActions) {
                            message.warning(
                              "Expired loan requests cannot receive new lender offers."
                            );
                            return;
                          }
                          setSelectedSupportLenderId("");
                          const totalLoanedAmount = (Array.isArray(item.loan_offers)
                            ? item.loan_offers
                            : []
                          ).reduce(
                            (sum, offer) => sum + Number(offer.offer_amount || 0),
                            0
                          );
                          showModal(loan_id, totalLoanedAmount);
                        }}
                        style={{
                          background: itemBlocksActions ? "#d9d9d9" : "#0e5aa5",
                          color: "white",
                          width: "100%",
                          border: "none",
                          borderRadius: "50px",
                          padding: "6px 0px",
                          fontSize: "12px",
                          margin: "10px 0px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: itemBlocksActions ? "not-allowed" : "pointer",
                        }}
                      >
                        Make Lender Offer
                      </button>
                    </>
                  ) : null}
                  {shouldShowLenderActions && !itemIsNoContact && !itemBlocksActions ? (
                    <button
                      className="all_button"
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        const onGoingLoan = item.loan_offers.filter(
                          (offer) => offer.status === "accepted"
                        );
                        const totalLoanedAmount = item.loan_offers.reduce(
                          (sum, offer) => sum + offer.offer_amount,
                          0
                        );
                        console.log(totalLoanedAmount);
                        showModal(loan_id, totalLoanedAmount);
                      }}
                      // onClick={(event) => showModal(loan_id, event)}
                      style={{
                        background: "#7057F6",
                        color: "white",
                        width: "100%",
                        border: "none",
                        borderRadius: "50px",
                        padding: "6px 0px",
                        fontSize: "12px",
                        margin: "10px 0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Make an offer{" "}
                      <HourglassTopIcon
                        className="rotating_hourglass"
                        style={{
                          color: "white",
                          fontSize: "16px",
                          marginLeft: "5px",
                        }}
                      />
                    </button>
                  ) : null}
                  {shouldShowLenderActions && !itemIsNoContact && !itemBlocksActions ? (
                    <button
                      className="all_button"
                      style={{
                        background: "transparent",
                        color: "grey",
                        width: "100%",
                        border: "2px solid lightgrey",
                        borderRadius: "50px",
                        padding: "4px 0px",
                        fontSize: "12px",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        showModal2(loan_id, event);
                      }}
                    >
                      Not Interested?
                    </button>
                  ) : shouldShowLenderActions && itemIsRejected ? (
                    <div className="sl-lender-rejected-status" role="status">Rejected by you</div>
                  ) : shouldShowLenderActions && itemIsExpired ? (
                    <div
                      style={{
                        marginTop: "10px",
                        borderRadius: "12px",
                        background: "#fff7ed",
                        color: "#c2410c",
                        padding: "10px 12px",
                        fontSize: "12px",
                        fontWeight: 700,
                      }}
                    >
                      Expired case. Borrower actions are disabled.
                    </div>
                  ) : null}
                  {renderConciergeInterest("corporate", item, itemIsExpired)}
                </div>
              </>
            </div>
          </div>
        </div>
      </>
    );
  };

  const PersonalLoanCard = ({ loan }) => {
    const borrowerName = getPersonalLoanName(loan);
    const cardBackground = "#ffffffb3";
    const personalLoanNoContact = isNoContactLoan(loan);
    const personalLoanExpired = isExpiredThirtyDaysAfterCreation(loan?.created_at);
    const personalLoanRejected = !isSupportMode && isTruthyFlag(loan?.rejected_by_me);
    const personalLoanBlocksActions = (personalLoanExpired || personalLoanRejected) && !isSupportMode;
    const loanRemark = parseLoanRemark(loan?.loan_remark);
    const loanRemarkIsGood = loanRemark?.type === "Good";
    const personalLoanOfferCount =
      loan?.loan_offer_count ?? (Array.isArray(loan?.offers) ? loan.offers.length : 0);
    const personalLoanViewedCount =
      loan?.viewed_by_count ??
      (Array.isArray(loan?.viewed_by) ? loan.viewed_by.length : 0);
    const cardTooltipProps = {
      placement: "bottomLeft",
      overlayStyle: { maxWidth: 280 },
      getPopupContainer: () => document.body,
    };

    return (
      <div
        className={`sl-rebrand-loan-card sl-personal-loan-card ${
          personalLoanNoContact ? "sl-concierge-loan-card" : ""
        } ${
          getSupportLoanCardClass(loan, "personal")
        } ${personalLoanRejected ? "sl-lender-rejected" : ""}`}
        style={{
          width: "100%",
          textAlign: "center",
          borderRadius: "10px",
          backgroundColor: cardBackground,
          display: "inline-block",
          flexDirection: "column",
          justifyContent: "center",
          minHeight: screenWidth > 1200 ? "40vh" : "auto",
          position: "relative",
          height: "auto",
          marginBottom: "15px",
          breakInside: "avoid",
          WebkitColumnBreakInside: "avoid",
          pageBreakInside: "avoid",
        }}
      >
        <div className="sl-countdown-badge">
          {calculateThirtyDayCountdown(loan?.created_at)}
        </div>
        {personalLoanNoContact ? (
          <Tooltip
            {...cardTooltipProps}
            title="The borrower has opt-in to our concierge service where SmartLend will provide a personalized service to the borrower to match them with the right lender, if you're interested in making an offer to this borrower, you can click on the express interest button below and our concierge team will be in touch with you shortly."
          >
            <div
              className={`sl-loan-card-tooltip ${
                personalLoanExpired ? "is-expired" : ""
              }`}
              style={{
                position: "absolute",
                top: personalLoanExpired ? 56 : 20,
                right: 20,
                width: "25px",
                height: "25px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#5d24c7",
                zIndex: 40,
              }}
            >
              <AutoAwesomeIcon
                className="tooltip-target"
                style={{ color: "white", fontSize: "16px" }}
              />
            </div>
          </Tooltip>
        ) : loanRemark ? (
          <Tooltip {...cardTooltipProps} title={loanRemark.message}>
            <div
              className={`sl-loan-card-tooltip ${
                personalLoanExpired ? "is-expired" : ""
              }`}
              style={{
                position: "absolute",
                top: personalLoanExpired ? 56 : 20,
                right: 20,
                width: "25px",
                height: "25px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: loanRemarkIsGood ? "rgb(14, 90, 165)" : "red",
                zIndex: 40,
              }}
            >
              {loanRemarkIsGood ? (
                <AutoAwesomeIcon
                  className="tooltip-target"
                  style={{ color: "white", fontSize: "16px" }}
                />
              ) : (
                <GppMaybeIcon
                  className="tooltip-target"
                  style={{ color: "white", fontSize: "16px" }}
                />
              )}
            </div>
          </Tooltip>
        ) : null}
        <div
          className={
            loanRemark
              ? loanRemark.type === "Good"
                ? "animated-border-container"
                : loanRemark.type === "Bad"
                ? "animated-border-container-red"
                : ""
              : ""
          }
          style={{ borderRadius: "12px", overflow: "visible" }}
        >
          <div className="main_inner_content">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "100%",
                position: "relative",
              }}
            >
              <div
                className="animated-border-container-round"
                style={{
                  position: "absolute",
                  height: "60px",
                  width: "60px",
                  top: "50%",
                  transform: "translate(0, -50%)",
                  left: "-2.5px",
                  borderRadius: "50%",
                }}
              ></div>
              <div
                className="step1s main_inner_content sl-loan-avatar sl-loan-avatar-pink"
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  background: "var(--sl-pink-soft)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: personalLoanBlocksActions ? "not-allowed" : "pointer",
                  color: "var(--sl-pink)",
                  fontSize: 20,
                  fontWeight: 600,
                  position: "relative",
                  zIndex: 20,
                }}
                onClick={() => {
                  if (personalLoanBlocksActions) {
                    return;
                  }

                  openPersonalLoanProfile(loan);
                }}
              >
                {borrowerName ? getInitials(borrowerName) : "SL"}
              </div>
              <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
                <h3
                  style={{
                    fontWeight: "700",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "16px",
                    color: "#142C44CC",
                    textAlign: "left",
                    margin: "0px",
                  }}
                >
                  {borrowerName.length > 20
                    ? borrowerName.slice(0, 20) + "..."
                    : borrowerName}
                </h3>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "12px",
                    color: "rgba(0,0,0,0.4)",
                    textAlign: "left",
                    margin: "0px",
                  }}
                >
                  Money Lender Loan
                </p>
                {isSupportMode ? <SupportLoanStatusPills loan={loan} loanType="personal" /> : null}
              </div>
            </div>
            <div className="sl-loan-card-body">
              <div className="sl-amount-block">
                <span className="sl-field-label">Requested amount</span>
                <div className="sl-loan-amount">
                  {formatPersonalAmount(loan?.amount)}
                </div>
              </div>
              <div className="sl-field-grid">
                <div className="sl-field">
                  <p className="sl-field-label">Preferred rate</p>
                  <p className="sl-field-value">
                    {formatPersonalRate(MONEY_LENDER_INTEREST_RATE_PM)}
                  </p>
                </div>
                <div className="sl-field">
                  <p className="sl-field-label">Preferred tenor</p>
                  <p className="sl-field-value">
                    {formatPersonalTenor(loan?.desired_tenor_months)}
                  </p>
                </div>
                <div className="sl-field">
                  <p className="sl-field-label">Processing fee</p>
                  <p className="sl-field-value">
                    {PERSONAL_LOAN_PROCESSING_FEE_LABEL}
                  </p>
                </div>
              </div>
              <div className="sl-loan-card-meta">
                <span className="sl-tag-green">
                  {personalLoanOfferCount} Offering
                </span>
                <span>{personalLoanViewedCount} Viewed</span>
                <span>Applied {formatDate(loan?.created_at)}</span>
              </div>
              {renderSupportAuditPanel("personal", loan)}
            </div>
            <div className="sl-loan-card-actions">
              {(!personalLoanNoContact || isSupportMode) && !personalLoanBlocksActions ? (
                <button
                  className="all_button"
                  disabled={personalDownloadId === loan.id}
                  onClick={() => downloadPersonalLoanDocuments(loan)}
                  style={{
                    background: "transparent",
                    color: "grey",
                    width: "100%",
                    border: "2px solid lightgrey",
                    borderRadius: "15px",
                    padding: "4px 20px",
                    fontSize: "12px",
                    marginTop: "10px",
                    opacity: personalDownloadId === loan.id ? 0.6 : 1,
                    cursor:
                      personalDownloadId === loan.id ? "not-allowed" : "pointer",
                  }}
                >
                  {personalDownloadId === loan.id
                    ? "Preparing download..."
                    : "Download Borrower Documents"}
                </button>
              ) : null}
              {isSupportMode ? (
                <>
                  {renderSupportManageDocumentButton(
                    "personal",
                    loan,
                    personalLoanBlocksActions
                  )}
                  <button
                    className="all_button"
                    disabled={personalLoanBlocksActions}
                    onClick={() => {
                      if (personalLoanBlocksActions) {
                        message.warning(
                          "Expired loan requests cannot receive new lender offers."
                        );
                        return;
                      }
                      openPersonalOfferModal(loan);
                    }}
                    style={{
                      background: personalLoanBlocksActions ? "#d9d9d9" : "#CC3A8A",
                      color: "white",
                      width: "100%",
                      border: "none",
                      borderRadius: "50px",
                      padding: "6px 0px",
                      fontSize: "12px",
                      margin: "10px 0px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: personalLoanBlocksActions ? "not-allowed" : "pointer",
                    }}
                  >
                    Make Lender Offer
                  </button>
                </>
              ) : null}
              {shouldShowLenderActions && !personalLoanNoContact && !personalLoanBlocksActions ? (
                <>
                  <button
                    className="all_button"
                    onClick={() => {
                      const userId = getPersonalLoanUserId(loan);
                      if (!userId) return;
                      const url = `/l-messages?principelname=${borrowerName}&userid=${userId}&requestamount=${
                        loan?.amount || 0
                      }`;
                      history.push(url);
                    }}
                    style={{
                      background: "transparent",
                      color: "grey",
                      width: "100%",
                      border: "2px solid lightgrey",
                      borderRadius: "15px",
                      padding: "4px 20px",
                      fontSize: "12px",
                      marginTop: "10px",
                    }}
                  >
                    Message borrower
                  </button>
                  <button
                    className="all_button"
                    onClick={() => openPersonalOfferModal(loan)}
                    style={{
                      background: "#CC3A8A",
                      color: "white",
                      width: "100%",
                      border: "none",
                      borderRadius: "50px",
                      padding: "6px 0px",
                      fontSize: "12px",
                      margin: "10px 0px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Make an offer{" "}
                    <HourglassTopIcon
                      className="rotating_hourglass"
                      style={{
                        color: "white",
                        fontSize: "16px",
                        marginLeft: "5px",
                      }}
                    />
                  </button>
                  <button
                    className="all_button"
                    onClick={() => openPersonalRejectionModal(loan)}
                    style={{
                      background: "transparent",
                      color: "grey",
                      width: "100%",
                      border: "2px solid lightgrey",
                      borderRadius: "50px",
                      padding: "4px 0px",
                      fontSize: "12px",
                    }}
                  >
                    Reject offer
                  </button>
                </>
              ) : shouldShowLenderActions && personalLoanRejected ? (
                <div className="sl-lender-rejected-status" role="status">Rejected by you</div>
              ) : shouldShowLenderActions && personalLoanExpired ? (
                <div
                  style={{
                    marginTop: "10px",
                    borderRadius: "12px",
                    background: "#fff7ed",
                    color: "#c2410c",
                    padding: "10px 12px",
                    fontSize: "12px",
                    fontWeight: 700,
                  }}
                >
                  Expired case. Borrower actions are disabled.
                </div>
              ) : shouldShowLenderActions && personalLoanNoContact ? (
                <div
                  style={{
                    marginTop: "10px",
                    borderRadius: "12px",
                    background: "#f5f3ff",
                    color: "#6d28d9",
                    padding: "10px 12px",
                    fontSize: "12px",
                    fontWeight: 700,
                  }}
                >
                  Concierge case. SmartLend will coordinate borrower contact.
                </div>
              ) : null}
              {renderConciergeInterest("personal", loan, personalLoanExpired)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const PropertyLoanCard = ({ loan }) => {
    const borrowerName = getPropertyLoanName(loan);
    const cardBackground = "#ffffffb3";
    const loanData = normalizePropertyLoanData(loan);
    const loanTenorMonths = getPropertyLoanTenorMonths(loanData);
    const isRejected = !isSupportMode && isTruthyFlag(loan?.rejected_by_me);
    const propertyLoanExpired = isExpiredThirtyDaysAfterCreation(loan?.created_at);
    const propertyLoanBlocksActions = (propertyLoanExpired || isRejected) && !isSupportMode;

    return (
      <div
        className={`sl-rebrand-loan-card sl-property-loan-card ${getSupportLoanCardClass(loan, "property")} ${isRejected ? "sl-lender-rejected" : ""}`}
        role="article"
        aria-label={`Property loan application #${loan.id}`}
        style={{
          width: "100%",
          textAlign: "center",
          borderRadius: "10px",
          backgroundColor: cardBackground,
          display: "inline-block",
          flexDirection: "column",
          justifyContent: "center",
          minHeight: screenWidth > 1200 ? "40vh" : "auto",
          position: "relative",
          height: "auto",
          marginBottom: "15px",
          breakInside: "avoid",
          WebkitColumnBreakInside: "avoid",
          pageBreakInside: "avoid",
        }}
      >
        <div className="sl-countdown-badge">
          {calculateThirtyDayCountdown(loan?.created_at)}
        </div>
        <div style={{ borderRadius: "12px", overflow: "visible" }}>
          <div className="main_inner_content">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "100%",
                position: "relative",
              }}
            >
              <div
                className="animated-border-container-round"
                style={{
                  position: "absolute",
                  height: "60px",
                  width: "60px",
                  top: "50%",
                  transform: "translate(0, -50%)",
                  left: "-2.5px",
                  borderRadius: "50%",
                }}
              ></div>
              <div
                className="step1s main_inner_content sl-loan-avatar"
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  background: "#2f9e44",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: propertyLoanBlocksActions ? "not-allowed" : "pointer",
                  color: "white",
                  fontSize: 20,
                  fontWeight: 600,
                  position: "relative",
                  zIndex: 20,
                }}
                onClick={() => {
                  if (propertyLoanBlocksActions) {
                    return;
                  }

                  openPropertyLoanProfile(loan);
                }}
              >
                {borrowerName ? getInitials(borrowerName) : "SL"}
              </div>
              <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
                <h3
                  style={{
                    fontWeight: "700",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "16px",
                    color: "#142C44CC",
                    textAlign: "left",
                    margin: "0px",
                  }}
                >
                  {borrowerName.length > 20
                    ? borrowerName.slice(0, 20) + "..."
                    : borrowerName}
                </h3>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "12px",
                    color: "rgba(0,0,0,0.4)",
                    textAlign: "left",
                    margin: "0px",
                  }}
                >
                  Property Term Loan
                </p>
                {isSupportMode ? <SupportLoanStatusPills loan={loan} loanType="property" /> : null}
              </div>
            </div>
            <div className="sl-loan-card-body">
              <div className="sl-amount-block">
                <span className="sl-field-label">Requested amount</span>
                <div className="sl-loan-amount">
                  {formatPersonalAmount(loanData?.loanAmount)}
                </div>
              </div>
              <div className="sl-field-grid">
                <div className="sl-field">
                  <p className="sl-field-label">Preferred rate</p>
                  <p className="sl-field-value">
                    {getPropertyLoanInterestRange(loanData)}
                  </p>
                </div>
                <div className="sl-field">
                  <p className="sl-field-label">Preferred tenor</p>
                  <p className="sl-field-value">
                    {formatPersonalTenor(loanTenorMonths)}
                  </p>
                </div>
                <div className="sl-field">
                  <p className="sl-field-label">Processing fee</p>
                  <p className="sl-field-value">{PROPERTY_LOAN_PROCESSING_FEE_LABEL}</p>
                </div>
              </div>
              <div className="sl-loan-card-meta">
                <span>{getPropertyLoanTypeLabel(loanData)}</span>
                <span>Applied {formatDate(loan?.created_at)}</span>
              </div>
              {renderSupportAuditPanel("property", loan)}
            </div>
            <div className="sl-loan-card-actions">
              {!propertyLoanBlocksActions ? (
                <button
                  className="all_button"
                  disabled={propertyDownloadId === loan.id}
                  onClick={() => downloadPropertyLoanDocuments(loan)}
                  style={{
                    background: "transparent",
                    color: "grey",
                    width: "100%",
                    border: "2px solid lightgrey",
                    borderRadius: "15px",
                    padding: "4px 20px",
                    fontSize: "12px",
                    marginTop: "10px",
                    opacity: propertyDownloadId === loan.id ? 0.6 : 1,
                    cursor:
                      propertyDownloadId === loan.id ? "not-allowed" : "pointer",
                  }}
                >
                  {propertyDownloadId === loan.id
                    ? "Preparing download..."
                    : "Download Borrower Documents"}
                </button>
              ) : null}
              {isSupportMode ? (
                <>
                  {renderSupportManageDocumentButton(
                    "property",
                    loan,
                    propertyLoanBlocksActions
                  )}
                  <button
                    className="all_button"
                    disabled={propertyLoanBlocksActions}
                    onClick={() => {
                      if (propertyLoanBlocksActions) {
                        message.warning(
                          "Expired loan requests cannot receive new lender offers."
                        );
                        return;
                      }
                      openPropertyOfferModal(loan);
                    }}
                    style={{
                      background: propertyLoanBlocksActions ? "#d9d9d9" : "#2f9e44",
                      color: "white",
                      width: "100%",
                      border: "none",
                      borderRadius: "50px",
                      padding: "6px 0px",
                      fontSize: "12px",
                      margin: "10px 0px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: propertyLoanBlocksActions ? "not-allowed" : "pointer",
                    }}
                  >
                    Make Lender Offer
                  </button>
                </>
              ) : null}
              {shouldShowLenderActions && !propertyLoanBlocksActions ? (
                <>
                  <button
                    className="all_button"
                    onClick={() => {
                      const userId = getPropertyLoanUserId(loan);
                      if (!userId) return;
                      const url = `/l-messages?principelname=${borrowerName}&userid=${userId}&requestamount=${
                        loanData?.loanAmount || 0
                      }`;
                      history.push(url);
                    }}
                    style={{
                      background: "transparent",
                      color: "grey",
                      width: "100%",
                      border: "2px solid lightgrey",
                      borderRadius: "15px",
                      padding: "4px 20px",
                      fontSize: "12px",
                      marginTop: "10px",
                    }}
                  >
                    Message borrower
                  </button>
                  <button
                    className="all_button"
                    onClick={() => openPropertyOfferModal(loan)}
                    style={{
                      background: "#2f9e44",
                      color: "white",
                      width: "100%",
                      border: "none",
                      borderRadius: "50px",
                      padding: "6px 0px",
                      fontSize: "12px",
                      margin: "10px 0px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Make an offer{" "}
                    <HourglassTopIcon
                      className="rotating_hourglass"
                      style={{
                        color: "white",
                        fontSize: "16px",
                        marginLeft: "5px",
                      }}
                    />
                  </button>
                  <button
                    className="all_button"
                    onClick={() => openPropertyRejectionModal(loan)}
                    style={{
                      background: "transparent",
                      color: "grey",
                      width: "100%",
                      border: "2px solid lightgrey",
                      borderRadius: "50px",
                      padding: "4px 0px",
                      fontSize: "12px",
                    }}
                  >
                    Reject offer
                  </button>
                </>
              ) : shouldShowLenderActions && isRejected ? (
                <div className="sl-lender-rejected-status" role="status">Rejected by you</div>
              ) : shouldShowLenderActions && propertyLoanExpired ? (
                <div
                  style={{
                    marginTop: "10px",
                    borderRadius: "12px",
                    background: "#fff7ed",
                    color: "#c2410c",
                    padding: "10px 12px",
                    fontSize: "12px",
                    fontWeight: 700,
                  }}
                >
                  Expired case. Borrower actions are disabled.
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Move the fetching functionality into a separate function
  const fetchDataWithRunFilter = async () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + authToken);

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      setIsLoading(true);
      const response = await fetch(
        corporateLoanEndpoint,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const fetchedData = await response.json();
      console.log(fetchedData);
      const parsedData = fetchedData["Requested Loan"].map((item) => {
        // Parse credit_report_data in the main object
        const updatedItem = {
          ...item,
          credit_report_data: parseMaybeJson(item.credit_report_data) || {},
        };

        // Filter and parse credit_report_data in loan_authorizations array
        const updatedLoanAuthorizations = item.loan_authorizations
          .filter((item) => {
            const createdAtDate = new Date(item.created_at);
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

            // Return only if the created_at date is within the last 30 days
            return createdAtDate >= thirtyDaysAgo;
          })
          .map((authorization) => ({
            ...authorization,
            credit_report_data:
              parseMaybeJson(authorization.credit_report_data) || {},
          }));

        // Update the item with the updated loan_authorizations array
        updatedItem.loan_authorizations = updatedLoanAuthorizations;

        return updatedItem;
      });

      console.log(parsedData);

      if (parsedData && parsedData.length > 0) {
        setData(parsedData);

        const targetDate = new Date(parsedData[0].expired_date).getTime();
        setTargetDate(targetDate);
      }

      let filtered = parsedData;

      console.log(filtered);
      // Filter the parsedData based on the query parameters
      if (minLoanAmount) {
        filtered = filtered.filter(
          (item) => item.request_amount >= minLoanAmount
        );
      }
      if (maxLoanAmount) {
        filtered = filtered.filter(
          (item) => item.request_amount <= maxLoanAmount
        );
      }
      if (LoanPeriodMin) {
        filtered = filtered.filter(
          (item) => item.request_period >= LoanPeriodMin
        );
      }
      if (LoanPeriodMax) {
        filtered = filtered.filter(
          (item) => item.request_period <= LoanPeriodMax
        );
      }
      if (LoanInterestMin) {
        filtered = filtered.filter(
          (item) => item.request_interest_rate >= LoanInterestMin / 100
        );
      }
      if (LoanInterestMax) {
        filtered = filtered.filter(
          (item) => item.request_interest_rate <= LoanInterestMax / 100
        );
      }
      if (MinYearOfIncorp) {
        console.log(MinYearOfIncorp);
        filtered = filtered.filter(
          (item) =>
            calculateYearsFromNow(
              JSON.parse(item?.singpass_data)?.entity?.["basic-profile"]?.[
                "registration-date"
              ]?.value
            ) >= MinYearOfIncorp
        );
      }

      if (selectedIndustry) {
        const selectedGroup = findGroupByName(selectedIndustry);
        console.log(selectedGroup);
        if (selectedGroup) {
          filtered = filtered.filter((item) => {
            const ssicCode = JSON.parse(item.singpass_data).entity[
              "basic-profile"
            ]["primary-activity"].code;
            console.log(selectedGroup.value.includes(ssicCode));
            return selectedGroup.value.includes(ssicCode);
          });
        }
      }

      if (selectedCreditRating) {
        const selectedIndex = findRatingIndex(selectedCreditRating);
        console.log(selectedIndex);
        filtered = filtered.filter((item) => {
          const creditReportData = item.credit_report_data || {};
          const creditRating = creditReportData.RiskGrade
            ? creditReportData.RiskGrade.replace(/\s+/g, "")
            : null;
          if (creditRating === null) {
            return false; // Skip items with null or undefined RiskGrade
          }
          const itemRatingIndex = findRatingIndex(creditRating);
          console.log(itemRatingIndex);
          if (itemRatingIndex > -1 && selectedIndex > -1) {
            return itemRatingIndex <= selectedIndex;
          }
          return false; // Skip items where itemRatingIndex or selectedIndex is invalid
        });
      }

      if (loanCategoryFilters.length > 0) {
        filtered = filtered.filter((item) =>
          loanCategoryFilters.includes(item.category)
        );
      }
      // Set filteredData only if it's not empty
      console.log(filtered);
      if (filtered.length > 0) {
        setFilteredData(filtered);
      } else if (filtered !== parsedData) {
        setFilteredData([]);
        // console.log("no");
        setempty("1");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + authToken);

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      setIsLoading(true);
      const response = await fetch(
        corporateLoanEndpoint,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const fetchedData = await response.json();
      console.log(fetchedData);
      const parsedData = fetchedData["Requested Loan"].map((item) => {
        // Parse credit_report_data in the main object
        const updatedItem = {
          ...item,
          credit_report_data: parseMaybeJson(item.credit_report_data) || {},
        };

        // Filter and parse credit_report_data in loan_authorizations array
        const updatedLoanAuthorizations = item.loan_authorizations
          .filter((item) => {
            const createdAtDate = new Date(item.created_at);
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

            // Return only if the created_at date is within the last 30 days
            return createdAtDate >= thirtyDaysAgo;
          })
          .map((authorization) => ({
            ...authorization,
            credit_report_data:
              parseMaybeJson(authorization.credit_report_data) || {},
          }));

        // Update the item with the updated loan_authorizations array
        updatedItem.loan_authorizations = updatedLoanAuthorizations;

        return updatedItem;
      });

      console.log(parsedData);

      if (parsedData && parsedData.length > 0) {
        setData(parsedData);

        const targetDate = new Date(parsedData[0].expired_date).getTime();
        setTargetDate(targetDate);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPersonalLoans = async () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + authToken);

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      setIsPersonalLoansLoading(true);
      const response = await fetch(
        personalLoanEndpoint,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch personal loans");
      }

      const json = await response.json();
      setPersonalLoans(json.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsPersonalLoansLoading(false);
    }
  };

  const fetchPropertyLoans = async () => {
    try {
      setIsPropertyLoansLoading(true);
      const response = await fetch(
        propertyLoanEndpoint,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + authToken,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch property term loans");
      }

      const json = await response.json();
      setPropertyLoans(json.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsPropertyLoansLoading(false);
    }
  };

  const fetchSupportLenders = async () => {
    if (!isSupportMode) return;

    try {
      setSupportLendersLoading(true);
      const response = await fetch("https://www.smart-lend.com/api/support/lenders", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + Cookies.get("support_token"),
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Failed to fetch lenders");
      }

      setSupportLenders(json.lenders || []);
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to load lender list for support offers.");
    } finally {
      setSupportLendersLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchPersonalLoans();
  }, []);

  useEffect(() => {
    fetchPropertyLoans();
  }, []);

  useEffect(() => {
    fetchSupportLenders();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [dppicture, setdppicture] = useState([]);

  const fillAllLenderPpicture = async (index, lenderId) => {
    // try {
    //   const response = await fetch(
    //     `https://www.smart-lend.com/api/user/getLenderPicture?lender_id=${lenderId}`,
    //     {
    //       method: "GET",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${Cookies.get("token")}`,
    //       },
    //     }
    //   );
    //   const blob = await response.blob();
    //   const imageUrl = URL.createObjectURL(blob);
    //   setdppicture((prevDppicture) => {
    //     const updatedDppicture = [...prevDppicture]; // Create a copy of the array
    //     updatedDppicture[index] = { profilepicture: imageUrl }; // Update the specific index
    //     console.log(updatedDppicture);
    //     return updatedDppicture;
    //   });
    // } catch (error) {
    //   console.error(error);
    // }
  };

  useEffect(() => {
    if (filteredData) {
      filteredData
        .sort((a, b) => {
          if (
            notInterestedIds.includes(a.loan_id) &&
            !notInterestedIds.includes(b.loan_id)
          ) {
            return 1;
          }
          if (
            !notInterestedIds.includes(a.loan_id) &&
            notInterestedIds.includes(b.loan_id)
          ) {
            return -1;
          }
          // If express 1 must be top compare to express 0
          if (a.express !== b.express) {
            return b.express - a.express;
          }
          // Sorting based on the selection at the sort by option
          if (sortBy === "default") {
            // if user select the option recommend, then sort the data based on the request_amount from high to low
            return b.request_amount - a.request_amount;
          } else if (sortBy === "latest-request") {
            // if user select option latest request, sort the data by latest created_at to the not latest created_at
            return new Date(b.created_at) - new Date(a.created_at);
          }
          return 0;
        })
        .map((item, index) => {
          if (item.visibility) {
            if (calculateCountdown(item.expired_date) !== "Expired") {
              fillAllLenderPpicture(index, item.user_id);
            }
          }
        });
    } else {
      if (data && data.length > 0 && empty == "0") {
        data.map((item, index) => {
          if (item.visibility) {
            if (calculateCountdown(item.expired_date) !== "Expired") {
              fillAllLenderPpicture(index, item.user_id);
            }
          }
        });
      }
    }
  }, [filteredData, data, sortBy]);
  const [dataSingpassModal, setDataSingpassModal] = useState(false);
  const [myinfoData, setMyinfoData] = useState(null);
  const [needOtherAuthoriser, setNeedOtherAuthoriser] = useState(false);
  const [otherAuthoriserDetails, setOtherAuthoriserDetails] = useState(null);
  const [openDataIndex, setOpenDataIndex] = useState(null);
  const [keyman, setKeyman] = useState("");
  const [viewingUser, setViewingUser] = useState(0);
  const [viewingTab, setViewingTab] = useState(0);
  const [liveUserData, setLiveUserData] = useState(null);
  const [singpassData, setSingpassData] = useState(null);
  const [combinedSingpassData, setCombinedSingpassData] = useState([]);
  const [badgeVerified, setBadgeVerified] = useState(false);
  const [backupContact, setBackupContact] = useState("");
  const [isPersonalLoanProfile, setIsPersonalLoanProfile] = useState(false);
  const [selectedPersonalLoan, setSelectedPersonalLoan] = useState(null);
  const [sccbReportData, setSccbReportData] = useState(null);
  const [keymanDetails, setKeymanDetails] = useState({
    contact: "",
    email: "",
  });
  const [hideContactInfo, setHideContactInfo] = useState(false);
  const [notes, setNotes] = useState("");
  const [platformNotes, setPlatformNotes] = useState("");
  const [loanRemark, setLoanRemark] = useState("");
  const [profileApplicationComments, setProfileApplicationComments] = useState([]);
  const [profilePropertyApplicationId, setProfilePropertyApplicationId] = useState(null);
  usePropertyApplicationCommentRefresh(profilePropertyApplicationId, dataSingpassModal, authToken, setProfileApplicationComments);

  const availableTab = useMemo(() => getLoanProfileTabs(sccbReportData), [sccbReportData]);
  const singpassDetails = async (
    user,
    other_authorization,
    loan_id,
    keyman,
    notes,
    platform_notes,
    loan_remark,
    applicationComments = [],
    propertyApplicationId = null
  ) => {
    try {
      if (loan_id) {
        setBankAnalysisContext((current) => ({
          ...current, loanId: loan_id, loanType: "corporate",
          enabled: current.loanId === loan_id ? current.enabled : false,
        }));
        setMlcbAnalysisContext({ enabled: false, loanId: null });
      }
      setProfileApplicationComments(applicationComments);
      setProfilePropertyApplicationId(propertyApplicationId);
      setKeyman(keyman);
      setNotes(notes);
      setPlatformNotes(platform_notes);
      setLoanRemark(loan_remark);
      const response = await fetch(
        `https://www.smart-lend.com/api/user/getBorrowerSingppass?user_id=${user}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response.json();
      console.log(json);
      setHideContactInfo(
        (currentValue) => currentValue || isTruthyFlag(json?.sl_created)
      );
      setKeymanDetails({
        contact: json.company_contact,
        email: json.company_email,
      });
      let allSingpassData = [json.singpass_data];
      setDataSingpassModal(true);
      setMyinfoData(json.myinfo_data || null);
      if (other_authorization) {
        console.log("need other authorizer");
        setNeedOtherAuthoriser(true);
        try {
          const response2 = await fetch(
            `https://www.smart-lend.com/api/loanDetails/getLoanAuthorisers`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("token")}`,
              },
              body: JSON.stringify({ loan_id: loan_id }),
            }
          );

          const json2 = await response2.json();
          setOtherAuthoriserDetails(json2.authorisers);
          console.log(JSON.parse(json2.authorisers[0].singpass_data));
          console.log(json.singpass_data);
          setLiveUserData(json.singpass_data);
          console.log(json2.authorisers);

          for (const single of json2.authorisers) {
            allSingpassData.push(JSON.parse(single.singpass_data));
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        console.log("Doesnt need other authoriser");
        setLiveUserData(json.singpass_data);
        setNeedOtherAuthoriser(false);
        setOtherAuthoriserDetails(null);
      }
      if (json.singpass_data) {
        setSingpassData(json.singpass_data);
        console.log(allSingpassData);
        setCombinedSingpassData(allSingpassData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const openPersonalLoanProfile = async (loan) => {
    const userId = getPersonalLoanUserId(loan);
    if (!userId) return;
    if (isSupportMode && onOpenBorrowerProfile) {
      onOpenBorrowerProfile(
        buildSupportBorrowerProfilePayload(loan, getPersonalLoanName(loan))
      );
      return;
    }

    recordLoanMarketplaceAudit("personal", loan.id, "viewed");
    setSelectedPersonalLoan(loan);
    const extractedCbs = loan?.cbs_report_document?.extracted_data || null;
    const parsedCbs = extractedCbs
      ? {
          RiskGrade: extractedCbs?.risk_grade,
          CreditScore: extractedCbs?.credit_score,
          ProbabilityofDefault: extractedCbs?.probability_default,
          SecuredCreditLimit: extractedCbs?.secured_credit_limit,
          UnsecuredCreditLimit: extractedCbs?.unsecured_credit_limit,
        }
      : null;
    const cbsFileUrl = loan?.cbs_report_document?.file_url;
    let parsedFromPdf = null;
    if (cbsFileUrl && !loan?.cbs_report_document?.parsing_job_id) {
      try {
        parsedFromPdf = await parseCbsReportFromPdf(cbsFileUrl);
      } catch (error) {
        console.error(error);
      }
    }
    const mergedCbs = parsedFromPdf
      ? { ...(parsedCbs || {}), ...parsedFromPdf }
      : parsedCbs;
    setBankAnalysisContext({
      loanId: loan.id,
      loanType: "personal",
      enabled: Boolean(loan?.precheck),
    });
    setMlcbAnalysisContext({
      loanId: loan.id,
      enabled: Boolean(
        loan?.allow_lender_visibility && loan?.mlcb_report_document
      ),
    });
    setIsPersonalLoanProfile(true);
    setViewingTab(0);
    setViewingUser(0);
    setBackupContact(userId);
    setSccbReportData(null);
    setOtherAuthoriserDetails(null);
    setCombinedSingpassData([]);
    setAllCBSData(
      mergedCbs
        ? [
            {
              user_id: userId,
              name: getPersonalLoanName(loan),
              cbs_data: mergedCbs,
            },
          ]
        : []
    );
    const personalPlatformNotes = loan?.platform_notes || "";
    const personalLoanRemark = loan?.loan_remark || "";
    setKeyman("");
    setNotes("");
    setPlatformNotes(personalPlatformNotes);
    setLoanRemark(personalLoanRemark);
    setHideContactInfo(shouldHideProfileContactInfo(loan));
    singpassDetails(
      userId,
      false,
      null,
      "",
      "",
      personalPlatformNotes,
      personalLoanRemark
    );
  };

  const openPropertyLoanProfile = async (loan) => {
    const userId = getPropertyLoanUserId(loan);
    if (!userId) return;
    if (isSupportMode && onOpenBorrowerProfile) {
      onOpenBorrowerProfile(
        buildSupportBorrowerProfilePayload(loan, getPropertyLoanName(loan))
      );
      return;
    }

    recordLoanMarketplaceAudit("property", loan.id, "viewed");
    const reportPayload =
      loan?.sccb_report?.response_payload ||
      loan?.sccb_reports?.find((report) => report?.response_payload)
        ?.response_payload ||
      loan?.sccbReports?.find((report) => report?.response_payload)
        ?.response_payload ||
      null;
    const loanData = normalizePropertyLoanData(loan);
    let applicationComments = loanData.support_comments || [];
    try {
      const response = await fetch(`https://www.smart-lend.com/api/propTermLoan/${loan.id}/support-comments`, {
        headers: { Authorization: `Bearer ${Cookies.get("token")}`, Accept: "application/json" },
      });
      const body = await response.json();
      if (response.ok) applicationComments = body.comments || [];
      else if (response.status === 403 || response.status === 404) applicationComments = [];
    } catch (error) { console.error("Unable to refresh application comments", error); }
    const extractedCbs = loanData?.cbs_report_document?.extracted_data || null;
    const parsedCbs = extractedCbs
      ? {
          RiskGrade: extractedCbs?.risk_grade,
          CreditScore: extractedCbs?.credit_score,
          ProbabilityofDefault: extractedCbs?.probability_default,
          SecuredCreditLimit: extractedCbs?.secured_credit_limit,
          UnsecuredCreditLimit: extractedCbs?.unsecured_credit_limit,
        }
      : null;
    const cbsFileUrl = loanData?.cbs_report_document?.file_url;
    let parsedFromPdf = null;
    if (cbsFileUrl) {
      try {
        parsedFromPdf = await parseCbsReportFromPdf(cbsFileUrl);
      } catch (error) {
        console.error(error);
      }
    }
    const mergedCbs = parsedFromPdf
      ? { ...(parsedCbs || {}), ...parsedFromPdf }
      : parsedCbs;
    setBankAnalysisContext({
      loanId: loan.id,
      loanType: "property",
      enabled: true,
    });
    setMlcbAnalysisContext({
      loanId: loan.id,
      enabled: false,
    });
    setIsPersonalLoanProfile(true);
    setViewingTab(0);
    setViewingUser(0);
    setBackupContact(userId);
    setSccbReportData(reportPayload);
    setOtherAuthoriserDetails(null);
    setCombinedSingpassData([]);
    setAllCBSData(
      mergedCbs
        ? [
            {
              user_id: userId,
              name: getPropertyLoanName(loan),
              cbs_data: mergedCbs,
            },
          ]
        : []
    );
    setKeyman("");
    setNotes("");
    setPlatformNotes("");
    setLoanRemark("");
    setHideContactInfo(shouldHideProfileContactInfo(loan));
    singpassDetails(userId, false, null, "", "", "", "", applicationComments, loan.id);
  };

  const downloadPersonalLoanDocuments = async (loan) => {
    if (!loan?.id) return;
    setPersonalDownloadId(loan.id);
    try {
      const response = await fetch(
        isSupportMode
          ? `https://www.smart-lend.com/api/support/loans/personal/${loan.id}/documents/download`
          : `https://www.smart-lend.com/api/personalLoans/${loan.id}/documents/download`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(
          json?.message || "Unable to download personal loan documents."
        );
      }

      if (json?.download_url) {
        await recordLoanMarketplaceAudit("personal", loan.id, "downloaded");
        window.open(json.download_url, "_blank", "noopener,noreferrer");
      } else {
        throw new Error("Download link not available.");
      }
    } catch (error) {
      console.error(error);
      message.error(
        error?.message || "Unable to download personal loan documents."
      );
    } finally {
      setPersonalDownloadId(null);
    }
  };

  const downloadPropertyLoanDocuments = async (loan) => {
    if (!loan?.id) return;
    setPropertyDownloadId(loan.id);
    try {
      const response = await fetch(
        isSupportMode
          ? `https://www.smart-lend.com/api/support/loans/property/${loan.id}/documents/download`
          : `https://www.smart-lend.com/api/propTermLoan/${loan.id}/documents/download`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(
          json?.message || "Unable to download property loan documents."
        );
      }

      if (json?.download_url) {
        await recordLoanMarketplaceAudit("property", loan.id, "downloaded");
        window.open(json.download_url, "_blank", "noopener,noreferrer");
      } else {
        throw new Error("Download link not available.");
      }
    } catch (error) {
      console.error(error);
      message.error(
        error?.message || "Unable to download property loan documents."
      );
    } finally {
      setPropertyDownloadId(null);
    }
  };

  const getShareholderAddress = (data) => {
    const allSingpassData = [singpassData];
    if (otherAuthoriserDetails !== null && otherAuthoriserDetails.length > 0) {
      for (const single of otherAuthoriserDetails) {
        allSingpassData.push(JSON.parse(single.singpass_data));
      }
      const toPush = allSingpassData.filter(
        (sd) => getPersonData(sd)?.name?.value === data
      );
      // console.log(toPush);
      return toPush;
    } else {
      return allSingpassData;
    }
  };

  const corporateLoanSource =
    filteredData && filteredData.length > 0
      ? filteredData
      : data && data.length > 0 && empty == "0"
      ? data
      : [];
  const visibleCorporateLoans = corporateLoanSource.filter(
    (item) =>
      isSupportMode ||
      item.visibility &&
      !item.make_hidden &&
      !item.admin_removal
  );
  const sortedCorporateLoans = [...visibleCorporateLoans].sort((a, b) => {
    if (sortBy === "latest-request") {
      return new Date(b.created_at) - new Date(a.created_at);
    }
    if (
      notInterestedIds.includes(a.loan_id) &&
      !notInterestedIds.includes(b.loan_id)
    ) {
      return 1;
    }
    if (
      !notInterestedIds.includes(a.loan_id) &&
      notInterestedIds.includes(b.loan_id)
    ) {
      return -1;
    }
    if (a.express !== b.express) {
      return b.express - a.express;
    }
    return b.request_amount - a.request_amount;
  });

  const sortedPersonalLoans = personalLoans
    .filter((loan) => !loan?.my_offer)
    .sort((a, b) => {
      if (sortBy === "latest-request") {
        return new Date(b.created_at) - new Date(a.created_at);
      }
      return Number(b.amount || 0) - Number(a.amount || 0);
    });
  const sortedPropertyLoans = [...propertyLoans].sort((a, b) => {
    if (sortBy === "latest-request") {
      return new Date(b.created_at) - new Date(a.created_at);
    }
    const amountA = Number(normalizePropertyLoanData(a)?.loanAmount || 0);
    const amountB = Number(normalizePropertyLoanData(b)?.loanAmount || 0);
    return amountB - amountA;
  });
  const visiblePropertyLoans = sortedPropertyLoans.filter(
    (loan) => !loan?.my_offer
  );
  const allowedProducts = (() => {
    if (!userDetails?.lender_allowed_products) return [];
    if (Array.isArray(userDetails.lender_allowed_products)) {
      return userDetails.lender_allowed_products;
    }
    if (typeof userDetails.lender_allowed_products === "string") {
      try {
        const parsed = JSON.parse(userDetails.lender_allowed_products);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (error) {
        return userDetails.lender_allowed_products
          .split(",")
          .map((entry) => entry.trim())
          .filter(Boolean);
      }
    }
    return [];
  })();
  const hasCorporateAccess = isSupportMode || allowedProducts.some((product) =>
    String(product).toLowerCase().includes("corporate")
  );
  const hasPersonalAccess = isSupportMode || allowedProducts.some((product) =>
    String(product).toLowerCase().includes("personal")
  );
  const hasPropertyAccess = isSupportMode || allowedProducts.some((product) =>
    String(product).toLowerCase().includes("property")
  );


  const hasVisibleCorporateLoans =
    hasCorporateAccess && sortedCorporateLoans.length > 0;
  const hasVisiblePersonalLoans =
    hasPersonalAccess && sortedPersonalLoans.length > 0;
  const hasVisiblePropertyLoans =
    hasPropertyAccess && visiblePropertyLoans.length > 0;
  const hasAnyVisibleLoanCards =
    hasVisibleCorporateLoans ||
    hasVisiblePersonalLoans ||
    hasVisiblePropertyLoans;

  const mixedLatestLoans =
    sortBy === "latest-request"
      ? [
          ...(hasCorporateAccess
            ? sortedCorporateLoans.map((loan) => ({
                type: "corporate",
                loan,
                createdAt: loan.created_at,
              }))
            : []),
          ...(hasPersonalAccess
            ? sortedPersonalLoans.map((loan) => ({
                type: "personal",
                loan,
                createdAt: loan.created_at,
              }))
            : []),
          ...(hasPropertyAccess
            ? visiblePropertyLoans.map((loan) => ({
                type: "property",
                loan,
                createdAt: loan.created_at,
              }))
            : []),
        ].sort(
          (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
        )
      : [];

  const loanCardEntriesUnfiltered =
    sortBy === "latest-request"
      ? mixedLatestLoans.map((entry, index) => ({ ...entry, index }))
      : [
          ...(hasCorporateAccess
            ? sortedCorporateLoans.map((loan, index) => ({
                type: "corporate",
                loan,
                index,
              }))
            : []),
          ...(hasPersonalAccess
            ? sortedPersonalLoans.map((loan) => ({
                type: "personal",
                loan,
              }))
            : []),
          ...(hasPropertyAccess
            ? visiblePropertyLoans.map((loan) => ({
                type: "property",
                loan,
              }))
            : []),
        ];

  const loanTypeCounts = useMemo(() => {
    const counts = {
      all: loanCardEntriesUnfiltered.length,
      corporate: 0,
      personal: 0,
      concierge: 0,
    };

    loanCardEntriesUnfiltered.forEach((entry) => {
      if (isNoContactLoan(entry.loan)) {
        counts.concierge += 1;
        return;
      }

      if (entry.type === "personal") {
        counts.personal += 1;
        return;
      }

      counts.corporate += 1;
    });

    return counts;
  }, [loanCardEntriesUnfiltered]);

  const loanTypeEntries =
    activeLoanTypeFilter === "all"
      ? loanCardEntriesUnfiltered
      : loanCardEntriesUnfiltered.filter((entry) => {
          if (activeLoanTypeFilter === "personal") return entry.type === "personal";
          if (activeLoanTypeFilter === "concierge") return isNoContactLoan(entry.loan);
          return entry.type !== "personal" && !isNoContactLoan(entry.loan);
        });

  const loanCardEntries = loanTypeEntries.filter((entry) => {
    const name = entry.type === "corporate"
      ? entry.loan.principal_name || "-"
      : entry.type === "personal"
      ? getPersonalLoanName(entry.loan)
      : getPropertyLoanName(entry.loan);
    return matchesLoanCardName(name, pageSearch);
  });

  const restrictedLoanAccess =
    activeLoanTypeFilter === "corporate" && !hasCorporateAccess
      ? {
          title: "Corporate loan access required",
          description:
            "This section is available exclusively to lenders approved to offer corporate loans. If your organisation would like access, please contact our team at support@smart-lend.com.",
        }
      : activeLoanTypeFilter === "personal" && !hasPersonalAccess
      ? {
          title: "Personal loan access required",
          description:
            "This section is available exclusively to lenders licensed to offer personal loans. If your organisation operates a licensed moneylending arm and would like access, please contact our team at support@smart-lend.com.",
        }
      : null;

  const renderRestrictedLoanAccess = () => (
    <div className="sl-loan-access-required">
      <div className="sl-loan-access-icon">
        <LockOutlined />
      </div>
      <h3>{restrictedLoanAccess.title}</h3>
      <p>{restrictedLoanAccess.description}</p>
      <a href="mailto:support@smart-lend.com" className="sl-loan-access-button">
        <MailOutlined />
        Contact Support
      </a>
    </div>
  );

  const renderLoanCardEntry = (entry) => {
    if (entry.type === "corporate") {
      const item = entry.loan;

      return (
        <Container
          key={`corporate-${item.loan_id}`}
          icon="https://cdn.pixabay.com/photo/2018/05/08/21/28/apple-3384010_960_720.png"
          title={item.principal_name || "-"}
          subtitle={
            sortBy === "latest-request"
              ? ""
              : item.express === 1
              ? "Express Business Loan"
              : "Simple Business Loan"
          }
          loanOfferCount={item.loan_offer_count + " Offering"}
          label="Credit Score"
          credit_score={item.credit_score}
          description={item.credit_score || "-"}
          createdAt={item.created_at}
          label1="Loan Amount"
          description1={item.request_amount.toLocaleString("en-US", {
            style: "currency",
            currency: "SGD",
          })}
          label2="Period"
          description2={item.request_period + " Months" || "-"}
          reject_reason={item.reject_reason}
          countDown={item.expired_date}
          index={entry.index || 0}
          loan_id={item.loan_id}
          userId={item.user_id}
          open_modal={modalStates[item.loan_id]}
          onClickModal={(event) => showModal(item.loan_id, event)}
          cancel_modal={() => handleClose(item.loan_id)}
          item={item}
        />
      );
    }

    if (entry.type === "personal") {
      return <PersonalLoanCard key={`personal-${entry.loan.id}`} loan={entry.loan} />;
    }

    return <PropertyLoanCard key={`property-${entry.loan.id}`} loan={entry.loan} />;
  };

  const personalOfferBorrower = personalOfferModal.loan
    ? getPersonalLoanName(personalOfferModal.loan)
    : "Borrower";
  const propertyOfferBorrower = propertyOfferModal.loan
    ? getPropertyLoanName(propertyOfferModal.loan)
    : "Borrower";
  const personalRejectBorrower = personalRejectionModal.loan
    ? getPersonalLoanName(personalRejectionModal.loan)
    : "Borrower";
  const propertyRejectBorrower = propertyRejectionModal.loan
    ? getPropertyLoanName(propertyRejectionModal.loan)
    : "Borrower";

  const getCorporatePreferredRate = (item) =>
    item?.request_interest_rate === 2
      ? "1.1% - 2%"
      : item?.request_interest_rate === 3
      ? "2.1% - 3%"
      : "3.1% - 5%";

  const getCorporateProcessingFee = (item) =>
    item?.admin_fee === 3
      ? "1% - 3%"
      : item?.admin_fee === 5
      ? "3.1% - 5%"
      : "5.1% - 7%";

  const formatCorporateCurrency = (amount) =>
    Number(amount || 0).toLocaleString("en-US", {
      style: "currency",
      currency: "SGD",
    });

  const renderCorporateOfferModalBody = (
    item,
    {
      interestLabel = "Interest Rate Per Month (%)",
      interestMax = 5,
      processingMax = 7,
      showRepaymentTenor = true,
      revenueLabel = "Forecast revenue",
      includeProcessingInRevenue = false,
    } = {}
  ) => {
    const borrowerName = item?.principal_name || "Borrower";
    const repaymentLabel =
      loanRepaymentTenor === ""
        ? "Monthly"
        : loanRepaymentTenor === "Weekly"
        ? "Weekly"
        : "Bi-Weekly";

    return (
      <>
        <div className="sl-loan-modal-head">
          <div className="sl-loan-modal-title">
            <div className="sl-loan-modal-mark">
              {getInitials(borrowerName).slice(0, 2)}
            </div>
            <div>
              <h2>Corporate Loan Offer</h2>
              <p>Build a firm offer for {borrowerName}.</p>
            </div>
          </div>
        </div>
        <div className="sl-loan-modal-grid">
          <div className="sl-loan-modal-panel">
            <h3>Offer terms</h3>
            <div className="sl-loan-modal-fields">
              {renderSupportLenderSelect("corporate")}
              <div className="sl-loan-modal-field">
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Offer amount
                </div>
                <input
                  type="number"
                  id="offer_amount"
                  name="offer_amount"
                  onChange={handleLoanAmountChange}
                />
              </div>
              <div className="sl-loan-modal-field">
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  {interestLabel}
                </div>
                <input
                  type="number"
                  id="offer_interest_rate"
                  name="offer_interest_rate"
                  min={0}
                  max={interestMax}
                  onChange={handleInterestRateChange}
                />
                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              </div>
              <div className="sl-loan-modal-field">
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Loan period (month)
                </div>
                <input
                  type="number"
                  id="offer_period"
                  name="offer_period"
                  onChange={handleLoanPeriodChange}
                />
              </div>
              <div className="sl-loan-modal-field">
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Processing fee (%)
                </div>
                <input
                  type="number"
                  id="offer_processing_fee"
                  name="offer_processing_fee"
                  value={parseFloat(offer_processing_fee)}
                  onChange={(e) => setProcessingFee(e.target.value)}
                  min={0}
                  max={processingMax}
                />
                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              </div>
              {showRepaymentTenor &&
              (isSupportMode
                ? selectedSupportLenderId === "L66489"
                : userDetails?.user_id === "L66489") ? (
                <div className="sl-loan-modal-field">
                  <div style={{ fontWeight: 700, marginBottom: 6 }}>
                    Repayment tenor
                  </div>
                  <select
                    id="repayment_tenor"
                    name="repayment_tenor"
                    onChange={(e) => {
                      setLoanRepaymentTenor(e.target.value);
                    }}
                  >
                    <option value="">Monthly</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Bi-Weekly">Bi-Weekly</option>
                  </select>
                </div>
              ) : null}
              <div className="sl-loan-modal-field">
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Loan type
                </div>
                <select id="type" name="type" onChange={handleLoanTypeChange}>
                  <option value="simple">Unsecured Business Term Loan</option>
                </select>
              </div>
            </div>
          </div>
          <div className="sl-loan-modal-panel sl-loan-modal-summary">
            <h3>Request snapshot</h3>
            <div className="sl-loan-modal-summary-item">
              <span>Requested amount</span>
              <strong>{formatCorporateCurrency(item?.request_amount)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred rate</span>
              <strong>{getCorporatePreferredRate(item)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred tenor</span>
              <strong>
                {item?.request_period ? `${item.request_period} Months` : "-"}
              </strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Processing fee</span>
              <strong>{getCorporateProcessingFee(item)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>{repaymentLabel} instalment</span>
              <strong>{formatCorporateCurrency(offer_monthly_installment)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Processing fees</span>
              <strong>
                {formatCorporateCurrency(
                  offer_amount * (offer_processing_fee / 100)
                )}
              </strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>{revenueLabel}</span>
              <strong>
                {formatCorporateCurrency(
                  includeProcessingInRevenue
                    ? offer_revenue + offer_amount * (offer_processing_fee / 100)
                    : offer_revenue
                )}
              </strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Platform fee</span>
              <strong>{formatCorporateCurrency(offer_amount * 0.015)}</strong>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderCorporateNotInterestedModalBody = (item) => {
    const borrowerName = item?.principal_name || "this borrower";

    return (
      <>
        <div className="sl-loan-modal-head">
          <div className="sl-loan-modal-title">
            <div className="sl-loan-modal-mark">
              {getInitials(borrowerName).slice(0, 2)}
            </div>
            <div>
              <h2>Not Interested</h2>
              <p>Record why {borrowerName} is not suitable right now.</p>
            </div>
          </div>
        </div>
        <div className="sl-loan-modal-grid">
          <div className="sl-loan-modal-panel">
            <h3>Reason</h3>
            <div className="sl-loan-modal-fields">
              <div className="sl-loan-modal-field full">
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Please select one option
                </div>
                <select id="type" name="type" onChange={handleNotInterestedModal}>
                  <option value="interest_rate_is_too_low">
                    The interest rate is too low
                  </option>
                  <option value="loan_period_is_too_long">
                    The loan period is too long
                  </option>
                  <option value="credit_score_borrower_not_meet_expectation">
                    The credit score of the borrower does not meet my expectation
                  </option>
                  <option value="others">Others</option>
                </select>
              </div>
              {showOtherInput && (
                <div className="sl-loan-modal-field full">
                  <div style={{ fontWeight: 700, marginBottom: 6 }}>
                    Please specify
                  </div>
                  <input
                    type="text"
                    id="other_reason"
                    name="other_reason"
                    onChange={(event) => setSelectedValue(event.target.value)}
                    value={selectedValue}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="sl-loan-modal-panel sl-loan-modal-summary">
            <h3>Request snapshot</h3>
            <div className="sl-loan-modal-summary-item">
              <span>Requested amount</span>
              <strong>{formatCorporateCurrency(item?.request_amount)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred rate</span>
              <strong>{getCorporatePreferredRate(item)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred tenor</span>
              <strong>
                {item?.request_period ? `${item.request_period} Months` : "-"}
              </strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Processing fee</span>
              <strong>{getCorporateProcessingFee(item)}</strong>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <Box className="sl-loan-request-shell" m="0 24px 32px 36px">
      {isLoading || isPersonalLoansLoading || isPropertyLoansLoading ? (
        <div
          style={{
            width: "100vw",
            height: "100vh",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 2000,
            background: "rgba(256,256,256,0.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress
            style={{ color: "#1677ff" }}
            size={80}
            thickness={5} // Adjust thickness as needed
          />
        </div>
      ) : null}
      <Modal
        className="sl-loan-action-modal sl-lender-activity-modal"
        width={isMobile ? "96%" : 1040}
        open={lenderActivityModal.open}
        onCancel={closeSupportLenderActivity}
        title={null}
        footer={null}
      >
        {lenderActivityLoading ? (
          <div
            style={{
              minHeight: 260,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: 12,
              color: "#64748b",
            }}
          >
            <CircularProgress style={{ color: "#0e5aa5" }} size={42} />
            <div style={{ fontWeight: 800 }}>Loading lender activity...</div>
          </div>
        ) : lenderActivityData ? (
          <div
            style={{
              display: "grid",
              gap: 18,
              background: "#f6f8fb",
              margin: "-8px",
              padding: isMobile ? 12 : 18,
              borderRadius: 14,
            }}
          >
            <div
              style={{
                padding: isMobile ? "18px" : "22px 24px",
                borderRadius: 16,
                background:
                  "linear-gradient(135deg, #0e5aa5 0%, #17324d 58%, #0f766e 100%)",
                color: "white",
                boxShadow: "0 18px 38px rgba(14, 90, 165, 0.22)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 14,
                  flexWrap: "wrap",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 800,
                      opacity: 0.78,
                      textTransform: "uppercase",
                      letterSpacing: 0,
                      marginBottom: 6,
                    }}
                  >
                    Support lender audit
                  </div>
                  <h2
                    style={{
                      margin: 0,
                      color: "white",
                      fontSize: isMobile ? 22 : 28,
                      fontWeight: 900,
                      lineHeight: 1.15,
                    }}
                  >
                    {lenderActivityData.borrower?.name || "Borrower"}
                  </h2>
                  <div style={{ marginTop: 8, opacity: 0.82, fontWeight: 700 }}>
                    {lenderActivityData.loan_type === "corporate"
                      ? "Corporate loan"
                      : lenderActivityData.loan_type === "personal"
                      ? "Money lender loan"
                      : "Property term loan"}{" "}
                    • Loan {lenderActivityData.loan_id}
                  </div>
                </div>
                <Button
                  onClick={closeSupportLenderActivity}
                  style={{
                    border: "1px solid rgba(255,255,255,0.38)",
                    background: "rgba(255,255,255,0.14)",
                    color: "white",
                    fontWeight: 800,
                    borderRadius: 10,
                  }}
                >
                  Close
                </Button>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile
                  ? "1fr"
                  : "repeat(6, minmax(0, 1fr))",
                gap: 12,
              }}
            >
              {renderSupportActivityMetric(
                "Requested amount",
                formatPersonalAmount(lenderActivityData.requested_amount),
                { accent: true, large: true }
              )}
              {renderSupportActivityMetric(
                "Requested rate",
                lenderActivityData.requested_rate
                  ? `${lenderActivityData.requested_rate}%`
                  : "-"
              )}
              {renderSupportActivityMetric(
                "Requested tenor",
                formatPersonalTenor(lenderActivityData.requested_tenor)
              )}
              {renderSupportActivityMetric(
                "Offers submitted",
                `${(lenderActivityData.offers || []).length}`,
                { accent: true, large: true }
              )}
              {renderSupportActivityMetric(
                "Rejected",
                `${getSupportRejectedOffers(lenderActivityData.offers).length}`,
                { accent: true, large: true }
              )}
              {renderSupportActivityMetric(
                "Ongoing",
                `${getSupportOngoingOffers(lenderActivityData.offers).length}`,
                { accent: true, large: true }
              )}
            </div>

            {getSupportRejectedOffers(lenderActivityData.offers).length ? (
              <div
                style={{
                  padding: isMobile ? 14 : 18,
                  borderRadius: 16,
                  background: "#fff7ed",
                  border: "1px solid #fed7aa",
                  display: "grid",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 12,
                        color: "#9a3412",
                        fontWeight: 900,
                        textTransform: "uppercase",
                        letterSpacing: 0,
                      }}
                    >
                      Rejected by borrower
                    </div>
                    <div style={{ color: "#7c2d12", fontWeight: 800 }}>
                      Lenders whose offers the borrower rejected
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: isMobile
                      ? "1fr"
                      : "repeat(auto-fit, minmax(220px, 1fr))",
                    gap: 10,
                  }}
                >
                  {getSupportRejectedOffers(lenderActivityData.offers).map(
                    (offer) => (
                      <button
                        type="button"
                        key={`rejected-${offer.loan_type}-${offer.id}`}
                        onClick={() => setSelectedCommunicationOffer(offer)}
                        style={{
                          textAlign: "left",
                          padding: "12px 14px",
                          borderRadius: 12,
                          border: "1px solid #fdba74",
                          background: "white",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            color: "#172033",
                            fontWeight: 900,
                            lineHeight: 1.25,
                            marginBottom: 6,
                          }}
                        >
                          {offer.lender?.name || offer.lender_user_id}
                        </div>
                        <div
                          style={{
                            color: "#9a3412",
                            fontSize: 12,
                            fontWeight: 800,
                            lineHeight: 1.35,
                          }}
                        >
                          {getSupportOfferRejectionReason(offer)}
                        </div>
                      </button>
                    )
                  )}
                </div>
              </div>
            ) : null}

            {(lenderActivityData.offers || []).length === 0 ? (
              <div
                style={{
                  padding: 24,
                  borderRadius: 14,
                  background: "white",
                  color: "#64748b",
                  border: "1px dashed #cbd5e1",
                  textAlign: "center",
                  fontWeight: 800,
                }}
              >
                No lender offers have been submitted for this loan yet.
              </div>
            ) : (
              <div style={{ display: "grid", gap: 14 }}>
                {(lenderActivityData.offers || []).map((offer) => (
                  <div
                    key={`${offer.loan_type}-${offer.id}`}
                    style={{
                      border: "1px solid #dbe7f5",
                      borderRadius: 16,
                      padding: isMobile ? 14 : 18,
                      background: "#fff",
                      boxShadow: "0 14px 34px rgba(15, 35, 55, 0.07)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 14,
                        flexWrap: "wrap",
                        alignItems: "center",
                        marginBottom: 16,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: 12,
                          alignItems: "center",
                          minWidth: 0,
                        }}
                      >
                        <div
                          style={{
                            width: 42,
                            height: 42,
                            borderRadius: 12,
                            background: "#e0f2fe",
                            color: "#0e5aa5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: 900,
                            flexShrink: 0,
                          }}
                        >
                          {(offer.lender?.name || offer.lender_user_id || "L")
                            .slice(0, 2)
                            .toUpperCase()}
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <div
                            style={{
                              fontWeight: 900,
                              color: "#172033",
                              fontSize: 16,
                              lineHeight: 1.2,
                              wordBreak: "break-word",
                            }}
                          >
                          {offer.lender?.name || offer.lender_user_id}
                          </div>
                          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>
                            {offer.lender_user_id}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          flexWrap: "wrap",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            padding: "7px 10px",
                            borderRadius: 999,
                            background: "#eef2ff",
                            color: "#3730a3",
                            fontSize: 12,
                            fontWeight: 900,
                            textTransform: "capitalize",
                          }}
                        >
                          {offer.status || "No status"}
                        </span>
                        <Button
                          type="primary"
                          onClick={() => setSelectedCommunicationOffer(offer)}
                          style={{
                            borderRadius: 10,
                            fontWeight: 800,
                            background: "#0e5aa5",
                            borderColor: "#0e5aa5",
                          }}
                        >
                          View Communication
                        </Button>
                        {isSupportMode ? (
                          <SupportMarkOfferOngoingButton
                            loanType={lenderActivityData.loan_type}
                            offer={offer}
                            onUpdated={async () => {
                              await openSupportLenderActivity(
                                lenderActivityModal.loanType,
                                lenderActivityModal.loan
                              );
                              if (lenderActivityModal.loanType === "personal") fetchPersonalLoans();
                              else if (lenderActivityModal.loanType === "property") fetchPropertyLoans();
                              else fetchData();
                            }}
                          />
                        ) : null}
                        {isSupportMode ? (
                          <SupportCancelOfferButton
                            loanType={lenderActivityData.loan_type}
                            offer={offer}
                            onCancelled={async () => {
                              await openSupportLenderActivity(
                                lenderActivityModal.loanType,
                                lenderActivityModal.loan
                              );
                              if (lenderActivityModal.loanType === "personal") fetchPersonalLoans();
                              else if (lenderActivityModal.loanType === "property") fetchPropertyLoans();
                              else fetchData();
                            }}
                          />
                        ) : null}
                        {["corporate", "personal", "property"].includes(
                          lenderActivityData.loan_type
                        ) && isSupportOfferEditable(offer) ? (
                          <Button
                            onClick={() => openSupportEditOfferModal(offer)}
                            style={{
                              borderRadius: 10,
                              fontWeight: 800,
                              borderColor: "#0e5aa5",
                              color: "#0e5aa5",
                              background: "#eff6ff",
                            }}
                          >
                            Edit offer
                          </Button>
                        ) : null}
                        {["corporate", "personal"].includes(
                          lenderActivityData.loan_type
                        ) && isSupportOfferAcceptable(offer) ? (
                          <Button
                            onClick={() => openSupportAcceptOfferModal(offer)}
                            style={{
                              borderRadius: 10,
                              fontWeight: 800,
                              borderColor: "#16a34a",
                              color: "#166534",
                              background: "#f0fdf4",
                            }}
                          >
                            Accept on behalf
                          </Button>
                        ) : null}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: isMobile
                          ? "1fr"
                          : "repeat(4, minmax(135px, 1fr))",
                        gap: 12,
                      }}
                    >
                      {renderSupportOfferMetric(
                        "Offer amount",
                        formatPersonalAmount(offer.amount),
                        { highlight: true }
                      )}
                      {renderSupportOfferMetric("Rate", formatSupportOfferRate(offer))}
                      {renderSupportOfferMetric("Tenor", formatSupportOfferTenor(offer))}
                      {renderSupportOfferMetric(
                        "Processing fee",
                        lenderActivityData.loan_type === "property"
                          ? `${PROPERTY_LOAN_PROCESSING_FEE_LABEL} (${formatPersonalAmount(propertyLoanProcessingFee(offer.amount))})`
                          : formatSupportProcessingFee(offer.processing_fee)
                      )}
                      {renderSupportOfferMetric(
                        "Monthly installment",
                        formatPersonalAmount(offer.monthly_installment)
                      )}
                      {renderSupportOfferMetric(
                        "Revenue",
                        formatPersonalAmount(offer.revenue)
                      )}
                      {renderSupportOfferMetric("Created", offer.created_at || "-")}
                      {renderSupportOfferMetric("Updated", offer.updated_at || "-")}
                      {isSupportOfferRejectedByBorrower(offer)
                        ? renderSupportOfferMetric(
                            "Rejection reason",
                            getSupportOfferRejectionReason(offer)
                          )
                        : null}
                    </div>
                    {renderSupportRepaymentSchedule(offer)}
                  </div>
                ))}
              </div>
            )}

            {selectedCommunicationOffer ? (
              <div
                style={{
                  border: "1px solid #cbd5e1",
                  borderRadius: 16,
                  padding: isMobile ? 14 : 18,
                  background: "#fff",
                  boxShadow: "0 16px 36px rgba(15, 35, 55, 0.08)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                    alignItems: "center",
                    flexWrap: "wrap",
                    paddingBottom: 14,
                    borderBottom: "1px solid #e2e8f0",
                    marginBottom: 14,
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 900, color: "#172033", fontSize: 17 }}>
                      Communication with{" "}
                      {selectedCommunicationOffer.lender?.name ||
                        selectedCommunicationOffer.lender_user_id}
                    </div>
                    <div style={{ fontSize: 12, color: "#6b7b93" }}>
                      {isSupportOfferRejectedByBorrower(selectedCommunicationOffer)
                        ? "Rejected offer details"
                        : "Read-only transcript for support review"}
                    </div>
                  </div>
                  <Button
                    onClick={() => setSelectedCommunicationOffer(null)}
                    style={{ borderRadius: 10, fontWeight: 800 }}
                  >
                    Hide
                  </Button>
                </div>
                {isSupportOfferRejectedByBorrower(selectedCommunicationOffer) ? (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                      gap: 12,
                      marginBottom: 14,
                    }}
                  >
                    {renderSupportOfferMetric(
                      "Rejected lender",
                      selectedCommunicationOffer.lender?.name ||
                        selectedCommunicationOffer.lender_user_id
                    )}
                    {renderSupportOfferMetric(
                      "Reason",
                      getSupportOfferRejectionReason(selectedCommunicationOffer)
                    )}
                  </div>
                ) : null}
                {selectedCommunicationOffer.communications?.messages?.length ? (
                  <div
                    style={{
                      display: "grid",
                      gap: 12,
                      maxHeight: 390,
                      overflow: "auto",
                      padding: "2px 4px 2px 0",
                    }}
                  >
                    {selectedCommunicationOffer.communications.messages.map(
                      (chatMessage, index) => {
                        const isLenderMessage = chatMessage.from_role === "lender";
                        return (
                          <div
                            key={`${chatMessage.thread_id}-${chatMessage.timestamp}-${index}`}
                            style={{
                              display: "flex",
                              justifyContent: isLenderMessage
                                ? "flex-end"
                                : "flex-start",
                            }}
                          >
                            <div
                              style={{
                                width: "min(100%, 680px)",
                                padding: "12px 14px",
                                borderRadius: isLenderMessage
                                  ? "14px 14px 4px 14px"
                                  : "14px 14px 14px 4px",
                                background: isLenderMessage ? "#e0f2fe" : "#f8fafc",
                                border: `1px solid ${
                                  isLenderMessage ? "#bae6fd" : "#e2e8f0"
                                }`,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: 10,
                                  fontSize: 12,
                                  color: "#64748b",
                                  marginBottom: 7,
                                  flexWrap: "wrap",
                                }}
                              >
                                <strong style={{ color: "#172033" }}>
                                  {chatMessage.from_name} ({chatMessage.from_role})
                                </strong>
                                <span>
                                  {formatCommunicationTimestamp(
                                    chatMessage.timestamp
                                  )}
                                </span>
                              </div>
                              {chatMessage.text ? (
                                <div
                                  style={{
                                    color: "#172033",
                                    fontSize: 14,
                                    lineHeight: 1.55,
                                    whiteSpace: "pre-wrap",
                                  }}
                                >
                                  {chatMessage.text}
                                </div>
                              ) : null}
                              {chatMessage.meet ? (
                                <div style={{ color: "#64748b", fontWeight: 700 }}>
                                  Meeting invitation
                                </div>
                              ) : null}
                              {renderSupportMessageAttachments(
                                chatMessage.attachments
                              )}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      color: "#64748b",
                      padding: 18,
                      borderRadius: 12,
                      background: "#f8fafc",
                      border: "1px dashed #cbd5e1",
                      textAlign: "center",
                      fontWeight: 800,
                    }}
                  >
                    No messages found between this lender and borrower.
                  </div>
                )}
              </div>
            ) : null}
          </div>
        ) : (
          <div style={{ padding: "24px", color: "#64748b" }}>
            Select lender activity from a loan card to load details.
          </div>
        )}
      </Modal>
      <Modal
        className="sl-loan-action-modal"
        width={isMobile ? "96%" : 620}
        open={supportEditModal.open}
        onCancel={closeSupportEditOfferModal}
        title="Edit lender offer"
        footer={[
          <Button key="cancel" onClick={closeSupportEditOfferModal}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={supportEditBusy}
            onClick={submitSupportEditOffer}
            style={{ background: "#0e5aa5", borderColor: "#0e5aa5" }}
          >
            Save offer
          </Button>,
        ]}
      >
        <div style={{ display: "grid", gap: 16 }}>
          <div
            style={{
              padding: 14,
              borderRadius: 12,
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
            }}
          >
            <div style={{ fontWeight: 900, color: "#172033" }}>
              {supportEditModal.offer?.lender?.name ||
                supportEditModal.offer?.lender_user_id ||
                "Selected lender"}
            </div>
            <div style={{ color: "#64748b", fontWeight: 700, marginTop: 4 }}>
              {lenderActivityData?.loan_type === "personal"
                ? "Money lender loan"
                : lenderActivityData?.loan_type === "property"
                ? "Property term loan"
                : "Corporate loan"}{" "}
              • Loan {lenderActivityData?.loan_id}
            </div>
          </div>

          {lenderActivityData?.loan_type === "corporate" ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                gap: 12,
              }}
            >
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Offer amount</div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={1}
                  value={supportEditForm.amount}
                  formatter={(value) =>
                    `S$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/S\$\s?|(,*)/g, "")}
                  onChange={(value) => updateSupportEditForm("amount", value)}
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Interest rate (decimal)
                </div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  step={0.0001}
                  value={supportEditForm.interest_rate}
                  onChange={(value) =>
                    updateSupportEditForm("interest_rate", value)
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Tenor</div>
                {renderSupportTenorInput(supportEditForm.period, (value) =>
                  updateSupportEditForm("period", value)
                )}
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                gap: 12,
              }}
            >
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Offer amount</div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={1}
                  value={supportEditForm.amount}
                  formatter={(value) =>
                    `S$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/S\$\s?|(,*)/g, "")}
                  onChange={(value) => updateSupportEditForm("amount", value)}
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  {lenderActivityData?.loan_type === "property"
                    ? "Rate (% p.a.)"
                    : "Rate (% p.m.)"}
                </div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  step={0.01}
                  value={
                    lenderActivityData?.loan_type === "property"
                      ? supportEditForm.rate_pa
                      : supportEditForm.rate_pm
                  }
                  onChange={(value) =>
                    updateSupportEditForm(
                      lenderActivityData?.loan_type === "property"
                        ? "rate_pa"
                        : "rate_pm",
                      value
                    )
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Tenor</div>
                {renderSupportTenorInput(
                  supportEditForm.tenor_months,
                  (value) => updateSupportEditForm("tenor_months", value)
                )}
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Processing fee
                </div>
                {lenderActivityData?.loan_type === "property" ? (
                  <Input
                    aria-label="Processing fee"
                    readOnly
                    value={`${PROPERTY_LOAN_PROCESSING_FEE_LABEL} (${formatPersonalAmount(propertyLoanProcessingFee(supportEditForm.amount))})`}
                  />
                ) : (
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    value={supportEditForm.processing_fee}
                    onChange={(value) =>
                      updateSupportEditForm("processing_fee", value)
                    }
                  />
                )}
              </div>
            </div>
          )}

          <div>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Support note</div>
            <Input.TextArea
              rows={3}
              value={supportEditForm.support_note}
              onChange={(event) =>
                updateSupportEditForm("support_note", event.target.value)
              }
            />
          </div>
        </div>
      </Modal>
      <Modal
        className="sl-loan-action-modal"
        width={isMobile ? "96%" : 560}
        open={supportDisbursementModal.open}
        onCancel={closeSupportDisbursementModal}
        title="Adjust disbursement date"
        footer={[
          <Button key="cancel" onClick={closeSupportDisbursementModal}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={supportDisbursementBusy}
            onClick={submitSupportDisbursementDate}
          >
            Update schedule dates
          </Button>,
        ]}
      >
        <div style={{ display: "grid", gap: 16 }}>
          <div
            style={{
              padding: 14,
              borderRadius: 12,
              background: "#fff7ed",
              border: "1px solid #fed7aa",
              color: "#9a3412",
              lineHeight: 1.5,
            }}
          >
            Updating the disbursement date will move every repayment due date
            using the loan&apos;s existing monthly, weekly, or bi-weekly cadence.
            Payment amounts and recorded payment statuses will not change.
          </div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Disbursement date
            </div>
            <Input
              type="date"
              value={supportDisbursementForm.disbursement_date || ""}
              onChange={(event) =>
                setSupportDisbursementForm((previous) => ({
                  ...previous,
                  disbursement_date: event.target.value,
                }))
              }
            />
          </div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Support note
            </div>
            <Input.TextArea
              rows={3}
              value={supportDisbursementForm.support_note || ""}
              onChange={(event) =>
                setSupportDisbursementForm((previous) => ({
                  ...previous,
                  support_note: event.target.value,
                }))
              }
              placeholder="Reason for the date adjustment"
            />
          </div>
        </div>
      </Modal>
      <Modal
        className="sl-loan-action-modal"
        width={isMobile ? "96%" : 760}
        open={supportAcceptModal.open}
        onCancel={closeSupportAcceptOfferModal}
        title="Accept offer on behalf of borrower"
        footer={[
          <Button key="cancel" onClick={closeSupportAcceptOfferModal}>
            Cancel
          </Button>,
          <Button
            key="accept"
            type="primary"
            loading={supportAcceptBusy}
            onClick={submitSupportAcceptOffer}
            style={{ background: "#16a34a", borderColor: "#16a34a" }}
          >
            Accept offer
          </Button>,
        ]}
      >
        <div style={{ display: "grid", gap: 16 }}>
          <div
            style={{
              padding: 14,
              borderRadius: 12,
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
            }}
          >
            <div style={{ fontWeight: 900, color: "#172033" }}>
              {supportAcceptModal.offer?.lender?.name ||
                supportAcceptModal.offer?.lender_user_id ||
                "Selected lender"}
            </div>
            <div style={{ color: "#64748b", fontWeight: 700, marginTop: 4 }}>
              {lenderActivityData?.loan_type === "personal"
                ? "Money lender loan"
                : "Corporate loan"}{" "}
              • Loan {lenderActivityData?.loan_id}
            </div>
          </div>

          {lenderActivityData?.loan_type === "corporate" ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                gap: 12,
              }}
            >
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Loan amount</div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={1}
                  value={supportAcceptForm.amount}
                  formatter={(value) =>
                    `S$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/S\$\s?|(,*)/g, "")}
                  onChange={(value) => updateSupportAcceptForm("amount", value)}
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Interest rate (decimal)
                </div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  step={0.0001}
                  value={supportAcceptForm.interest_rate}
                  onChange={(value) =>
                    updateSupportAcceptForm("interest_rate", value)
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Tenor
                </div>
                {renderSupportTenorInput(supportAcceptForm.period, (value) =>
                  updateSupportAcceptForm("period", value)
                )}
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Loan type</div>
                <Select
                  style={{ width: "100%" }}
                  value={supportAcceptForm.type}
                  onChange={(value) => updateSupportAcceptForm("type", value)}
                  options={[
                    { value: "simple", label: "Simple" },
                    { value: "effective", label: "Effective" },
                  ]}
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Monthly installment
                </div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  value={supportAcceptForm.monthly_installment}
                  onChange={(value) =>
                    updateSupportAcceptForm("monthly_installment", value)
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Principal</div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  value={supportAcceptForm.principal}
                  onChange={(value) =>
                    updateSupportAcceptForm("principal", value)
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Revenue</div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  value={supportAcceptForm.revenue}
                  onChange={(value) => updateSupportAcceptForm("revenue", value)}
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Repayment tenor
                </div>
                <Select
                  style={{ width: "100%" }}
                  value={supportAcceptForm.repayment_tenor}
                  onChange={(value) =>
                    updateSupportAcceptForm("repayment_tenor", value)
                  }
                  options={[
                    { value: "Monthly", label: "Monthly" },
                    { value: "Weekly", label: "Weekly" },
                    { value: "Bi-Weekly", label: "Bi-Weekly" },
                  ]}
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Processing fee
                </div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  value={supportAcceptForm.processing_fee}
                  onChange={(value) =>
                    updateSupportAcceptForm("processing_fee", value)
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Admin fee</div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  value={supportAcceptForm.admin_fee}
                  onChange={(value) =>
                    updateSupportAcceptForm("admin_fee", value)
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Total admin fee
                </div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  value={supportAcceptForm.total_admin_fee}
                  onChange={(value) =>
                    updateSupportAcceptForm("total_admin_fee", value)
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Disbursement date
                </div>
                <Input
                  type="date"
                  value={supportAcceptForm.disbursement_date}
                  onChange={(event) =>
                    updateSupportAcceptForm(
                      "disbursement_date",
                      event.target.value
                    )
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Express</div>
                <Select
                  style={{ width: "100%" }}
                  value={supportAcceptForm.express}
                  onChange={(value) => updateSupportAcceptForm("express", value)}
                  options={[
                    { value: false, label: "No" },
                    { value: true, label: "Yes" },
                  ]}
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Category</div>
                <Input
                  value={supportAcceptForm.category}
                  onChange={(event) =>
                    updateSupportAcceptForm("category", event.target.value)
                  }
                />
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                gap: 12,
              }}
            >
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>Loan amount</div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={1}
                  value={supportAcceptForm.amount}
                  formatter={(value) =>
                    `S$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/S\$\s?|(,*)/g, "")}
                  onChange={(value) => updateSupportAcceptForm("amount", value)}
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Rate (% p.m.)
                </div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  step={0.01}
                  value={supportAcceptForm.rate_pm}
                  onChange={(value) => updateSupportAcceptForm("rate_pm", value)}
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Tenor
                </div>
                {renderSupportTenorInput(
                  supportAcceptForm.tenor_months,
                  (value) => updateSupportAcceptForm("tenor_months", value)
                )}
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Processing fee
                </div>
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  value={supportAcceptForm.processing_fee}
                  onChange={(value) =>
                    updateSupportAcceptForm("processing_fee", value)
                  }
                />
              </div>
              <div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  Disbursement date
                </div>
                <Input
                  type="date"
                  value={supportAcceptForm.disbursement_date}
                  onChange={(event) =>
                    updateSupportAcceptForm(
                      "disbursement_date",
                      event.target.value
                    )
                  }
                />
              </div>
            </div>
          )}

          <div>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Support note</div>
            <Input.TextArea
              rows={3}
              value={supportAcceptForm.support_note}
              onChange={(event) =>
                updateSupportAcceptForm("support_note", event.target.value)
              }
            />
          </div>
        </div>
      </Modal>
      <Modal
        className="sl-loan-action-modal"
        width={isMobile ? "96%" : 720}
        open={manageDocumentModal.open}
        onCancel={closeSupportManageDocuments}
        title={`Manage document - ${getSupportManageDocumentLoanName()}`}
        footer={[
          <Button key="close" onClick={closeSupportManageDocuments}>
            Close
          </Button>,
          <Button
            key="upload"
            type="primary"
            loading={manageDocumentUploading}
            onClick={handleSupportDocumentUpload}
          >
            Upload document
          </Button>,
        ]}
      >
        <div style={{ display: "grid", gap: 16 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: 12,
            }}
          >
            <div>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>
                Document type
              </div>
              <Select
                value={manageDocumentType || undefined}
                style={{ width: "100%" }}
                onChange={(value) => setManageDocumentType(value)}
                options={manageDocumentTypeOptions.map((option) => ({
                  value: option.value,
                  label: option.label,
                }))}
                placeholder="Select document type"
              />
            </div>
            <div>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>File</div>
              <input
                key={manageDocumentFile ? "support-document-selected" : "support-document-empty"}
                type="file"
                accept={
                  ["cbs", "mlcb"].includes(manageDocumentType)
                    ? "application/pdf"
                    : undefined
                }
                onChange={(event) =>
                  setManageDocumentFile(event.target.files?.[0] || null)
                }
                style={{ width: "100%" }}
              />
            </div>
            {manageDocumentModal.loanType === "personal" &&
            manageDocumentType === "bank_statement" ? (
              <>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: 6 }}>
                    Month key
                  </div>
                  <Input
                    placeholder="2026-08"
                    value={manageDocumentGroupKey}
                    onChange={(event) =>
                      setManageDocumentGroupKey(event.target.value)
                    }
                  />
                </div>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: 6 }}>
                    Month label
                  </div>
                  <Input
                    placeholder="August 2026"
                    value={manageDocumentGroupLabel}
                    onChange={(event) =>
                      setManageDocumentGroupLabel(event.target.value)
                    }
                  />
                </div>
              </>
            ) : null}
          </div>
          <div>
            <div style={{ fontWeight: 800, marginBottom: 8 }}>
              Current documents
            </div>
            {manageDocumentLoading ? (
              <div style={{ padding: "14px 0" }}>Loading documents...</div>
            ) : manageDocumentList.length ? (
              <div style={{ display: "grid", gap: 8 }}>
                {manageDocumentList.map((documentItem) => (
                  <div
                    key={`${documentItem.document_type}-${documentItem.document_id}-${documentItem.group_key || "root"}`}
                    style={{
                      display: "grid",
                      gridTemplateColumns: isMobile ? "1fr" : "1fr auto",
                      gap: 8,
                      alignItems: "center",
                      padding: "10px 12px",
                      border: "1px solid #e6edf5",
                      borderRadius: 8,
                    }}
                  >
                    <div style={{ minWidth: 0 }}>
                      <div
                        style={{
                          fontWeight: 700,
                          color: "#142C44",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {documentItem.file_name}
                      </div>
                      <div style={{ color: "#64748b", fontSize: 12 }}>
                        {documentItem.document_type_label}
                        {documentItem.group_label
                          ? ` - ${documentItem.group_label}`
                          : ""}
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      {documentItem.file_url ? (
                        <Button
                          size="small"
                          onClick={() =>
                            window.open(
                              documentItem.file_url,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                        >
                          View
                        </Button>
                      ) : null}
                      <Button
                        size="small"
                        danger
                        loading={
                          String(manageDocumentDeletingId) ===
                          String(documentItem.document_id)
                        }
                        onClick={() => handleSupportDocumentDelete(documentItem)}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                style={{
                  padding: "14px 12px",
                  border: "1px dashed #cbd5e1",
                  borderRadius: 8,
                  color: "#64748b",
                }}
              >
                No documents uploaded yet.
              </div>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        className="sl-loan-action-modal"
        open={warningLenderModal}
        onCancel={() => {
          setWarningLenderModal(false);
        }}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                setWarningLenderModal(false);
                openMakeAnOfferModal();
              }}
            >
              Proceed
            </Button>
            <Button type="default" onClick={() => setWarningLenderModal(false)}>
              Cancel
            </Button>
          </div>,
        ]}
      >
        <div
          style={{
            fontSize: "18px",
            fontWeight: 800,
            color: "#142C44CC",
            fontFamily: "Manrope, sans-serif",
          }}
        >
          Loan Offer Notice
        </div>
        <div style={{ marginTop: "5px" }}>
          The borrower currently have accepted loans totaling{" "}
          {floatingLoanAmount.totalLoanedAmount.toLocaleString("en-us", {
            style: "currency",
            currency: "SGD",
          })}{" "}
          on this loan request, would you like to proceed making a loan offer to
          this borrower?
        </div>
      </Modal>
      <Modal
        className="sl-loan-action-modal"
        width={isMobile ? "100%" : "60%"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={dataSingpassModal}
        onCancel={() => {
          setDataSingpassModal(false);
          setSingpassData(null);
          setMyinfoData(null);
          setOpenDataIndex(null);
          setKeyman("");
          setIsPersonalLoanProfile(false);
          setSelectedPersonalLoan(null);
          setProfileApplicationComments([]);
          setProfilePropertyApplicationId(null);
          setHideContactInfo(false);
          setSccbReportData(null);
          setBankAnalysisContext({
            loanId: null,
            loanType: null,
            enabled: false,
          });
          setMlcbAnalysisContext({
            loanId: null,
            enabled: false,
          });
        }}
        footer={null}
      >
        {singpassData || myinfoData || profilePropertyApplicationId ? (
          <ProfileViewer
            keyman={keyman}
            isMobile={isMobile}
            viewingUser={viewingUser}
            setViewingUser={(data) => {
              setViewingUser(data);
            }}
            singpassData={singpassData}
            liveUserData={liveUserData}
            myinfoData={myinfoData}
            otherAuthoriserDetails={otherAuthoriserDetails}
            setLiveUserData={(data) => {
              setLiveUserData(data);
            }}
            setViewingTab={(data) => {
              setViewingTab(data);
            }}
            viewingTab={viewingTab}
            badgeVerified={badgeVerified}
            availableTab={availableTab}
            allCBSData={allCBSData}
            combinedSingpassData={combinedSingpassData}
            getShareholderAddress={(data) => {
              getShareholderAddress(data);
            }}
            backupContact={backupContact}
            notes={notes}
            platform_notes={platformNotes}
            loan_remark={loanRemark}
            personalOnly={isPersonalLoanProfile}
            loanDocuments={selectedPersonalLoan}
            applicationComments={profileApplicationComments}
            propertyApplicationId={profilePropertyApplicationId}
            hideContactInfo={hideContactInfo}
            showConciergeNotice={!isSupportMode && hideContactInfo}
            bankAnalysisContext={bankAnalysisContext}
            mlcbAnalysisContext={mlcbAnalysisContext}
            sccbReportData={sccbReportData}
            sccbReportType="personal"
            sccbExcludeColumns={SCCB_EXCLUDE_COLUMNS}
          />
        ) : (
          <div></div>
        )}
      </Modal>
      <Modal
        className="sl-loan-action-modal sl-personal-loan-modal"
        open={personalOfferModal.open}
        onCancel={closePersonalOfferModal}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
              gap: 8,
            }}
          >
            <Button
              type="primary"
              loading={personalOfferBusy}
              onClick={submitPersonalOffer}
            >
              Submit offer
            </Button>
            <Button type="default" onClick={closePersonalOfferModal}>
              Cancel
            </Button>
          </div>,
        ]}
      >
        <div className="sl-loan-modal-head">
          <div className="sl-loan-modal-title">
            <div className="sl-loan-modal-mark pink">
              {getInitials(personalOfferBorrower).slice(0, 2)}
            </div>
            <div>
              <h2>Money Lender Offer</h2>
              <p>Build a firm offer for {personalOfferBorrower}.</p>
            </div>
          </div>
        </div>
        <div className="sl-loan-modal-grid">
          <div className="sl-loan-modal-panel">
            <h3>Offer terms</h3>
            <div className="sl-loan-modal-fields">
          {renderSupportLenderSelect("personal")}
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Offer amount</div>
            <InputNumber
              style={{ width: "100%" }}
              value={personalOfferForm.amount}
              min={1000}
              max={200000}
              formatter={(value) =>
                `S$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/S\$\s?|(,*)/g, "")}
              onChange={(value) =>
                setPersonalOfferForm((prev) => ({
                  ...prev,
                  amount: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Rate (% p.m.){" "}
              <Tooltip title={MONEY_LENDER_RATE_TOOLTIP}>
                <QuestionCircleOutlined
                  style={{ color: "#8c8c8c", cursor: "help" }}
                />
              </Tooltip>
            </div>
            <InputNumber
              style={{ width: "100%" }}
              value={personalOfferForm.rate_pa}
              min={MONEY_LENDER_INTEREST_RATE_PM}
              max={MONEY_LENDER_INTEREST_RATE_PM}
              precision={2}
              disabled
            />
          </div>
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Tenor (months)
            </div>
            <InputNumber
              style={{ width: "100%" }}
              value={personalOfferForm.tenor_months}
              min={1}
              max={120}
              step={1}
              onChange={(value) =>
                setPersonalOfferForm((prev) => ({
                  ...prev,
                  tenor_months: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Request additional documents (optional)
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {personalOfferDocuments.map((doc, index) => (
                <div
                  key={`personal-doc-${index}`}
                  style={{ display: "flex", gap: 8 }}
                >
                  <Input
                    placeholder="Document name"
                    value={doc}
                    onChange={(event) =>
                      handlePersonalDocumentChange(event.target.value, index)
                    }
                  />
                  {personalOfferDocuments.length > 1 && (
                    <Button
                      type="text"
                      icon={<MinusOutlined />}
                      onClick={() => removePersonalDocument(index)}
                    />
                  )}
                  {index === personalOfferDocuments.length - 1 && (
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addPersonalDocument}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="sl-loan-modal-field full">
          <Input.TextArea
            rows={3}
            placeholder="Optional message to the borrower"
            value={personalOfferMessage}
            onChange={(event) => setPersonalOfferMessage(event.target.value)}
          />
          </div>
            </div>
          </div>
          <div className="sl-loan-modal-panel sl-loan-modal-summary">
            <h3>Request snapshot</h3>
            <div className="sl-loan-modal-summary-item">
              <span>Requested amount</span>
              <strong>{formatPersonalAmount(personalOfferModal.loan?.amount)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred rate</span>
              <strong>{formatPersonalRate(MONEY_LENDER_INTEREST_RATE_PM)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred tenor</span>
              <strong>{formatPersonalTenor(personalOfferModal.loan?.desired_tenor_months)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>
                Processing fee{" "}
                <Tooltip title={MONEY_LENDER_PROCESSING_FEE_TOOLTIP}>
                  <QuestionCircleOutlined
                    style={{ color: "#8c8c8c", cursor: "help" }}
                  />
                </Tooltip>
              </span>
              <strong>{PERSONAL_LOAN_PROCESSING_FEE_LABEL}</strong>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        className="sl-loan-action-modal sl-personal-loan-modal"
        open={personalRejectionModal.open}
        onCancel={closePersonalRejectionModal}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
              gap: 8,
            }}
          >
            <Button
              type="primary"
              loading={personalRejectionBusy}
              onClick={submitPersonalRejection}
            >
              Submit rejection
            </Button>
            <Button type="default" onClick={closePersonalRejectionModal}>
              Cancel
            </Button>
          </div>,
        ]}
      >
        <div className="sl-loan-modal-head">
          <div className="sl-loan-modal-title">
            <div className="sl-loan-modal-mark pink">
              {getInitials(personalRejectBorrower).slice(0, 2)}
            </div>
            <div>
              <h2>Reject request</h2>
              <p>Record why {personalRejectBorrower} is not suitable right now.</p>
            </div>
          </div>
        </div>
        <div className="sl-loan-modal-grid">
          <div className="sl-loan-modal-panel">
            <h3>Reason</h3>
            <div className="sl-loan-modal-fields">
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Reason</div>
            <Select
              style={{ width: "100%" }}
              value={personalRejectionForm.reason}
              onChange={(value) =>
                setPersonalRejectionForm((prev) => ({
                  ...prev,
                  reason: value,
                }))
              }
              options={personalRejectionOptions.map((option) => ({
                value: option,
                label: option.replace(/_/g, " "),
              }))}
            />
          </div>
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Notes</div>
            <Input.TextArea
              rows={3}
              value={personalRejectionForm.notes}
              onChange={(event) =>
                setPersonalRejectionForm((prev) => ({
                  ...prev,
                  notes: event.target.value,
                }))
              }
            />
          </div>
            </div>
          </div>
          <div className="sl-loan-modal-panel sl-loan-modal-summary">
            <h3>Request snapshot</h3>
            <div className="sl-loan-modal-summary-item">
              <span>Requested amount</span>
              <strong>{formatPersonalAmount(personalRejectionModal.loan?.amount)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Product</span>
              <strong>Money Lender Loan</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Applied</span>
              <strong>{formatDate(personalRejectionModal.loan?.created_at)}</strong>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        className="sl-loan-action-modal"
        open={propertyOfferModal.open}
        onCancel={closePropertyOfferModal}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
              gap: 8,
            }}
          >
            <Button
              type="primary"
              loading={propertyOfferBusy}
              onClick={submitPropertyOffer}
            >
              Submit offer
            </Button>
            <Button type="default" onClick={closePropertyOfferModal}>
              Cancel
            </Button>
          </div>,
        ]}
      >
        <div className="sl-loan-modal-head">
          <div className="sl-loan-modal-title">
            <div className="sl-loan-modal-mark green">
              {getInitials(propertyOfferBorrower).slice(0, 2)}
            </div>
            <div>
              <h2>Property Term Loan Offer</h2>
              <p>Build a firm offer for {propertyOfferBorrower}.</p>
            </div>
          </div>
        </div>
        <div className="sl-loan-modal-grid">
          <div className="sl-loan-modal-panel">
            <h3>Offer terms</h3>
            <div className="sl-loan-modal-fields">
          {renderSupportLenderSelect("property")}
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Offer amount</div>
            <InputNumber
              style={{ width: "100%" }}
              value={propertyOfferForm.amount}
              min={1000}
              formatter={(value) =>
                `S$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/S\$\s?|(,*)/g, "")}
              onChange={(value) =>
                setPropertyOfferForm((prev) => ({
                  ...prev,
                  amount: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Rate (% p.a.)
            </div>
            <InputNumber
              style={{ width: "100%" }}
              value={propertyOfferForm.rate_pa}
              min={0}
              max={100}
              onChange={(value) =>
                setPropertyOfferForm((prev) => ({
                  ...prev,
                  rate_pa: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Tenor (years)
            </div>
            <InputNumber
              style={{ width: "100%" }}
              value={propertyOfferForm.tenor_years}
              min={0.25}
              max={30}
              step={0.25}
              onChange={(value) =>
                setPropertyOfferForm((prev) => ({
                  ...prev,
                  tenor_years: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Request additional documents (optional)
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {propertyOfferDocuments.map((doc, index) => (
                <div
                  key={`property-doc-${index}`}
                  style={{ display: "flex", gap: 8 }}
                >
                  <Input
                    placeholder="Document name"
                    value={doc}
                    onChange={(event) =>
                      handlePropertyDocumentChange(event.target.value, index)
                    }
                  />
                  {propertyOfferDocuments.length > 1 && (
                    <Button
                      type="text"
                      icon={<MinusOutlined />}
                      onClick={() => removePropertyDocument(index)}
                    />
                  )}
                  {index === propertyOfferDocuments.length - 1 && (
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addPropertyDocument}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="sl-loan-modal-field full">
          <Input.TextArea
            rows={3}
            placeholder="Optional message to the borrower"
            value={propertyOfferMessage}
            onChange={(event) => setPropertyOfferMessage(event.target.value)}
          />
          </div>
            </div>
          </div>
          <div className="sl-loan-modal-panel sl-loan-modal-summary">
            <h3>Request snapshot</h3>
            <div className="sl-loan-modal-summary-item">
              <span>Requested amount</span>
              <strong>{formatPersonalAmount(normalizePropertyLoanData(propertyOfferModal.loan)?.loanAmount)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred rate</span>
              <strong>{getPropertyLoanInterestRange(normalizePropertyLoanData(propertyOfferModal.loan))}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred tenor</span>
              <strong>{formatPersonalTenor(getPropertyLoanTenorMonths(normalizePropertyLoanData(propertyOfferModal.loan)))}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Processing fee</span>
              <strong>{PROPERTY_LOAN_PROCESSING_FEE_LABEL}</strong>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        className="sl-loan-action-modal"
        open={propertyRejectionModal.open}
        onCancel={closePropertyRejectionModal}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
              gap: 8,
            }}
          >
            <Button
              type="primary"
              loading={propertyRejectionBusy}
              onClick={submitPropertyRejection}
            >
              Submit rejection
            </Button>
            <Button type="default" onClick={closePropertyRejectionModal}>
              Cancel
            </Button>
          </div>,
        ]}
      >
        <div className="sl-loan-modal-head">
          <div className="sl-loan-modal-title">
            <div className="sl-loan-modal-mark green">
              {getInitials(propertyRejectBorrower).slice(0, 2)}
            </div>
            <div>
              <h2>Reject request</h2>
              <p>Record why {propertyRejectBorrower} is not suitable right now.</p>
            </div>
          </div>
        </div>
        <div className="sl-loan-modal-grid">
          <div className="sl-loan-modal-panel">
            <h3>Reason</h3>
            <div className="sl-loan-modal-fields">
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Reason</div>
            <Select
              style={{ width: "100%" }}
              placeholder="Select a reason"
              value={propertyRejectionForm.reason}
              onChange={(value) =>
                setPropertyRejectionForm((prev) => ({
                  ...prev,
                  reason: value,
                }))
              }
              options={propertyRejectionOptions.map((option) => ({
                value: option,
                label: option.replace(/_/g, " "),
              }))}
            />
          </div>
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Notes (optional)
            </div>
            <Input.TextArea
              rows={3}
              placeholder="Add more context"
              value={propertyRejectionForm.notes}
              onChange={(event) =>
                setPropertyRejectionForm((prev) => ({
                  ...prev,
                  notes: event.target.value,
                }))
              }
            />
          </div>
            </div>
          </div>
          <div className="sl-loan-modal-panel sl-loan-modal-summary">
            <h3>Request snapshot</h3>
            <div className="sl-loan-modal-summary-item">
              <span>Requested amount</span>
              <strong>{formatPersonalAmount(normalizePropertyLoanData(propertyRejectionModal.loan)?.loanAmount)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Product</span>
              <strong>{getPropertyLoanTypeLabel(normalizePropertyLoanData(propertyRejectionModal.loan))}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Applied</span>
              <strong>{formatDate(propertyRejectionModal.loan?.created_at)}</strong>
            </div>
          </div>
        </div>
      </Modal>
      <Box
        className="sl-loan-request-page"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="140px"
        gap="20px"
        borderRadius="10px"
      >
        <Box
          className="sl-loan-request-main"
          gridColumn={screenWidth > 1200 ? "span 10" : "span 12"}
          gridRow="span 2"
          borderRadius="10px"
          opacity="0.95"
          paddingBottom="100px"
          style={{
            overflowY: "scroll",
            height: isMobile ? "80vh" : "90vh",
            overflowX: "hidden",
            background:
              "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
            padding: "15px",
          }}
          // margin="20px 20px 20px 20px"
        >
          <Modal
            className="sl-loan-action-modal"
            footer={[
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 16,
                }}
              >
                <Button
                  type="primary"
                  onClick={() =>
                    handleRequestMoreDocument(
                      loanId,
                      express,
                      user_id,
                      principal_name
                    )
                  }
                >
                  Submit
                </Button>
                <Button type="default" onClick={handleCancel}>
                  Cancel
                </Button>
              </div>,
            ]}
            open={isModalOpen}
            // onOk={handleOk}
            onCancel={handleCancel}
          >
            {" "}
            <div
              style={{
                color: "rgba(0,0,0,0.5)",
                fontWeight: "700",
                marginTop: "10px",
              }}
            >
              Please Insert The Document Name
            </div>
            <div>
              {documentDescriptions.map((description, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    width: "90%",
                    marginTop: "15px",
                  }}
                >
                  <div style={{ width: "30%" }}>
                    <div
                      style={{
                        color: "rgba(0,0,0,0.5)",
                        fontWeight: "700",
                        marginTop: "10px",
                      }}
                    >
                      Document Name
                    </div>
                  </div>
                  <div style={{ width: "60%" }}>
                    <div>
                      <input
                        style={{
                          width: "90%",
                          padding: "8px",
                          borderRadius: "12px",
                          marginTop: "5px",
                          outline: "none",
                          border: "1px solid rgba(0,0,0,0.2)",
                        }}
                        value={description}
                        placeholder="Document Name"
                        onChange={(event) => handleChange(event, index)}
                      />
                    </div>
                  </div>
                  {documentDescriptions.length > 1 && (
                    <div style={{ width: "10%", textAlign: "right" }}>
                      <Button
                        type="default"
                        onClick={() => remove(index)}
                        style={{
                          backgroundColor: "none",
                          border: "none",
                          color: "#FF0000",
                          boxShadow: "none",
                          marginTop: "10px",
                        }}
                        icon={<MinusOutlined />}
                      >
                        Remove
                      </Button>
                    </div>
                  )}
                </div>
              ))}
              <div>
                <Button
                  type="default"
                  onClick={addMore}
                  style={{
                    backgroundColor: "none",
                    border: "none",
                    color: "#0E5AA5",
                    marginLeft: "25%",
                    boxShadow: "none",
                    marginTop: "5px",
                  }}
                  icon={<PlusOutlined style={{ marginTop: "-10px" }} />}
                >
                  Add more
                </Button>
              </div>
            </div>
          </Modal>
          <Box
            className="sl-loan-request-head"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            borderRadius="10px"
            style={{ marginBottom: "10px" }}
          >
            <Typography
              color={colors.grey[920]}
              variant="h5"
              fontWeight="800"
              fontFamily="Manrope, sans-serif"
              fontSize="18px"
            >
              Requested Loans
            </Typography>
            <div className="sl-loan-type-filter" aria-label="Loan type filter">
              {[
                ["all", "All", "#0F172A"],
                ["corporate", "Corporate", "#2F80ED"],
                ["personal", "Personal", "#EC4899"],
                ["concierge", "Concierge", "#A855F7"],
              ].map(([value, label, color]) => (
                <button
                  key={value}
                  type="button"
                  className={activeLoanTypeFilter === value ? "is-active" : ""}
                  onClick={() => setActiveLoanTypeFilter(value)}
                >
                  {value !== "all" ? (
                    <span className="dot" style={{ background: color }} />
                  ) : null}
                  {label}
                  <span className="count">{loanTypeCounts[value]}</span>
                </button>
              ))}
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label
                  htmlFor="sort-by"
                  style={{
                    marginRight: "7px",
                    marginLeft: "10px",
                    color: "#142C44CC",
                    fontWeight: "800",
                    fontSize: "13px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Sort by:
                </label>
                <div style={{ width: "63%" }}>
                  <select
                    id="sort-by"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    style={{
                      width: "100%",
                      borderRadius: "30px",
                      color: "#0E5AA5",
                      backgroundColor: "#ECF0F5",
                      border: "1px solid #3E536733",
                      fontWeight: "600",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "13px",
                    }}
                  >
                    <option value="latest-request">Latest Request</option>
                    <option value="default">Recommend</option>
                  </select>
                </div>
              </div>
            </div>
          </Box>
          <Box gridColumn="span 4">
            <div
              className="sl-loan-grid-list"
              style={{
                alignItems: "flex-start",
                color: "grey",
                width: "100%",
              }}
            >
              {restrictedLoanAccess ? (
                renderRestrictedLoanAccess()
              ) : loanCardEntries.length > 0 ? (
                loanCardEntries.map(renderLoanCardEntry)
              ) : (
                <div
                  style={{
                    width: "100%",
                    padding: "0px 0px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      padding: "0px 15px",
                      background: "rgba(255,255,255,0.7)",
                      borderRadius: "10px",
                      height: "150px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontFamily: "Manrope, sans-serif",
                      fontSize: "0.8em",
                      fontWeight: "600",
                      color: "#00000066",
                    }}
                  >
                    No results found
                  </div>
                </div>
              )}
              {filteredData && filteredData.length > 0
                ? filteredData.map((item, index) => (
                    <Modal
                      className="sl-loan-action-modal"
                      style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
                      open={modalStates[item.loan_id]}
                      onCancel={() => {
                        if (item.loan_id) {
                          setModalStates((prevStates) => ({
                            ...prevStates,
                            [item.loan_id]: false,
                          }));
                        }
                        setSelectedSupportLenderId("");
                      }}
                      footer={[
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            marginTop: 25,
                          }}
                        >
                          {offer_amount.length > 0 &&
                            offer_interest_rate.length > 0 &&
                            offer_period.length > 0 &&
                            type.length > 0 && (
                              <div>
                                <Button
                                  className="sl-highlight-primary-button"
                                  type="primary"
                                  onClick={() =>
                                    setMakeOfferData({
                                      loan_id: item.loan_id,
                                      express: item.express,
                                      user_id: item.user_id,
                                      principal_name: item.principal_name,
                                      created_at: item.created_at,
                                      loan_repayment_tenor: loanRepaymentTenor,
                                    })
                                  }
                                >
                                  Make Offer
                                </Button>
                                <Button
                                  type="default"
                                  style={{ marginLeft: "10px" }}
                                  onClick={() =>
                                    showModalRequestDocument(
                                      item.loan_id,
                                      item.express,
                                      item.user_id,
                                      item.principal_name,
                                      item.created_at
                                    )
                                  }
                                >
                                  Request More Document
                                </Button>
                              </div>
                            )}
                        </div>,
                      ]}
                    >
                      {renderCorporateOfferModalBody(item)}
                    </Modal>
                  ))
                : data &&
                  data.length > 0 &&
                  empty == "0" &&
                  data
                    .sort((a, b) => {
                      if (
                        notInterestedIds.includes(a.loan_id) &&
                        !notInterestedIds.includes(b.loan_id)
                      ) {
                        return 1;
                      }
                      if (
                        !notInterestedIds.includes(a.loan_id) &&
                        notInterestedIds.includes(b.loan_id)
                      ) {
                        return -1;
                      }
                      // If express 1 must be top compare to express 0
                      if (a.express !== b.express) {
                        return b.express - a.express;
                      }
                      // Sorting based on the selection at the sort by option
                      if (sortBy === "default") {
                        // if user select the option recommend, then sort the data based on the request_amount from high to low
                        return b.request_amount - a.request_amount;
                      } else if (sortBy === "latest-request") {
                        // if user select option latest request, sort the data by latest created_at to the not latest created_at
                        return new Date(b.created_at) - new Date(a.created_at);
                      }
                      return 0;
                    })
                    .map((item, index) => (
                      <Modal
                        className="sl-loan-action-modal"
                        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
                        open={modalStates[item.loan_id]}
                        onCancel={() => {
                          setSelectedSupportLenderId("");
                          setModalStates((prevStates) => ({
                            ...prevStates,
                            [item.loan_id]: false,
                          }));
                        }}
                        footer={[
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: 16,
                            }}
                          >
                            {offer_amount.length > 0 &&
                              offer_interest_rate.length > 0 &&
                              offer_period.length > 0 &&
                              type.length > 0 && (
                                <div>
                                  <Button
                                    className="sl-highlight-primary-button"
                                    type="primary"
                                    onClick={() =>
                                      setMakeOfferData({
                                        loan_id: item.loan_id,
                                        express: item.express,
                                        user_id: item.user_id,
                                        principal_name: item.principal_name,
                                        created_at: item.created_at,
                                        loan_repayment_tenor:
                                          loanRepaymentTenor,
                                      })
                                    }
                                  >
                                    Make Offer
                                  </Button>
                                  <Button
                                    type="default"
                                    style={{ marginLeft: "10px" }}
                                    onClick={() =>
                                      showModalRequestDocument(
                                        item.loan_id,
                                        item.express,
                                        item.user_id,
                                        item.principal_name,
                                        item.created_at
                                      )
                                    }
                                  >
                                    Request More Document
                                  </Button>
                                </div>
                              )}
                          </div>,
                        ]}
                      >
                        {renderCorporateOfferModalBody(item, {
                          interestLabel: "Interest Rate (Month)",
                          interestMax: 100,
                          processingMax: 100,
                          showRepaymentTenor: false,
                          revenueLabel: "Guaranteed revenue",
                          includeProcessingInRevenue: true,
                        })}
                      </Modal>
                    ))}
              {data &&
                data.length > 0 &&
                data.map((item, index) => (
                  <Modal
                    className="sl-loan-action-modal"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
                    open={modalStates2[item.loan_id]}
                    onCancel={() =>
                      setModalStates2((prevStates) => ({
                        ...prevStates,
                        [item.loan_id]: false,
                      }))
                    }
                    footer={[
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: 16,
                        }}
                      >
                        <Button
                          className="sl-highlight-primary-button"
                          type="primary"
                          onClick={() =>
                            handleNotInterested(item.loan_id, selectedValue)
                          }
                        >
                          Submit
                        </Button>
                        <Button
                          type="default"
                          onClick={() =>
                            setModalStates2((prevStates) => ({
                              ...prevStates,
                              [item.loan_id]: false,
                            }))
                          }
                        >
                          Cancel
                        </Button>
                      </div>,
                    ]}
                  >
                    {renderCorporateNotInterestedModalBody(item)}
                  </Modal>
                ))}
            </div>
          </Box>
        </Box>
        <details className="sl-marketplace-filters" open={!isMobile}>
          <summary>Search filters</summary>
          <Box
            className="sl-loan-filter-panel"
            gridColumn="span 2"
            opacity="1.00"
            display="flex"
            style={{
              height: "90vh",
              padding: "15px",
              background:
                "transparent linear-gradient(0deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
            }}
          >
            <div
              className="step2s"
              style={{
                border: "none",
                margin: "0px",
                padding: "0px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <FilterAltIcon
                  style={{ color: "#142C44CC", marginRight: "5px" }}
                />
                <h4
                  style={{
                    color: "#142C44CC",
                    fontWeight: "800",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "18px",
                    margin: "0px",
                  }}
                >
                  Search Filter
                </h4>
              </div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  Loan Amount
                </h5>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0,0,0,0.4)",
                  margin: "5px 0px 0px 0px",
                }}
              >
                <input
                  type="number"
                  placeholder="MIN"
                  value={minLoanAmount}
                  onChange={(e) => setMinLoanAmount(e.target.value)}
                  style={{
                    border: "none",
                    outline: "1px solid lightgrey",
                    borderRadius: "5px",
                    textAlign: "center",
                    margin: "0px 10px 0px 0px",
                    width: "40%",
                  }}
                />
                -
                <input
                  type="number"
                  placeholder="MAX"
                  value={maxLoanAmount}
                  onChange={(e) => setMaxLoanAmount(e.target.value)}
                  style={{
                    border: "none",
                    outline: "1px solid lightgrey",
                    borderRadius: "5px",
                    textAlign: "center",
                    margin: "0px 0px 0px 10px",
                    width: "40%",
                  }}
                />
              </div>
              <div style={{ margin: "10px 0px 20px 0px" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    id="checkbox1"
                    checked={selectedCheckbox === "checkbox1"}
                    onChange={() =>
                      handleLoanAmountCheckbox("checkbox1", 0, 10000)
                    }
                    style={{ margin: "0px 10px 0px 0px" }}
                  />
                  <label
                    for="checkbox1"
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                    }}
                  >
                    $0 - $10,000
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    id="checkbox2"
                    checked={selectedCheckbox === "checkbox2"}
                    onChange={() =>
                      handleLoanAmountCheckbox("checkbox2", 10001, 50000)
                    }
                    style={{ margin: "0px 10px 0px 0px" }}
                  />
                  <label
                    htmlFor="checkbox2"
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                    }}
                  >
                    $10,001 - $50,000
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    id="checkbox3"
                    checked={selectedCheckbox === "checkbox3"}
                    onChange={() =>
                      handleLoanAmountCheckbox("checkbox3", 50001, 10000000)
                    }
                    style={{ margin: "0px 10px 0px 0px" }}
                  />
                  <label
                    htmlFor="checkbox3"
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                    }}
                  >
                    {">$50,000"}
                  </label>
                </div>
              </div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  Expected Interest Rate
                </h5>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0,0,0,0.4)",
                  margin: "5px 0px 0px 0px",
                }}
              >
                <input
                  type="number"
                  placeholder="MIN"
                  value={LoanInterestMin}
                  onChange={(e) => setLoanInterestMin(e.target.value)}
                  style={{
                    border: "none",
                    outline: "1px solid lightgrey",
                    borderRadius: "5px",
                    textAlign: "center",
                    margin: "0px 10px 0px 0px",
                    width: "40%",
                  }}
                />
                -
                <input
                  type="number"
                  placeholder="MAX"
                  value={LoanInterestMax}
                  onChange={(e) => setLoanInterestMax(e.target.value)}
                  style={{
                    border: "none",
                    outline: "1px solid lightgrey",
                    borderRadius: "5px",
                    textAlign: "center",
                    margin: "0px 0px 0px 10px",
                    width: "40%",
                  }}
                />
              </div>
              <div style={{ margin: "10px 0px 20px 0px" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    id="checkbox10"
                    checked={selectedCheckbox2 === "checkbox10"}
                    onChange={() =>
                      handleLoanInterestCheckbox("checkbox10", 1, 2)
                    }
                    style={{ margin: "0px 10px 0px 0px" }}
                  />
                  <label
                    for="checkbox10"
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                    }}
                  >
                    1% - 2%
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    id="checkbox11"
                    checked={selectedCheckbox2 === "checkbox11"}
                    onChange={() =>
                      handleLoanInterestCheckbox("checkbox11", 2.1, 5)
                    }
                    style={{ margin: "0px 10px 0px 0px" }}
                  />
                  <label
                    for="checkbox11"
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                    }}
                  >
                    2.1% - 5%
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    id="checkbox12"
                    checked={selectedCheckbox2 === "checkbox12"}
                    onChange={() =>
                      handleLoanInterestCheckbox("checkbox12", 5.01, 100)
                    }
                    style={{ margin: "0px 10px 0px 0px" }}
                  />
                  <label
                    for="checkbox12"
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                    }}
                  >
                    {">5%"}
                  </label>
                </div>
              </div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  Loan Period
                </h5>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0,0,0,0.4)",
                  margin: "5px 0px 0px 0px",
                }}
              >
                <input
                  type="number"
                  placeholder="MIN"
                  value={LoanPeriodMin}
                  onChange={(e) => setLoanPeriodMin(e.target.value)}
                  style={{
                    border: "none",
                    outline: "1px solid lightgrey",
                    borderRadius: "5px",
                    textAlign: "center",
                    margin: "0px 10px 0px 0px",
                    width: "40%",
                  }}
                />
                -
                <input
                  type="number"
                  placeholder="MAX"
                  value={LoanPeriodMax}
                  onChange={(e) => setLoanPeriodMax(e.target.value)}
                  style={{
                    border: "none",
                    outline: "1px solid lightgrey",
                    borderRadius: "5px",
                    textAlign: "center",
                    margin: "0px 0px 0px 10px",
                    width: "40%",
                  }}
                />
              </div>
              <div style={{ margin: "10px 0px 20px 0px" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    id="checkbox5"
                    checked={selectedCheckbox1 === "checkbox5"}
                    onChange={() => handleLoanPeriodCheckbox("checkbox5", 0, 6)}
                    style={{ margin: "0px 10px 0px 0px" }}
                  />
                  <label
                    for="checkbox5"
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                    }}
                  >
                    0 - 6 Months
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    id="checkbox6"
                    checked={selectedCheckbox1 === "checkbox6"}
                    onChange={() =>
                      handleLoanPeriodCheckbox("checkbox6", 7, 12)
                    }
                    style={{ margin: "0px 10px 0px 0px" }}
                  />
                  <label
                    for="checkbox6"
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                    }}
                  >
                    7 - 12 Months
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    id="checkbox7"
                    checked={selectedCheckbox1 === "checkbox7"}
                    onChange={() =>
                      handleLoanPeriodCheckbox("checkbox7", 13, 60)
                    }
                    style={{ margin: "0px 10px 0px 0px" }}
                  />
                  <label
                    for="checkbox7"
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.4)",
                      textAlign: "left",
                    }}
                  >
                    {">12 Months"}
                  </label>
                </div>
              </div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  Years of Incorporation
                </h5>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0,0,0,0.4)",
                  margin: "5px 0px 0px 0px",
                }}
              >
                <select
                  value={MinYearOfIncorp}
                  onChange={(e) => setMinYearOfIncorp(e.target.value)}
                  style={{
                    border: "none",
                    outline: "1px solid lightgrey",
                    borderRadius: "5px",
                    textAlign: "center",
                    margin: "0px 10px 0px 0px",
                    width: "90%",
                  }}
                >
                  <option value="">Select range</option>
                  <option value="0">Less than 1 year</option>
                  <option value="2">2 years and above</option>
                  <option value="5">5 years and above</option>
                </select>
              </div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  Guarantor
                </h5>
              </div>
              <div className="sl-filter-seg">
                <button
                  type="button"
                  className={loanGuarantorFilter === "single" ? "is-active" : ""}
                  onClick={() => setLoanGuarantorFilter("single")}
                >
                  Single guarantor
                </button>
                <button
                  type="button"
                  className={loanGuarantorFilter === "multiple" ? "is-active" : ""}
                  onClick={() => setLoanGuarantorFilter("multiple")}
                >
                  More than 1
                </button>
              </div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  Private property
                </h5>
              </div>
              <div className="sl-filter-seg">
                <button
                  type="button"
                  className={loanPrivatePropertyFilter === "yes" ? "is-active" : ""}
                  onClick={() => setLoanPrivatePropertyFilter("yes")}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className={loanPrivatePropertyFilter === "no" ? "is-active" : ""}
                  onClick={() => setLoanPrivatePropertyFilter("no")}
                >
                  No
                </button>
              </div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  DSR <span className="sl-filter-note">Subscribed only</span>
                </h5>
              </div>
              <div className="sl-slider-row">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={loanDsrFilter}
                  onChange={(e) => setLoanDsrFilter(e.target.value)}
                />
                <div className="sl-slider-value">{loanDsrFilter}%</div>
              </div>
              <div className="sl-risk-band sl-risk-good">Very healthy</div>
              <div className="sl-filter-legend">
                &lt;30% healthy · 30-50% acceptable · 50-70% higher risk ·
                70%+ overleveraged
              </div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  Avg end-month balance
                </h5>
              </div>
              <div className="sl-slider-row">
                <input
                  type="range"
                  min="0"
                  max="500000"
                  step="1000"
                  value={loanAembFilter}
                  onChange={(e) => setLoanAembFilter(e.target.value)}
                />
                <div className="sl-slider-value">
                  ${Number(loanAembFilter).toLocaleString("en-US")}
                </div>
              </div>
              <div className="sl-risk-band sl-risk-ok">Moderate</div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  BTI ratio
                </h5>
              </div>
              <div className="sl-slider-row">
                <input
                  type="range"
                  min="0"
                  max="10"
                  step="0.1"
                  value={loanBtiFilter}
                  onChange={(e) => setLoanBtiFilter(e.target.value)}
                />
                <div className="sl-slider-value">
                  {Number(loanBtiFilter).toFixed(1)}x
                </div>
              </div>
              <div className="sl-risk-band sl-risk-good">Healthy</div>
              <div className="title-loan-request">
                <h5
                  style={{
                    color: "#142C44CC",
                    fontWeight: "700",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  Preferred Keyman Credit Bureau Rating
                </h5>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0,0,0,0.4)",
                  margin: "5px 0px 0px 0px",
                }}
              >
                <select
                  value={selectedCreditRating}
                  onChange={(e) => {
                    setSelectedCreditRating(e.target.value);
                  }}
                  style={{
                    border: "none",
                    outline: "1px solid lightgrey",
                    borderRadius: "5px",
                    textAlign: "center",
                    margin: "0px 10px 0px 0px",
                    width: "90%",
                  }}
                >
                  <option value="">None selected</option>
                  {possiblecreditrating.map((cr, index) => (
                    <option value={cr.value} key={index}>
                      {cr.value}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ marginTop: "15px" }}>
                <button
                  className="step3s"
                  style={{
                    background: "rgb(14, 90, 165)",
                    borderRadius: "30px",
                    padding: "7px 35px",
                    border: "none",
                    color: "white",
                    fontWeight: 600,
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    setMinLoanAmount("");
                    setMaxLoanAmount("");
                    setLoanInterestMin("");
                    setLoanInterestMax("");
                    setLoanPeriodMin("");
                    setLoanPeriodMax("");
                    setMinYearOfIncorp("");
                    setSelectedIndustry("");
                    setSelectedCreditRating("");
                    setSelectedCheckbox(null);
                    setSelectedCheckbox1(null);
                    setSelectedCheckbox2(null);
                    setLoanGuarantorFilter("single");
                    setLoanPrivatePropertyFilter("yes");
                    setLoanDsrFilter(25);
                    setLoanAembFilter(50000);
                    setLoanBtiFilter(2);
                  }}
                >
                  Reset filter
                </button>
              </div>
            </div>
          </Box>
        </details>
      </Box>
      <Tour
        steps={tourSteps}
        style={{ color: "black" }}
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)}
      />
      <Modal
        className="sl-loan-action-modal"
        zIndex={2000} // Higher than default (default is 1000)
        open={makeOfferData !== null}
        onCancel={() => {
          if (makeOfferData.loan_id) {
            setModalStates((prevStates) => ({
              ...prevStates,
              [makeOfferData.loan_id]: false,
            }));
          }
          setSelectedSupportLenderId("");
          setMakeOfferData(null);
        }}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                handleMakeOffer(
                  makeOfferData.loan_id,
                  makeOfferData.express,
                  makeOfferData.user_id,
                  makeOfferData.principal_name,
                  makeOfferData.created_at
                );
              }}
            >
              Proceed
            </Button>
            <Button
              type="default"
              onClick={() => {
                if (makeOfferData.loan_id) {
                  setModalStates((prevStates) => ({
                    ...prevStates,
                    [makeOfferData.loan_id]: false,
                  }));
                }
                setSelectedSupportLenderId("");
                setMakeOfferData(null);
              }}
            >
              Cancel
            </Button>
          </div>,
        ]}
      >
        <div>
          <div
            style={{
              color: "rgba(20, 44, 68, 0.8)",
              fontWeight: 700,
              fontSize: 20,
            }}
          >
            Loan offer confirmation
          </div>
          <div>
            Please confirm whether this is a firm offer. Should you require
            further documentation (e.g., MLCB) or a site inspection, contact the
            borrower directly via [Message Borrower].
          </div>
        </div>
      </Modal>
    </Box>
  );
};

export default LoanRequestGrid;
